//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AccessSchedulesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get single access schedule for a device group
     * @param id Device group identifier
     * @return Returns an access schedule for a device group
     */
    getAccessSchedule(id: string, version: string, cancelToken?: CancelToken): Promise<AccessScheduleDto> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessSchedule(_response);
        });
    }

    protected processGetAccessSchedule(response: AxiosResponse): Promise<AccessScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessScheduleDto.fromJS(resultData200);
            return Promise.resolve<AccessScheduleDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessScheduleDto>(null as any);
    }

    /**
     * Modify a single access schedule for a device group
     * @param id Device group identifier
     */
    modify(id: string, version: string, dto: ModifyAccessScheduleDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a page of usergroups for a device, with optional search term applied and includes usergroups selected and total selected
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Returns an array of user groups
     */
    getAccessScheduleUserGroupsByDevice(deviceId: string, pageOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<AccessScheduleUserGroupListSelectDto> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/{deviceId}/usergroups?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessScheduleUserGroupsByDevice(_response);
        });
    }

    protected processGetAccessScheduleUserGroupsByDevice(response: AxiosResponse): Promise<AccessScheduleUserGroupListSelectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessScheduleUserGroupListSelectDto.fromJS(resultData200);
            return Promise.resolve<AccessScheduleUserGroupListSelectDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessScheduleUserGroupListSelectDto>(null as any);
    }

    /**
     * Modify a list of access schedules for a site
     * @param deviceId Device identifier
     */
    modifyAccessScheduleByUserGroups(deviceId: string, version: string, dto: ModifyAccessScheduleByUserGroupDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/{deviceId}/usergroups";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyAccessScheduleByUserGroups(_response);
        });
    }

    protected processModifyAccessScheduleByUserGroups(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all access schedules for a site
     * @param siteId Site identifier
     * @return Returns an array of access schedule for a site
     */
    getAllAccessSchedulesForASite(siteId: string, version: string, cancelToken?: CancelToken): Promise<AccessScheduleDto[]> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/Site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccessSchedulesForASite(_response);
        });
    }

    protected processGetAllAccessSchedulesForASite(response: AxiosResponse): Promise<AccessScheduleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccessScheduleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessScheduleDto[]>(null as any);
    }

    /**
     * Modify a list of access schedules for a site
     * @param siteId Site identifier
     */
    modifyAllForSite(siteId: string, version: string, dtos: AccessScheduleDto[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/AccessSchedules/Site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyAllForSite(_response);
        });
    }

    protected processModifyAllForSite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ActivitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an activity
     * @return Returns the new activities Id
     */
    create(version: string, dto: CreateActivityDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Activities";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all activities
     * @return Returns a list of activities
     */
    getAllActivities(version: string, cancelToken?: CancelToken): Promise<ActivityDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Activities";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActivities(_response);
        });
    }

    protected processGetAllActivities(response: AxiosResponse): Promise<ActivityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityDto[]>(null as any);
    }

    /**
     * Get single activity
     * @param id Activity identifier
     * @return Returns a single area
     */
    getActivity(id: string, version: string, cancelToken?: CancelToken): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/{version}/Activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivity(_response);
        });
    }

    protected processGetActivity(response: AxiosResponse): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityDto.fromJS(resultData200);
            return Promise.resolve<ActivityDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityDto>(null as any);
    }

    /**
     * Modify an activity
     * @param id Activity identifier
     */
    modify(id: string, version: string, dto: ModifyActivityDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an activity
     * @param id Activity identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Import CSV
     * @param file (optional) 
     */
    importCsv(version: string, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<ApiResponseOfFileLoadDto> {
        let url_ = this.baseUrl + "/api/{version}/Activities/ImportCsv";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCsv(_response);
        });
    }

    protected processImportCsv(response: AxiosResponse): Promise<ApiResponseOfFileLoadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponseOfFileLoadDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseOfFileLoadDto>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = ApiResponse.fromJS(resultData204);
            return throwException("A server side error occurred.", status, _responseText, _headers, result204);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponseOfFileLoadDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfFileLoadDto>(null as any);
    }

    /**
     * Process a file from storage
     * @param fileName (optional) fileName
     * @param skipOffset (optional) Number of records in the range to skip before loading
     * @param pageSize (optional) Number of records to load
     */
    processFile(fileName: string | undefined, skipOffset: number | undefined, pageSize: number | undefined, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfFileLoadDto> {
        let url_ = this.baseUrl + "/api/{version}/Activities/ProcessFile?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessFile(_response);
        });
    }

    protected processProcessFile(response: AxiosResponse): Promise<ApiResponseOfFileLoadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfFileLoadDto.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfFileLoadDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfFileLoadDto>(null as any);
    }
}

export class ActivityClockingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Re-send activity clockings that are stored in the portal database back on to the service bus
     * @param startdateRange (optional) Start date and time of the range to send
     * @param endDateRange (optional) End date and time of the range to send
     * @param skipOffset (optional) Number of records in the range to skip before sending
     * @param pageSize (optional) Number of records to send
     * @return Re-send activity clockings that are stored in the portal database back on to the service bus
     */
    resendActivityClockings(startdateRange: Date | undefined, endDateRange: Date | undefined, skipOffset: number | undefined, pageSize: number | undefined, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfActivityClockingResendDto> {
        let url_ = this.baseUrl + "/api/{version}/ActivityClockings/Resend?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startdateRange === null)
            throw new Error("The parameter 'startdateRange' cannot be null.");
        else if (startdateRange !== undefined)
            url_ += "startdateRange=" + encodeURIComponent(startdateRange ? "" + startdateRange.toISOString() : "") + "&";
        if (endDateRange === null)
            throw new Error("The parameter 'endDateRange' cannot be null.");
        else if (endDateRange !== undefined)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendActivityClockings(_response);
        });
    }

    protected processResendActivityClockings(response: AxiosResponse): Promise<ApiResponseOfActivityClockingResendDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfActivityClockingResendDto.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfActivityClockingResendDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfActivityClockingResendDto>(null as any);
    }
}

export class AddressLookupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get an address
     * @param houseOrNumber (optional) 
     * @param postCode (optional) Identfiier
     * @return Returns best match addresses
     */
    getAddresses(houseOrNumber: string | null | undefined, postCode: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<AddressDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Addresses?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (houseOrNumber !== undefined && houseOrNumber !== null)
            url_ += "houseOrNumber=" + encodeURIComponent("" + houseOrNumber) + "&";
        if (postCode !== undefined && postCode !== null)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddresses(_response);
        });
    }

    protected processGetAddresses(response: AxiosResponse): Promise<AddressDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto[]>(null as any);
    }
}

export class AnonymousClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getGET(version: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/{version}/Anonymous";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGET(_response);
        });
    }

    protected processGetGET(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getHEAD(version: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/{version}/Anonymous";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHEAD(_response);
        });
    }

    protected processGetHEAD(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AreasClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an area for an existing site
     * @return Returns the new area's Id
     */
    create(version: string, dto: CreateAreaDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Areas";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all areas
     * @return Returns a list of areas
     */
    getAllAreas(version: string, cancelToken?: CancelToken): Promise<AreaDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Areas";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAreas(_response);
        });
    }

    protected processGetAllAreas(response: AxiosResponse): Promise<AreaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AreaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AreaDto[]>(null as any);
    }

    /**
     * Get single area
     * @param id Area identifier
     * @return Returns a single area
     */
    getArea(id: string, version: string, cancelToken?: CancelToken): Promise<AreaDto> {
        let url_ = this.baseUrl + "/api/{version}/Areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArea(_response);
        });
    }

    protected processGetArea(response: AxiosResponse): Promise<AreaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AreaDto.fromJS(resultData200);
            return Promise.resolve<AreaDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AreaDto>(null as any);
    }

    /**
     * Delete an area
     * @param id Area identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a area
     * @param id area identifier
     */
    modify(id: string, version: string, dto: ModifyAreaDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthorizedClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(version: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/{version}/Authorized";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BadgesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a badge
     * @return Returns the new badges's Id
     */
    create(version: string, dto: CreateBadgeDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Badges";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all badges
     * @return Returns an array of badge
     */
    getAllBadges(version: string, cancelToken?: CancelToken): Promise<BadgeDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Badges";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBadges(_response);
        });
    }

    protected processGetAllBadges(response: AxiosResponse): Promise<BadgeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BadgeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BadgeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeDto[]>(null as any);
    }

    /**
     * Get single badge
     * @param id badge identifier
     * @return Returns a single badge
     */
    getABadge(id: string, version: string, cancelToken?: CancelToken): Promise<BadgeDto> {
        let url_ = this.baseUrl + "/api/{version}/Badges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetABadge(_response);
        });
    }

    protected processGetABadge(response: AxiosResponse): Promise<BadgeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BadgeDto.fromJS(resultData200);
            return Promise.resolve<BadgeDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeDto>(null as any);
    }

    /**
     * Delete a badge
     * @param id Badge identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Badges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a Badge
     * @param id Badge identifier
     */
    modify(id: string, version: string, dto: ModifyBadgeDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Badges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ClockingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Re-send clockings that are stored in the portal database back on to the service bus
     * @param startdateRange (optional) Start date and time of the range to send
     * @param endDateRange (optional) End date and time of the range to send
     * @param skipOffset (optional) Number of records in the range to skip before sending
     * @param pageSize (optional) Number of records to send
     * @return Re-send clockings that are stored in the portal database back on to the service bus
     */
    resendClockings(startdateRange: Date | undefined, endDateRange: Date | undefined, skipOffset: number | undefined, pageSize: number | undefined, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfClockingResendDto> {
        let url_ = this.baseUrl + "/api/{version}/Clockings/Resend?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startdateRange === null)
            throw new Error("The parameter 'startdateRange' cannot be null.");
        else if (startdateRange !== undefined)
            url_ += "startdateRange=" + encodeURIComponent(startdateRange ? "" + startdateRange.toISOString() : "") + "&";
        if (endDateRange === null)
            throw new Error("The parameter 'endDateRange' cannot be null.");
        else if (endDateRange !== undefined)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendClockings(_response);
        });
    }

    protected processResendClockings(response: AxiosResponse): Promise<ApiResponseOfClockingResendDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfClockingResendDto.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfClockingResendDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfClockingResendDto>(null as any);
    }

    /**
     * Gets all clockings within range and optional search term
     * @param startdateRange (optional) 
     * @param endDateRange (optional) 
     * @param skipOffset (optional) Number of clockings in the range to skip before reading
     * @param pageSize (optional) Number of clockings to read
     * @param searchTerm (optional) Search term to apply to device name, user first name, user surname and transaction id
     * @return Get all clockings that are stored in the portal database
     */
    getAllClockings(startdateRange: Date | undefined, endDateRange: Date | undefined, skipOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfClockingPageDto> {
        let url_ = this.baseUrl + "/api/{version}/Clockings?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startdateRange === null)
            throw new Error("The parameter 'startdateRange' cannot be null.");
        else if (startdateRange !== undefined)
            url_ += "startdateRange=" + encodeURIComponent(startdateRange ? "" + startdateRange.toISOString() : "") + "&";
        if (endDateRange === null)
            throw new Error("The parameter 'endDateRange' cannot be null.");
        else if (endDateRange !== undefined)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClockings(_response);
        });
    }

    protected processGetAllClockings(response: AxiosResponse): Promise<ApiResponseOfClockingPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfClockingPageDto.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfClockingPageDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfClockingPageDto>(null as any);
    }

    /**
     * Gets all clockings within range and optional search term for a single user
     * @param startDateRange (optional) 
     * @param endDateRange (optional) 
     * @param skipOffset (optional) Number of clockings in the range to skip before reading
     * @param pageSize (optional) Number of clockings to read
     * @param searchTerm (optional) Search term to apply to device name, user first name, user surname and transaction id
     * @return Get all clockings for a given user that are stored in the portal database
     */
    getAllClockings2(userId: string, startDateRange: Date | undefined, endDateRange: Date | undefined, skipOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfClockingPageDto> {
        let url_ = this.baseUrl + "/api/{version}/Clockings/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startDateRange === null)
            throw new Error("The parameter 'startDateRange' cannot be null.");
        else if (startDateRange !== undefined)
            url_ += "startDateRange=" + encodeURIComponent(startDateRange ? "" + startDateRange.toISOString() : "") + "&";
        if (endDateRange === null)
            throw new Error("The parameter 'endDateRange' cannot be null.");
        else if (endDateRange !== undefined)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClockings2(_response);
        });
    }

    protected processGetAllClockings2(response: AxiosResponse): Promise<ApiResponseOfClockingPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfClockingPageDto.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfClockingPageDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfClockingPageDto>(null as any);
    }

    /**
     * Set the analysis action for a clocking.
     * @param id The ID of the clocking
     * @param dto The status to change it to
     */
    updateAnalysisAction(id: string, version: string, dto: ModifyClockingAnalysisActionDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Clockings/{id}/AnalysisAction";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnalysisAction(_response);
        });
    }

    protected processUpdateAnalysisAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Get all clockings for a given user that are stored in the portal database
     */
    getAnalysis(id: string, version: string, cancelToken?: CancelToken): Promise<AnalysisTestItemResultPageItemDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Clockings/{id}/analysis";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnalysis(_response);
        });
    }

    protected processGetAnalysis(response: AxiosResponse): Promise<AnalysisTestItemResultPageItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnalysisTestItemResultPageItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AnalysisTestItemResultPageItemDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisTestItemResultPageItemDto[]>(null as any);
    }
}

export class DeviceActivitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a page of activities assigned to a device
     * @param deviceId (optional) 
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Returns a page of activities assigned to a device
     */
    getDeviceActivitiesPage(deviceId: string | undefined, pageOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<ActivitiesListDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceActivities?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceActivitiesPage(_response);
        });
    }

    protected processGetDeviceActivitiesPage(response: AxiosResponse): Promise<ActivitiesListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivitiesListDto.fromJS(resultData200);
            return Promise.resolve<ActivitiesListDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivitiesListDto>(null as any);
    }

    /**
     * Modify the list of activities available on a device
     */
    modify(deviceId: string, version: string, dto: DeviceActivitiesDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/DeviceActivities/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceFirmwareClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the current state of a scheduled firmware upgrade for a device (if applicable)
     * @param id device identifier
     * @return Returns the current state of an upgrade for a device
     */
    getDeviceUpgradeState(id: string, version: string, cancelToken?: CancelToken): Promise<DeviceUpgradeStateDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceFirmware/{id}/DeviceUpgradeState";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceUpgradeState(_response);
        });
    }

    protected processGetDeviceUpgradeState(response: AxiosResponse): Promise<DeviceUpgradeStateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceUpgradeStateDto.fromJS(resultData200);
            return Promise.resolve<DeviceUpgradeStateDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceUpgradeStateDto>(null as any);
    }

    /**
     * Get all device firmware versions for a device
     * @return Returns an array of device firmware versions
     */
    getFirmwareVersions(deviceId: string, version: string, cancelToken?: CancelToken): Promise<DeviceFirmwareDto[]> {
        let url_ = this.baseUrl + "/api/{version}/DeviceFirmware/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirmwareVersions(_response);
        });
    }

    protected processGetFirmwareVersions(response: AxiosResponse): Promise<DeviceFirmwareDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceFirmwareDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceFirmwareDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceFirmwareDto[]>(null as any);
    }
}

export class DeviceGroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a device group for an existing area
     * @return Returns the new device group's Id
     */
    create(version: string, dto: CreateDeviceGroupDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/DeviceGroups";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all device groups
     * @return Returns a list of device groups
     */
    getAllDeviceGroups(version: string, cancelToken?: CancelToken): Promise<DeviceGroupDto[]> {
        let url_ = this.baseUrl + "/api/{version}/DeviceGroups";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDeviceGroups(_response);
        });
    }

    protected processGetAllDeviceGroups(response: AxiosResponse): Promise<DeviceGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceGroupDto[]>(null as any);
    }

    /**
     * Get single device group
     * @param id Device group identifier
     * @return Returns a single device group
     */
    getDeviceGroup(id: string, version: string, cancelToken?: CancelToken): Promise<DeviceGroupDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceGroup(_response);
        });
    }

    protected processGetDeviceGroup(response: AxiosResponse): Promise<DeviceGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceGroupDto.fromJS(resultData200);
            return Promise.resolve<DeviceGroupDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceGroupDto>(null as any);
    }

    /**
     * Delete a device group
     * @param id Device group identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/DeviceGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a device group
     * @param id Device group identifier
     */
    modify(id: string, version: string, dto: ModifyDeviceGroupDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/DeviceGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceHardwareClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the attached hardware devices for a given device Id
     * @return Returns the attached hardware devices for the given device id
     */
    getHardwareDevices(deviceId: string, version: string, cancelToken?: CancelToken): Promise<DeviceHardware[]> {
        let url_ = this.baseUrl + "/api/{version}/DeviceHardware/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHardwareDevices(_response);
        });
    }

    protected processGetHardwareDevices(response: AxiosResponse): Promise<DeviceHardware[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceHardware.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceHardware[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceHardware[]>(null as any);
    }
}

export class DeviceHeartbeatClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Read the latest heartbeat for a device
     * @return the latest heartbeat for a device
     */
    get(deviceId: string, version: string, cancelToken?: CancelToken): Promise<DeviceHeartbeatDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceHeartbeats/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DeviceHeartbeatDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceHeartbeatDto.fromJS(resultData200);
            return Promise.resolve<DeviceHeartbeatDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceHeartbeatDto>(null as any);
    }
}

export class DeviceLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param filter (optional) 
     * @param skipOffset (optional) 
     * @param pageSize (optional) 
     * @return Returns a list of log files for a device
     */
    getAllLogFiles(deviceId: string, filter: string | null | undefined, skipOffset: number | undefined, pageSize: number | undefined, version: string, cancelToken?: CancelToken): Promise<DeviceLogListDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceLogs/{deviceId}?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllLogFiles(_response);
        });
    }

    protected processGetAllLogFiles(response: AxiosResponse): Promise<DeviceLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceLogListDto.fromJS(resultData200);
            return Promise.resolve<DeviceLogListDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceLogListDto>(null as any);
    }
}

export class DevicesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a device
     * @return Returns the new devices's Id
     */
    create(version: string, dto: CreateDeviceDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Devices";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all devices
     * @return Returns an array of devices
     */
    getAllDevices(version: string, cancelToken?: CancelToken): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Devices";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDevices(_response);
        });
    }

    protected processGetAllDevices(response: AxiosResponse): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto[]>(null as any);
    }

    /**
     * Create a clocking terminal with a new device group
     * @return Returns the new clocking terminal's Id
     */
    createClockingTerminalWithNewDeviceGroup(areaId: string, version: string, dto: CreateDeviceDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{areaId}/ClockingTerminal";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClockingTerminalWithNewDeviceGroup(_response);
        });
    }

    protected processCreateClockingTerminalWithNewDeviceGroup(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Create an access point with a new device group
     * @return Returns the new access point's Id
     */
    createAccessPointWithNewDeviceGroup(areaId: string, version: string, dto: CreateDeviceDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{areaId}/AccessPoint";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccessPointWithNewDeviceGroup(_response);
        });
    }

    protected processCreateAccessPointWithNewDeviceGroup(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all devices that have the given user group in their access schedule
     * @param userGroupId User group identifier
     * @return Returns an array of devices which have the user group in their access schedule
     */
    getAllDevicesUsingUserGroup(userGroupId: string, version: string, cancelToken?: CancelToken): Promise<DeviceSummaryDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{userGroupId}/UsingUserGroup";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDevicesUsingUserGroup(_response);
        });
    }

    protected processGetAllDevicesUsingUserGroup(response: AxiosResponse): Promise<DeviceSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceSummaryDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceSummaryDto[]>(null as any);
    }

    /**
     * Get single device
     * @param id Device identifier
     * @return Returns a single device
     */
    getADevice(id: string, version: string, cancelToken?: CancelToken): Promise<DeviceDto> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetADevice(_response);
        });
    }

    protected processGetADevice(response: AxiosResponse): Promise<DeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceDto.fromJS(resultData200);
            return Promise.resolve<DeviceDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto>(null as any);
    }

    /**
     * Delete a device
     * @param id Device identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a device
     * @param id Device identifier
     */
    modify(id: string, version: string, dto: ModifyDeviceDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a device and its device group
     * @param id Device identifier
     */
    deleteWithDeviceGroup(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/WithDeviceGroup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWithDeviceGroup(_response);
        });
    }

    protected processDeleteWithDeviceGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Identify a device
     * @param id Device identifier
     */
    identify(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/Identify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIdentify(_response);
        });
    }

    protected processIdentify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reboot a device
     * @param id Device identifier
     * @return Returns the new device command Id
     */
    reboot(id: string, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/Reboot";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReboot(_response);
        });
    }

    protected processReboot(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Deactivates the given device and re-creates a new unregistered device with the same configuration and a new id
     * @param id Device identifier
     * @return Returns the id of the new unregistered device
     */
    deactivate(id: string, version: string, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/Deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Reset the engineer PIN for a device
     * @param id Device identifier
     */
    resetEngineerPin(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/ResetEngineerPin";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetEngineerPin(_response);
        });
    }

    protected processResetEngineerPin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upgradeFirmware(id: string, releaseType: DeviceFirmwareReleaseType | undefined, firmwareVersion: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/UpgradeFirmware?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (releaseType === null)
            throw new Error("The parameter 'releaseType' cannot be null.");
        else if (releaseType !== undefined)
            url_ += "releaseType=" + encodeURIComponent("" + releaseType) + "&";
        if (firmwareVersion !== undefined && firmwareVersion !== null)
            url_ += "firmwareVersion=" + encodeURIComponent("" + firmwareVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgradeFirmware(_response);
        });
    }

    protected processUpgradeFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    refreshUserList(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/RefreshUserList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshUserList(_response);
        });
    }

    protected processRefreshUserList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Request logs from a device
     * @param id Device identifier
     */
    requestLogs(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Devices/{id}/RequestLogs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestLogs(_response);
        });
    }

    protected processRequestLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceStatusAlertConfigurationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get the device status alert configuration for an individual device. If not specifically set for this device then the global settings will be returned
     * @param id device identifier
     * @return Returns a device status alert configuration
     */
    getDeviceStatusAlertConfiguration(id: string, version: string, cancelToken?: CancelToken): Promise<DeviceStatusAlertConfigurationDto> {
        let url_ = this.baseUrl + "/api/{version}/DeviceStatusAlertConfigurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatusAlertConfiguration(_response);
        });
    }

    protected processGetDeviceStatusAlertConfiguration(response: AxiosResponse): Promise<DeviceStatusAlertConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceStatusAlertConfigurationDto.fromJS(resultData200);
            return Promise.resolve<DeviceStatusAlertConfigurationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceStatusAlertConfigurationDto>(null as any);
    }

    /**
     * Upsert a device status alert configuration for an individual device overriding the global settings
     * @param id device identifier
     */
    upsert(id: string, version: string, dto: UpsertDeviceStatusAlertConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/DeviceStatusAlertConfigurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Send test emails
     */
    sendTestEmail(version: string, dto: EmailAddressesDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Email/SendTestEmail";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GlobalConfigurationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create or modify a global configuration
     */
    upsert(version: string, dto: UpsertGlobalConfigurationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/GlobalConfigurations";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get default global configuration
     * @return Returns a global configuration
     */
    getGlobalConfiguration(version: string, cancelToken?: CancelToken): Promise<GlobalConfigurationDto> {
        let url_ = this.baseUrl + "/api/{version}/GlobalConfigurations";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGlobalConfiguration(_response);
        });
    }

    protected processGetGlobalConfiguration(response: AxiosResponse): Promise<GlobalConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GlobalConfigurationDto.fromJS(resultData200);
            return Promise.resolve<GlobalConfigurationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GlobalConfigurationDto>(null as any);
    }
}

export class LicenceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get licence
     * @return Returns licence details
     */
    getLicence(version: string, cancelToken?: CancelToken): Promise<LicenceDto> {
        let url_ = this.baseUrl + "/api/{version}/Licence";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicence(_response);
        });
    }

    protected processGetLicence(response: AxiosResponse): Promise<LicenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenceDto.fromJS(resultData200);
            return Promise.resolve<LicenceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenceDto>(null as any);
    }
}

export class NoticesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the list of notices for a given device
     * @return Returns an array of business notices
     */
    get(version: string, cancelToken?: CancelToken): Promise<BusinessNoticeDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Notices/BusinessNotices";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BusinessNoticeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessNoticeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BusinessNoticeDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessNoticeDto[]>(null as any);
    }

    /**
     * Updated the business notices
     */
    update(version: string, dto: BusinessNoticeDto[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Notices/BusinessNotices";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PermissionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get current user permissions
     * @return Returns current user permissions
     */
    getPermissions(version: string, cancelToken?: CancelToken): Promise<PermissionsDto> {
        let url_ = this.baseUrl + "/api/{version}/Permissions";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PermissionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionsDto.fromJS(resultData200);
            return Promise.resolve<PermissionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionsDto>(null as any);
    }
}

export class SitesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a site
     * @return Returns the new site's Id
     */
    create(version: string, dto: CreateSiteDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Sites";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get all sites
     * @return Returns an array of sites
     */
    getAllSites(version: string, cancelToken?: CancelToken): Promise<SiteSummaryDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Sites";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSites(_response);
        });
    }

    protected processGetAllSites(response: AxiosResponse): Promise<SiteSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SiteSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteSummaryDto[]>(null as any);
    }

    /**
     * Get single site
     * @param id Site identifier
     * @return Returns a single site
     */
    getASite(id: string, version: string, cancelToken?: CancelToken): Promise<SiteDto> {
        let url_ = this.baseUrl + "/api/{version}/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetASite(_response);
        });
    }

    protected processGetASite(response: AxiosResponse): Promise<SiteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteDto.fromJS(resultData200);
            return Promise.resolve<SiteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteDto>(null as any);
    }

    /**
     * Delete a site
     * @param id Site identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a site
     * @param id Site identifier
     */
    modify(id: string, version: string, dto: ModifySiteDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a tag
     * @return Returns the new tag id
     */
    create(version: string, dto: CreateTagDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Tags";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get a page of tags with optional search term applied
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Returns an array of tags
     */
    getAllTags(pageOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<TagListDto> {
        let url_ = this.baseUrl + "/api/{version}/Tags?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTags(_response);
        });
    }

    protected processGetAllTags(response: AxiosResponse): Promise<TagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagListDto.fromJS(resultData200);
            return Promise.resolve<TagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto>(null as any);
    }

    /**
     * Get a tag
     * @param tagId Tag identifier
     * @return Returns a tag
     */
    get(tagId: string, version: string, cancelToken?: CancelToken): Promise<TagDto> {
        let url_ = this.baseUrl + "/api/{version}/Tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagDto.fromJS(resultData200);
            return Promise.resolve<TagDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagDto>(null as any);
    }

    /**
     * Modify a tag
     * @param tagId Tag identifier
     */
    modify(tagId: string, version: string, dto: ModifyTagDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a tag
     * @param tagId Tag identifier
     */
    delete(tagId: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get tags by user
     * @param userId User identifier
     * @return Returns all tags for a user
     */
    getTagsByUser(userId: string, version: string, cancelToken?: CancelToken): Promise<TagDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Tags/{userId}/User";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagsByUser(_response);
        });
    }

    protected processGetTagsByUser(response: AxiosResponse): Promise<TagDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagDto[]>(null as any);
    }

    /**
     * Get all tags
     * @return Returns an array of tags
     */
    getAllTagsAll(version: string, cancelToken?: CancelToken): Promise<TagDto[]> {
        let url_ = this.baseUrl + "/api/{version}/Tags/Tags";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTagsAll(_response);
        });
    }

    protected processGetAllTagsAll(response: AxiosResponse): Promise<TagDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagDto[]>(null as any);
    }

    /**
     * Get tag groups
     * @return Returns a list of tag groups
     */
    getTagGroups(version: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/{version}/Tags/TagGroups";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagGroups(_response);
        });
    }

    protected processGetTagGroups(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class TimeZonesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a list of time zones
     * @return Returns a list of time zones
     */
    getAllTimeZones(version: string, cancelToken?: CancelToken): Promise<TimeZoneDto[]> {
        let url_ = this.baseUrl + "/api/{version}/TimeZones";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTimeZones(_response);
        });
    }

    protected processGetAllTimeZones(response: AxiosResponse): Promise<TimeZoneDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZoneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeZoneDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeZoneDto[]>(null as any);
    }
}

export class UserGroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a User group
     * @return Returns the new User group's Id
     */
    create(version: string, dto: CreateUserGroupDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get a page of user group summaries with optional search term applied
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Returns an array of user groups
     */
    getAllUserGroupsSummary(pageOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<UserGroupSummaryListDto> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserGroupsSummary(_response);
        });
    }

    protected processGetAllUserGroupsSummary(response: AxiosResponse): Promise<UserGroupSummaryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupSummaryListDto.fromJS(resultData200);
            return Promise.resolve<UserGroupSummaryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupSummaryListDto>(null as any);
    }

    /**
     * Get a single user group
     * @param id User group identifier
     * @return Returns a single user group
     */
    getUserGroup(id: string, version: string, cancelToken?: CancelToken): Promise<UserGroupDto> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserGroup(_response);
        });
    }

    protected processGetUserGroup(response: AxiosResponse): Promise<UserGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupDto.fromJS(resultData200);
            return Promise.resolve<UserGroupDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupDto>(null as any);
    }

    /**
     * Delete a user group
     * @param id User group identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modify a user group
     * @param id User group identifier
     */
    modify(id: string, version: string, dto: ModifyUserGroupDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets a page of user group members based on a search term and filters
     * @param id User group identifier
     * @param skipOffset (optional) Number of user group members to skip before reading - zero indexed
     * @param pageSize (optional) No of user group members to return in a page
     * @param filterQuery (optional) filter by user tags e.g. {"costcentre":["C2"],"department":["ENG","SUP"]}
     * @param searchTerm (optional) Search term to apply to user name and user ref
     * @return Returns a page of user group members based on a search term and filters
     */
    getUserGroupMembersPage(id: string, skipOffset: number | undefined, pageSize: number | undefined, filterQuery: string | null | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<UserGroupMembersPageDto> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups/{id}/members?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (skipOffset === null)
            throw new Error("The parameter 'skipOffset' cannot be null.");
        else if (skipOffset !== undefined)
            url_ += "skipOffset=" + encodeURIComponent("" + skipOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterQuery !== undefined && filterQuery !== null)
            url_ += "filterQuery=" + encodeURIComponent("" + filterQuery) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserGroupMembersPage(_response);
        });
    }

    protected processGetUserGroupMembersPage(response: AxiosResponse): Promise<UserGroupMembersPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupMembersPageDto.fromJS(resultData200);
            return Promise.resolve<UserGroupMembersPageDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ApiResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupMembersPageDto>(null as any);
    }

    /**
     * Add and remove users from a user group
     */
    modifyUserGroupMembers(id: string, version: string, dto: ModifyUserGroupMembersDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/UserGroups/{id}/members";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyUserGroupMembers(_response);
        });
    }

    protected processModifyUserGroupMembers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ApiResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserGroupTagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get a page of tags with optional search term applied which includes tags selected and total selected for a user group
     * @param userGroupId (optional) 
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Returns a filtered and/or matched array of tags with selected flag and selected count
     */
    getAllTags(userGroupId: string | undefined, pageOffset: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<UserGroupTagListSelectDto> {
        let url_ = this.baseUrl + "/api/{version}/UserGroupTags?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (userGroupId === null)
            throw new Error("The parameter 'userGroupId' cannot be null.");
        else if (userGroupId !== undefined)
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&";
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTags(_response);
        });
    }

    protected processGetAllTags(response: AxiosResponse): Promise<UserGroupTagListSelectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupTagListSelectDto.fromJS(resultData200);
            return Promise.resolve<UserGroupTagListSelectDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupTagListSelectDto>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a user
     * @return Returns the new user's Id
     */
    create(version: string, dto: CreateUserDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/Users";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get a page of users with optional filters and search term applied
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param includeNew (optional) 
     * @param includeUnenrolled (optional) 
     * @param includeActive (optional) 
     * @param includeInactive (optional) 
     * @param searchTerm (optional) 
     * @return Returns a filtered and/or matched array of users
     */
    getAllUsers(pageOffset: number | undefined, pageSize: number | undefined, includeNew: boolean | undefined, includeUnenrolled: boolean | undefined, includeActive: boolean | undefined, includeInactive: boolean | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<UserListDto> {
        let url_ = this.baseUrl + "/api/{version}/Users?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (includeNew === null)
            throw new Error("The parameter 'includeNew' cannot be null.");
        else if (includeNew !== undefined)
            url_ += "includeNew=" + encodeURIComponent("" + includeNew) + "&";
        if (includeUnenrolled === null)
            throw new Error("The parameter 'includeUnenrolled' cannot be null.");
        else if (includeUnenrolled !== undefined)
            url_ += "includeUnenrolled=" + encodeURIComponent("" + includeUnenrolled) + "&";
        if (includeActive === null)
            throw new Error("The parameter 'includeActive' cannot be null.");
        else if (includeActive !== undefined)
            url_ += "includeActive=" + encodeURIComponent("" + includeActive) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<UserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserListDto.fromJS(resultData200);
            return Promise.resolve<UserListDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListDto>(null as any);
    }

    /**
     * Get a page of users with optional filters and search term applied and includes users selected and total selected for a user group
     * @param userGroupId (optional) 
     * @param pageOffset (optional) 
     * @param pageSize (optional) 
     * @param includeNew (optional) 
     * @param includeUnenrolled (optional) 
     * @param includeActive (optional) 
     * @param includeInactive (optional) 
     * @param searchTerm (optional) 
     * @return Returns a filtered and/or matched array of users with selected flag and selected count
     */
    getAllUsersOnUserGroup(userGroupId: string | undefined, pageOffset: number | undefined, pageSize: number | undefined, includeNew: boolean | undefined, includeUnenrolled: boolean | undefined, includeActive: boolean | undefined, includeInactive: boolean | undefined, searchTerm: string | null | undefined, version: string, cancelToken?: CancelToken): Promise<UserListSelectDto> {
        let url_ = this.baseUrl + "/api/{version}/Users/UserGroup?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (userGroupId === null)
            throw new Error("The parameter 'userGroupId' cannot be null.");
        else if (userGroupId !== undefined)
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&";
        if (pageOffset === null)
            throw new Error("The parameter 'pageOffset' cannot be null.");
        else if (pageOffset !== undefined)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (includeNew === null)
            throw new Error("The parameter 'includeNew' cannot be null.");
        else if (includeNew !== undefined)
            url_ += "includeNew=" + encodeURIComponent("" + includeNew) + "&";
        if (includeUnenrolled === null)
            throw new Error("The parameter 'includeUnenrolled' cannot be null.");
        else if (includeUnenrolled !== undefined)
            url_ += "includeUnenrolled=" + encodeURIComponent("" + includeUnenrolled) + "&";
        if (includeActive === null)
            throw new Error("The parameter 'includeActive' cannot be null.");
        else if (includeActive !== undefined)
            url_ += "includeActive=" + encodeURIComponent("" + includeActive) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsersOnUserGroup(_response);
        });
    }

    protected processGetAllUsersOnUserGroup(response: AxiosResponse): Promise<UserListSelectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserListSelectDto.fromJS(resultData200);
            return Promise.resolve<UserListSelectDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListSelectDto>(null as any);
    }

    /**
     * Get single user
     * @param id User identifier
     * @return Returns a single user
     */
    getUser(id: string, version: string, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/{version}/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * Modify a user
     * @param id user identifier
     */
    modify(id: string, version: string, dto: ModifyUserDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModify(_response);
        });
    }

    protected processModify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a user
     * @param id User identifier
     */
    delete(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reset the enrolment code
     * @param id user identifier
     */
    resetEnrolmentCode(id: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/Users/{id}/ResetEnrolmentCode";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetEnrolmentCode(_response);
        });
    }

    protected processResetEnrolmentCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadCsv(version: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/{version}/Users/CSV";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCsv(_response);
        });
    }

    protected processDownloadCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserTagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a user tag
     * @return Returns the new user tag id
     */
    create(version: string, dto: CreateUserTagDto, cancelToken?: CancelToken): Promise<ApiResponseOfGuid> {
        let url_ = this.baseUrl + "/api/{version}/UserTags";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ApiResponseOfGuid.fromJS(resultData201);
            return Promise.resolve<ApiResponseOfGuid>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseOfGuid>(null as any);
    }

    /**
     * Get a user tag
     * @param userTagId User tag identifier
     * @return Returns a user tag
     */
    get(userTagId: string, version: string, cancelToken?: CancelToken): Promise<UserTagDto> {
        let url_ = this.baseUrl + "/api/{version}/UserTags/{userTagId}";
        if (userTagId === undefined || userTagId === null)
            throw new Error("The parameter 'userTagId' must be defined.");
        url_ = url_.replace("{userTagId}", encodeURIComponent("" + userTagId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTagDto.fromJS(resultData200);
            return Promise.resolve<UserTagDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTagDto>(null as any);
    }

    /**
     * Delete a user tag
     * @param userTagId User tag identifier
     */
    delete(userTagId: string, version: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{version}/UserTags/{userTagId}";
        if (userTagId === undefined || userTagId === null)
            throw new Error("The parameter 'userTagId' must be defined.");
        url_ = url_.replace("{userTagId}", encodeURIComponent("" + userTagId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get user tags by user
     * @param userId User identifier
     * @return Returns all user tags for a user
     */
    getUserTagsByUser(userId: string, version: string, cancelToken?: CancelToken): Promise<UserTagDto[]> {
        let url_ = this.baseUrl + "/api/{version}/UserTags/{userId}/User";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTagsByUser(_response);
        });
    }

    protected processGetUserTagsByUser(response: AxiosResponse): Promise<UserTagDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserTagDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTagDto[]>(null as any);
    }
}

export class IntegrationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an activity
     * @param api_version (optional) 
     * @param activityCreate The request body includes all the required fields
     * @return Created
     */
    createActivity(api_version: string | null | undefined, activityCreate: ActivityCreate, cancelToken?: CancelToken): Promise<GuidApiResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/activities?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivity(_response);
        });
    }

    protected processCreateActivity(response: AxiosResponse): Promise<GuidApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidApiResponse.fromJS(resultData201);
            return Promise.resolve<GuidApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidApiResponse>(null as any);
    }

    /**
     * Get all activities
     * @param api_version (optional) 
     * @return Success
     */
    getAllActivities(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<ActivityResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/activities?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActivities(_response);
        });
    }

    protected processGetAllActivities(response: AxiosResponse): Promise<ActivityResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivityResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityResponse[]>(null as any);
    }

    /**
     * Delete an activity
     * @param activityId Activity Identifier
     * @param api_version (optional) 
     */
    deleteActivity(activityId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/activities/{activityId}?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivity(_response);
        });
    }

    protected processDeleteActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get single activity
     * @param activityId Activity Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleActivity(activityId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<ActivityResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/activities/{activityId}?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleActivity(_response);
        });
    }

    protected processGetSingleActivity(response: AxiosResponse): Promise<ActivityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityResponse.fromJS(resultData200);
            return Promise.resolve<ActivityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityResponse>(null as any);
    }

    /**
     * Modify an activity
     * @param activityId Activity Identifier
     * @param api_version (optional) 
     * @param activityModify The request body includes all the required fields
     */
    modifyActivity(activityId: string, api_version: string | null | undefined, activityModify: ActivityModify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/activities/{activityId}?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityModify);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyActivity(_response);
        });
    }

    protected processModifyActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a badge
     * @param api_version (optional) 
     * @param badgeCreate The request body includes all the required fields
     * @return Created
     */
    createBadge(api_version: string | null | undefined, badgeCreate: BadgeCreate, cancelToken?: CancelToken): Promise<GuidApiResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/badges?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(badgeCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBadge(_response);
        });
    }

    protected processCreateBadge(response: AxiosResponse): Promise<GuidApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidApiResponse.fromJS(resultData201);
            return Promise.resolve<GuidApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidApiResponse>(null as any);
    }

    /**
     * Get all badges
     * @param api_version (optional) 
     * @return Success
     */
    getAllBadges(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<BadgeResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/badges?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBadges(_response);
        });
    }

    protected processGetAllBadges(response: AxiosResponse): Promise<BadgeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BadgeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BadgeResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeResponse[]>(null as any);
    }

    /**
     * Delete a badge
     * @param badgeId Badge Identifier
     * @param api_version (optional) 
     */
    deleteBadge(badgeId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/badges/{badgeId}?";
        if (badgeId === undefined || badgeId === null)
            throw new Error("The parameter 'badgeId' must be defined.");
        url_ = url_.replace("{badgeId}", encodeURIComponent("" + badgeId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBadge(_response);
        });
    }

    protected processDeleteBadge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a single badge
     * @param badgeId Badge Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleBadge(badgeId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<BadgeResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/badges/{badgeId}?";
        if (badgeId === undefined || badgeId === null)
            throw new Error("The parameter 'badgeId' must be defined.");
        url_ = url_.replace("{badgeId}", encodeURIComponent("" + badgeId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleBadge(_response);
        });
    }

    protected processGetSingleBadge(response: AxiosResponse): Promise<BadgeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BadgeResponse.fromJS(resultData200);
            return Promise.resolve<BadgeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeResponse>(null as any);
    }

    /**
     * Modify a Badge
     * @param badgeId Badge Identifier
     * @param api_version (optional) 
     * @param badgeModify The request body includes all the required fields
     */
    modifyBadge(badgeId: string, api_version: string | null | undefined, badgeModify: BadgeModify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/badges/{badgeId}?";
        if (badgeId === undefined || badgeId === null)
            throw new Error("The parameter 'badgeId' must be defined.");
        url_ = url_.replace("{badgeId}", encodeURIComponent("" + badgeId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(badgeModify);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyBadge(_response);
        });
    }

    protected processModifyBadge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all clockings within range
     * @param startdateRange (optional) The start date range
     * @param endDateRange (optional) The end date range
     * @param pageOffset (optional) The page offset value
     * @param pageSize (optional) The page size value
     * @param searchTerm (optional) A search term to search the user data fields
     * @param api_version (optional) 
     * @return Success
     */
    getAllClockings(startdateRange: Date | null | undefined, endDateRange: Date | null | undefined, pageOffset: number | null | undefined, pageSize: number | null | undefined, searchTerm: string | null | undefined, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<ClockingListResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/clockings?";
        if (startdateRange !== undefined && startdateRange !== null)
            url_ += "startdateRange=" + encodeURIComponent(startdateRange ? "" + startdateRange.toISOString() : "") + "&";
        if (endDateRange !== undefined && endDateRange !== null)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (pageOffset !== undefined && pageOffset !== null)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClockings(_response);
        });
    }

    protected processGetAllClockings(response: AxiosResponse): Promise<ClockingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClockingListResponse.fromJS(resultData200);
            return Promise.resolve<ClockingListResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClockingListResponse>(null as any);
    }

    /**
     * Gets all clockings for a single user
     * @param userId User Identifier
     * @param startdateRange (optional) The start date range
     * @param endDateRange (optional) The end date range
     * @param pageOffset (optional) The page offset value
     * @param pageSize (optional) The page size value
     * @param searchTerm (optional) A search term to search the user data fields
     * @param api_version (optional) 
     * @return Success
     */
    getAllClockingsForUser(userId: string, startdateRange: Date | null | undefined, endDateRange: Date | null | undefined, pageOffset: number | null | undefined, pageSize: number | null | undefined, searchTerm: string | null | undefined, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<ClockingListResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/clockings/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (startdateRange !== undefined && startdateRange !== null)
            url_ += "startdateRange=" + encodeURIComponent(startdateRange ? "" + startdateRange.toISOString() : "") + "&";
        if (endDateRange !== undefined && endDateRange !== null)
            url_ += "endDateRange=" + encodeURIComponent(endDateRange ? "" + endDateRange.toISOString() : "") + "&";
        if (pageOffset !== undefined && pageOffset !== null)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllClockingsForUser(_response);
        });
    }

    protected processGetAllClockingsForUser(response: AxiosResponse): Promise<ClockingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClockingListResponse.fromJS(resultData200);
            return Promise.resolve<ClockingListResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClockingListResponse>(null as any);
    }

    /**
     * Get a page of activities assigned to a device
     * @param deviceId Device Identifier
     * @param pageOffset (optional) The page offset value
     * @param pageSize (optional) The page size value
     * @param searchTerm (optional) A search term to search the user data fields
     * @param api_version (optional) 
     * @return Success
     */
    getDeviceActivities(deviceId: string, pageOffset: number | null | undefined, pageSize: number | null | undefined, searchTerm: string | null | undefined, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<DeviceActivitiesListResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/device-activities/{deviceId}?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (pageOffset !== undefined && pageOffset !== null)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceActivities(_response);
        });
    }

    protected processGetDeviceActivities(response: AxiosResponse): Promise<DeviceActivitiesListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceActivitiesListResponse.fromJS(resultData200);
            return Promise.resolve<DeviceActivitiesListResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceActivitiesListResponse>(null as any);
    }

    /**
     * Modify the list of activities
     * @param deviceId Device Identifier
     * @param api_version (optional) 
     * @param deviceActivitiesModify The request body includes all the required fields
     */
    modifyDeviceActivities(deviceId: string, api_version: string | null | undefined, deviceActivitiesModify: DeviceActivitiesModify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/device-activities/{deviceId}?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceActivitiesModify);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyDeviceActivities(_response);
        });
    }

    protected processModifyDeviceActivities(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all devices
     * @param api_version (optional) 
     * @return Success
     */
    getAllDevices(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<DeviceResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/devices?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDevices(_response);
        });
    }

    protected processGetAllDevices(response: AxiosResponse): Promise<DeviceResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse[]>(null as any);
    }

    /**
     * Get single device
     * @param deviceId Device Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleDevice(deviceId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/devices/{deviceId}?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleDevice(_response);
        });
    }

    protected processGetSingleDevice(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceResponse.fromJS(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    /**
     * Get all sites
     * @param api_version (optional) 
     * @return Success
     */
    getAllSites(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<SiteSummaryResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/sites?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSites(_response);
        });
    }

    protected processGetAllSites(response: AxiosResponse): Promise<SiteSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteSummaryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SiteSummaryResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteSummaryResponse[]>(null as any);
    }

    /**
     * Get single site
     * @param siteId Site Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleSite(siteId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<SiteResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/sites/{siteId}?";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleSite(_response);
        });
    }

    protected processGetSingleSite(response: AxiosResponse): Promise<SiteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteResponse.fromJS(resultData200);
            return Promise.resolve<SiteResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteResponse>(null as any);
    }

    /**
     * Create a tag
     * @param api_version (optional) 
     * @param tagCreate The request body includes all the required fields
     * @return Created
     */
    createTag(api_version: string | null | undefined, tagCreate: TagCreate, cancelToken?: CancelToken): Promise<GuidApiResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTag(_response);
        });
    }

    protected processCreateTag(response: AxiosResponse): Promise<GuidApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidApiResponse.fromJS(resultData201);
            return Promise.resolve<GuidApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidApiResponse>(null as any);
    }

    /**
     * Get a page of tags
     * @param pageOffset (optional) The page offset value
     * @param pageSize (optional) The page size value
     * @param searchTerm (optional) A search term to search the user data fields
     * @param api_version (optional) 
     * @return Success
     */
    getTags(pageOffset: number | null | undefined, pageSize: number | null | undefined, searchTerm: string | null | undefined, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<TagPageableListResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags?";
        if (pageOffset !== undefined && pageOffset !== null)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTags(_response);
        });
    }

    protected processGetTags(response: AxiosResponse): Promise<TagPageableListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagPageableListResponse.fromJS(resultData200);
            return Promise.resolve<TagPageableListResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagPageableListResponse>(null as any);
    }

    /**
     * Delete a tag
     * @param tagId Tag Identifier
     * @param api_version (optional) 
     */
    deleteTag(tagId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags/{tagId}?";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTag(_response);
        });
    }

    protected processDeleteTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a tag
     * @param tagId Tag Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleTag(tagId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<TagResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags/{tagId}?";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleTag(_response);
        });
    }

    protected processGetSingleTag(response: AxiosResponse): Promise<TagResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagResponse.fromJS(resultData200);
            return Promise.resolve<TagResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponse>(null as any);
    }

    /**
     * Modify a tag
     * @param tagId Tag Identifier
     * @param api_version (optional) 
     * @param tagModify The request body includes all the required fields
     */
    modifyTag(tagId: string, api_version: string | null | undefined, tagModify: TagModify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags/{tagId}?";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagModify);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyTag(_response);
        });
    }

    protected processModifyTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all tags
     * @param api_version (optional) 
     * @return Success
     */
    getAllTags(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<TagResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags/tags?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTags(_response);
        });
    }

    protected processGetAllTags(response: AxiosResponse): Promise<TagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponse[]>(null as any);
    }

    /**
     * Get tag groups
     * @param api_version (optional) 
     * @return Success
     */
    getTagGroups(api_version: string | null | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/tags/tag-groups?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagGroups(_response);
        });
    }

    protected processGetTagGroups(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Create a user
     * @param api_version (optional) 
     * @param userCreate The request body includes all the user data required to create a new user
     * @return Created
     */
    createUser(api_version: string | null | undefined, userCreate: UserCreate, cancelToken?: CancelToken): Promise<GuidApiResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/users?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<GuidApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidApiResponse.fromJS(resultData201);
            return Promise.resolve<GuidApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidApiResponse>(null as any);
    }

    /**
     * Get a page of users with optional filters
     * @param pageOffset (optional) The page offset value
     * @param pageSize (optional) The page size value
     * @param includeNew (optional) A boolean to specify whether the page should include new users
     * @param includeUnenrolled (optional) A boolean to specify whether the page should include unenrolled users
     * @param includeActive (optional) A boolean to specify whether the page should include active users
     * @param includeInactive (optional) A boolean to specify whether the page should include inactive users
     * @param searchTerm (optional) A search term to search the user data fields
     * @param api_version (optional) 
     * @return Success
     */
    getUsers(pageOffset: number | null | undefined, pageSize: number | null | undefined, includeNew: boolean | null | undefined, includeUnenrolled: boolean | null | undefined, includeActive: boolean | null | undefined, includeInactive: boolean | null | undefined, searchTerm: string | null | undefined, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<UserListResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/users?";
        if (pageOffset !== undefined && pageOffset !== null)
            url_ += "pageOffset=" + encodeURIComponent("" + pageOffset) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (includeNew !== undefined && includeNew !== null)
            url_ += "includeNew=" + encodeURIComponent("" + includeNew) + "&";
        if (includeUnenrolled !== undefined && includeUnenrolled !== null)
            url_ += "includeUnenrolled=" + encodeURIComponent("" + includeUnenrolled) + "&";
        if (includeActive !== undefined && includeActive !== null)
            url_ += "includeActive=" + encodeURIComponent("" + includeActive) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserListResponse.fromJS(resultData200);
            return Promise.resolve<UserListResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListResponse>(null as any);
    }

    /**
     * Delete a user
     * @param userId User Identifier
     * @param api_version (optional) 
     */
    deleteUser(userId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get single user
     * @param userId User Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getSingleUser(userId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<UserResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleUser(_response);
        });
    }

    protected processGetSingleUser(response: AxiosResponse): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResponse.fromJS(resultData200);
            return Promise.resolve<UserResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    /**
     * Modify a user
     * @param userId User Identifier
     * @param api_version (optional) 
     * @param userModify The request body content includes all the data fields and values that need to be modified.
     */
    modifyUser(userId: string, api_version: string | null | undefined, userModify: UserModify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userModify);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyUser(_response);
        });
    }

    protected processModifyUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a user tag
     * @param api_version (optional) 
     * @param userTagCreate The request body includes all the required fields
     * @return Created
     */
    createUserTag(api_version: string | null | undefined, userTagCreate: UserTagCreate, cancelToken?: CancelToken): Promise<GuidApiResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/user-tags?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userTagCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserTag(_response);
        });
    }

    protected processCreateUserTag(response: AxiosResponse): Promise<GuidApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidApiResponse.fromJS(resultData201);
            return Promise.resolve<GuidApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetailsModel.fromJS(resultData415);
            return throwException("Unsupported Media Type", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidApiResponse>(null as any);
    }

    /**
     * Delete a user tag
     * @param userTagId User Tag Identifier
     * @param api_version (optional) 
     */
    deleteUserTag(userTagId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/integrationapi/1.0/user-tags/{userTagId}?";
        if (userTagId === undefined || userTagId === null)
            throw new Error("The parameter 'userTagId' must be defined.");
        url_ = url_.replace("{userTagId}", encodeURIComponent("" + userTagId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserTag(_response);
        });
    }

    protected processDeleteUserTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a user tag
     * @param userTagId User Tag Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getUserTag(userTagId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<UserTagResponse> {
        let url_ = this.baseUrl + "/integrationapi/1.0/user-tags/{userTagId}?";
        if (userTagId === undefined || userTagId === null)
            throw new Error("The parameter 'userTagId' must be defined.");
        url_ = url_.replace("{userTagId}", encodeURIComponent("" + userTagId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTag(_response);
        });
    }

    protected processGetUserTag(response: AxiosResponse): Promise<UserTagResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTagResponse.fromJS(resultData200);
            return Promise.resolve<UserTagResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTagResponse>(null as any);
    }

    /**
     * Get user tags by user
     * @param userId User Identifier
     * @param api_version (optional) 
     * @return Success
     */
    getUserTagsOnUser(userId: string, api_version: string | null | undefined, cancelToken?: CancelToken): Promise<UserTagResponse[]> {
        let url_ = this.baseUrl + "/integrationapi/1.0/user-tags/{userId}/user?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTagsOnUser(_response);
        });
    }

    protected processGetUserTagsOnUser(response: AxiosResponse): Promise<UserTagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserTagResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetailsModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetailsModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetailsModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetailsModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTagResponse[]>(null as any);
    }
}

export class AccessScheduleDto implements IAccessScheduleDto {
    id?: string;
    name?: string | null;
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    scheduleTracks?: ScheduleTrackDto[] | null;
    entityVersion?: string;

    constructor(data?: IAccessScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scheduleTracks) {
                this.scheduleTracks = [];
                for (let i = 0; i < data.scheduleTracks.length; i++) {
                    let item = data.scheduleTracks[i];
                    this.scheduleTracks[i] = item && !(<any>item).toJSON ? new ScheduleTrackDto(item) : <ScheduleTrackDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.scheduleRotationType = _data["scheduleRotationType"] !== undefined ? _data["scheduleRotationType"] : <any>null;
            this.scheduleRotationLength = _data["scheduleRotationLength"] !== undefined ? _data["scheduleRotationLength"] : <any>null;
            this.scheduleBaseDate = _data["scheduleBaseDate"] ? new Date(_data["scheduleBaseDate"].toString()) : <any>null;
            if (Array.isArray(_data["scheduleTracks"])) {
                this.scheduleTracks = [] as any;
                for (let item of _data["scheduleTracks"])
                    this.scheduleTracks!.push(ScheduleTrackDto.fromJS(item));
            }
            else {
                this.scheduleTracks = <any>null;
            }
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): AccessScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["scheduleRotationType"] = this.scheduleRotationType !== undefined ? this.scheduleRotationType : <any>null;
        data["scheduleRotationLength"] = this.scheduleRotationLength !== undefined ? this.scheduleRotationLength : <any>null;
        data["scheduleBaseDate"] = this.scheduleBaseDate ? this.scheduleBaseDate.toISOString() : <any>null;
        if (Array.isArray(this.scheduleTracks)) {
            data["scheduleTracks"] = [];
            for (let item of this.scheduleTracks)
                data["scheduleTracks"].push(item.toJSON());
        }
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): AccessScheduleDto {
        const json = this.toJSON();
        let result = new AccessScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IAccessScheduleDto {
    id?: string;
    name?: string | null;
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    scheduleTracks?: IScheduleTrackDto[] | null;
    entityVersion?: string;
}

export enum ScheduleRotationType {
    None = 0,
    Day = 1,
    Week = 2,
    WeekPlusWeekend = 3,
}

export class ScheduleTrackDto implements IScheduleTrackDto {
    id?: string;
    trackId?: string | null;
    trackType?: ScheduleTrackType;
    trackName?: string | null;
    isActive?: boolean;
    timebars?: ScheduleTimebarDto[] | null;

    constructor(data?: IScheduleTrackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.timebars) {
                this.timebars = [];
                for (let i = 0; i < data.timebars.length; i++) {
                    let item = data.timebars[i];
                    this.timebars[i] = item && !(<any>item).toJSON ? new ScheduleTimebarDto(item) : <ScheduleTimebarDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.trackId = _data["trackId"] !== undefined ? _data["trackId"] : <any>null;
            this.trackType = _data["trackType"] !== undefined ? _data["trackType"] : <any>null;
            this.trackName = _data["trackName"] !== undefined ? _data["trackName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["timebars"])) {
                this.timebars = [] as any;
                for (let item of _data["timebars"])
                    this.timebars!.push(ScheduleTimebarDto.fromJS(item));
            }
            else {
                this.timebars = <any>null;
            }
        }
    }

    static fromJS(data: any): ScheduleTrackDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTrackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["trackId"] = this.trackId !== undefined ? this.trackId : <any>null;
        data["trackType"] = this.trackType !== undefined ? this.trackType : <any>null;
        data["trackName"] = this.trackName !== undefined ? this.trackName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.timebars)) {
            data["timebars"] = [];
            for (let item of this.timebars)
                data["timebars"].push(item.toJSON());
        }
        return data;
    }

    clone(): ScheduleTrackDto {
        const json = this.toJSON();
        let result = new ScheduleTrackDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleTrackDto {
    id?: string;
    trackId?: string | null;
    trackType?: ScheduleTrackType;
    trackName?: string | null;
    isActive?: boolean;
    timebars?: IScheduleTimebarDto[] | null;
}

export enum ScheduleTrackType {
    Open = 0,
    User = 1,
    UserGroup = 2,
}

export class ScheduleTimebarDto implements IScheduleTimebarDto {
    rotationOffset?: number;
    start?: number;
    end?: number;

    constructor(data?: IScheduleTimebarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rotationOffset = _data["rotationOffset"] !== undefined ? _data["rotationOffset"] : <any>null;
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.end = _data["end"] !== undefined ? _data["end"] : <any>null;
        }
    }

    static fromJS(data: any): ScheduleTimebarDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTimebarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rotationOffset"] = this.rotationOffset !== undefined ? this.rotationOffset : <any>null;
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["end"] = this.end !== undefined ? this.end : <any>null;
        return data;
    }

    clone(): ScheduleTimebarDto {
        const json = this.toJSON();
        let result = new ScheduleTimebarDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleTimebarDto {
    rotationOffset?: number;
    start?: number;
    end?: number;
}

export class AccessScheduleUserGroupListSelectDto implements IAccessScheduleUserGroupListSelectDto {
    metaData?: AccessScheduleUserGroupListSelectMetaDataDto | null;
    userGroups?: AccessScheduleUserGroupSelectDto[] | null;

    constructor(data?: IAccessScheduleUserGroupListSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new AccessScheduleUserGroupListSelectMetaDataDto(data.metaData) : <AccessScheduleUserGroupListSelectMetaDataDto>this.metaData;
            if (data.userGroups) {
                this.userGroups = [];
                for (let i = 0; i < data.userGroups.length; i++) {
                    let item = data.userGroups[i];
                    this.userGroups[i] = item && !(<any>item).toJSON ? new AccessScheduleUserGroupSelectDto(item) : <AccessScheduleUserGroupSelectDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? AccessScheduleUserGroupListSelectMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(AccessScheduleUserGroupSelectDto.fromJS(item));
            }
            else {
                this.userGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): AccessScheduleUserGroupListSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessScheduleUserGroupListSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        return data;
    }

    clone(): AccessScheduleUserGroupListSelectDto {
        const json = this.toJSON();
        let result = new AccessScheduleUserGroupListSelectDto();
        result.init(json);
        return result;
    }
}

export interface IAccessScheduleUserGroupListSelectDto {
    metaData?: IAccessScheduleUserGroupListSelectMetaDataDto | null;
    userGroups?: IAccessScheduleUserGroupSelectDto[] | null;
}

export class AccessScheduleUserGroupSummaryListMetaDataDto implements IAccessScheduleUserGroupSummaryListMetaDataDto {
    filteredTotal?: number;

    constructor(data?: IAccessScheduleUserGroupSummaryListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
        }
    }

    static fromJS(data: any): AccessScheduleUserGroupSummaryListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessScheduleUserGroupSummaryListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        return data;
    }

    clone(): AccessScheduleUserGroupSummaryListMetaDataDto {
        const json = this.toJSON();
        let result = new AccessScheduleUserGroupSummaryListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IAccessScheduleUserGroupSummaryListMetaDataDto {
    filteredTotal?: number;
}

export class AccessScheduleUserGroupListSelectMetaDataDto extends AccessScheduleUserGroupSummaryListMetaDataDto implements IAccessScheduleUserGroupListSelectMetaDataDto {
    totalSelected?: number;
    total?: number;
    restrictedUserGroup?: boolean;

    constructor(data?: IAccessScheduleUserGroupListSelectMetaDataDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalSelected = _data["totalSelected"] !== undefined ? _data["totalSelected"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.restrictedUserGroup = _data["restrictedUserGroup"] !== undefined ? _data["restrictedUserGroup"] : <any>null;
        }
    }

    static override fromJS(data: any): AccessScheduleUserGroupListSelectMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessScheduleUserGroupListSelectMetaDataDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSelected"] = this.totalSelected !== undefined ? this.totalSelected : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["restrictedUserGroup"] = this.restrictedUserGroup !== undefined ? this.restrictedUserGroup : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AccessScheduleUserGroupListSelectMetaDataDto {
        const json = this.toJSON();
        let result = new AccessScheduleUserGroupListSelectMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IAccessScheduleUserGroupListSelectMetaDataDto extends IAccessScheduleUserGroupSummaryListMetaDataDto {
    totalSelected?: number;
    total?: number;
    restrictedUserGroup?: boolean;
}

export class AccessScheduleUserGroupSelectDto implements IAccessScheduleUserGroupSelectDto {
    id?: string;
    name!: string;
    userCount?: number;
    selected?: boolean;

    constructor(data?: IAccessScheduleUserGroupSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userCount = _data["userCount"] !== undefined ? _data["userCount"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): AccessScheduleUserGroupSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessScheduleUserGroupSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userCount"] = this.userCount !== undefined ? this.userCount : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): AccessScheduleUserGroupSelectDto {
        const json = this.toJSON();
        let result = new AccessScheduleUserGroupSelectDto();
        result.init(json);
        return result;
    }
}

export interface IAccessScheduleUserGroupSelectDto {
    id?: string;
    name: string;
    userCount?: number;
    selected?: boolean;
}

export class ApiResponse implements IApiResponse {
    messages?: ApiResponseMessage[] | null;

    constructor(data?: IApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(<any>item).toJSON ? new ApiResponseMessage(item) : <ApiResponseMessage>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ApiResponseMessage.fromJS(item));
            }
            else {
                this.messages = <any>null;
            }
        }
    }

    static fromJS(data: any): ApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }

    clone(): ApiResponse {
        const json = this.toJSON();
        let result = new ApiResponse();
        result.init(json);
        return result;
    }
}

export interface IApiResponse {
    messages?: IApiResponseMessage[] | null;
}

export class ApiResponseMessage implements IApiResponseMessage {
    level?: ApiResponseMessageLevel;
    message?: string | null;
    field?: string | null;
    errorId?: string | null;

    constructor(data?: IApiResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            this.errorId = _data["errorId"] !== undefined ? _data["errorId"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["errorId"] = this.errorId !== undefined ? this.errorId : <any>null;
        return data;
    }

    clone(): ApiResponseMessage {
        const json = this.toJSON();
        let result = new ApiResponseMessage();
        result.init(json);
        return result;
    }
}

export interface IApiResponseMessage {
    level?: ApiResponseMessageLevel;
    message?: string | null;
    field?: string | null;
    errorId?: string | null;
}

export enum ApiResponseMessageLevel {
    Info = 0,
    Warning = 1,
    Validation = 2,
    Error = 3,
}

export class ModifyAccessScheduleDto implements IModifyAccessScheduleDto {
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    scheduleTracks?: ModifyScheduleTrackDto[] | null;

    constructor(data?: IModifyAccessScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scheduleTracks) {
                this.scheduleTracks = [];
                for (let i = 0; i < data.scheduleTracks.length; i++) {
                    let item = data.scheduleTracks[i];
                    this.scheduleTracks[i] = item && !(<any>item).toJSON ? new ModifyScheduleTrackDto(item) : <ModifyScheduleTrackDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleRotationType = _data["scheduleRotationType"] !== undefined ? _data["scheduleRotationType"] : <any>null;
            this.scheduleRotationLength = _data["scheduleRotationLength"] !== undefined ? _data["scheduleRotationLength"] : <any>null;
            this.scheduleBaseDate = _data["scheduleBaseDate"] ? new Date(_data["scheduleBaseDate"].toString()) : <any>null;
            if (Array.isArray(_data["scheduleTracks"])) {
                this.scheduleTracks = [] as any;
                for (let item of _data["scheduleTracks"])
                    this.scheduleTracks!.push(ModifyScheduleTrackDto.fromJS(item));
            }
            else {
                this.scheduleTracks = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyAccessScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAccessScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleRotationType"] = this.scheduleRotationType !== undefined ? this.scheduleRotationType : <any>null;
        data["scheduleRotationLength"] = this.scheduleRotationLength !== undefined ? this.scheduleRotationLength : <any>null;
        data["scheduleBaseDate"] = this.scheduleBaseDate ? this.scheduleBaseDate.toISOString() : <any>null;
        if (Array.isArray(this.scheduleTracks)) {
            data["scheduleTracks"] = [];
            for (let item of this.scheduleTracks)
                data["scheduleTracks"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModifyAccessScheduleDto {
        const json = this.toJSON();
        let result = new ModifyAccessScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IModifyAccessScheduleDto {
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    scheduleTracks?: IModifyScheduleTrackDto[] | null;
}

export class ModifyScheduleTrackDto implements IModifyScheduleTrackDto {
    id?: string;
    trackId?: string | null;
    trackType?: ScheduleTrackType;
    isActive?: boolean;
    timebars?: ScheduleTimebarDto[] | null;

    constructor(data?: IModifyScheduleTrackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.timebars) {
                this.timebars = [];
                for (let i = 0; i < data.timebars.length; i++) {
                    let item = data.timebars[i];
                    this.timebars[i] = item && !(<any>item).toJSON ? new ScheduleTimebarDto(item) : <ScheduleTimebarDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.trackId = _data["trackId"] !== undefined ? _data["trackId"] : <any>null;
            this.trackType = _data["trackType"] !== undefined ? _data["trackType"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["timebars"])) {
                this.timebars = [] as any;
                for (let item of _data["timebars"])
                    this.timebars!.push(ScheduleTimebarDto.fromJS(item));
            }
            else {
                this.timebars = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyScheduleTrackDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyScheduleTrackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["trackId"] = this.trackId !== undefined ? this.trackId : <any>null;
        data["trackType"] = this.trackType !== undefined ? this.trackType : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.timebars)) {
            data["timebars"] = [];
            for (let item of this.timebars)
                data["timebars"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModifyScheduleTrackDto {
        const json = this.toJSON();
        let result = new ModifyScheduleTrackDto();
        result.init(json);
        return result;
    }
}

export interface IModifyScheduleTrackDto {
    id?: string;
    trackId?: string | null;
    trackType?: ScheduleTrackType;
    isActive?: boolean;
    timebars?: IScheduleTimebarDto[] | null;
}

export class ModifyAccessScheduleByUserGroupDto implements IModifyAccessScheduleByUserGroupDto {
    allUsers?: boolean;
    userGroups?: UserGroupSelectionDto[] | null;

    constructor(data?: IModifyAccessScheduleByUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.userGroups) {
                this.userGroups = [];
                for (let i = 0; i < data.userGroups.length; i++) {
                    let item = data.userGroups[i];
                    this.userGroups[i] = item && !(<any>item).toJSON ? new UserGroupSelectionDto(item) : <UserGroupSelectionDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allUsers = _data["allUsers"] !== undefined ? _data["allUsers"] : <any>null;
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(UserGroupSelectionDto.fromJS(item));
            }
            else {
                this.userGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyAccessScheduleByUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAccessScheduleByUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allUsers"] = this.allUsers !== undefined ? this.allUsers : <any>null;
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModifyAccessScheduleByUserGroupDto {
        const json = this.toJSON();
        let result = new ModifyAccessScheduleByUserGroupDto();
        result.init(json);
        return result;
    }
}

export interface IModifyAccessScheduleByUserGroupDto {
    allUsers?: boolean;
    userGroups?: IUserGroupSelectionDto[] | null;
}

export class UserGroupSelectionDto implements IUserGroupSelectionDto {
    id?: string;
    isSelected?: boolean;

    constructor(data?: IUserGroupSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isSelected = _data["isSelected"] !== undefined ? _data["isSelected"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isSelected"] = this.isSelected !== undefined ? this.isSelected : <any>null;
        return data;
    }

    clone(): UserGroupSelectionDto {
        const json = this.toJSON();
        let result = new UserGroupSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupSelectionDto {
    id?: string;
    isSelected?: boolean;
}

export class ApiResponseOfGuid extends ApiResponse implements IApiResponseOfGuid {
    result?: string;

    constructor(data?: IApiResponseOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
        }
    }

    static override fromJS(data: any): ApiResponseOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiResponseOfGuid {
        const json = this.toJSON();
        let result = new ApiResponseOfGuid();
        result.init(json);
        return result;
    }
}

export interface IApiResponseOfGuid extends IApiResponse {
    result?: string;
}

export class CreateActivityDto implements ICreateActivityDto {
    name?: string | null;
    description?: string | null;
    externalReference?: string | null;
    externalId?: string | null;
    importId?: string | null;
    onsiteStatusChange?: OnsiteStatusChange;

    constructor(data?: ICreateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.importId = _data["importId"] !== undefined ? _data["importId"] : <any>null;
            this.onsiteStatusChange = _data["onsiteStatusChange"] !== undefined ? _data["onsiteStatusChange"] : <any>null;
        }
    }

    static fromJS(data: any): CreateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["importId"] = this.importId !== undefined ? this.importId : <any>null;
        data["onsiteStatusChange"] = this.onsiteStatusChange !== undefined ? this.onsiteStatusChange : <any>null;
        return data;
    }

    clone(): CreateActivityDto {
        const json = this.toJSON();
        let result = new CreateActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityDto {
    name?: string | null;
    description?: string | null;
    externalReference?: string | null;
    externalId?: string | null;
    importId?: string | null;
    onsiteStatusChange?: OnsiteStatusChange;
}

export enum OnsiteStatusChange {
    None = 0,
    Onsite = 1,
    Offsite = 2,
}

export class ActivityDto implements IActivityDto {
    id?: string;
    name!: string;
    description!: string;
    externalReference!: string;
    entityVersion?: string;
    onsiteStatusChange?: OnsiteStatusChange;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
            this.onsiteStatusChange = _data["onsiteStatusChange"] !== undefined ? _data["onsiteStatusChange"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        data["onsiteStatusChange"] = this.onsiteStatusChange !== undefined ? this.onsiteStatusChange : <any>null;
        return data;
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto {
    id?: string;
    name: string;
    description: string;
    externalReference: string;
    entityVersion?: string;
    onsiteStatusChange?: OnsiteStatusChange;
}

export class ModifyActivityDto implements IModifyActivityDto {
    name!: string;
    description!: string;
    externalReference!: string;
    onsiteStatusChange?: OnsiteStatusChange;

    constructor(data?: IModifyActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.onsiteStatusChange = _data["onsiteStatusChange"] !== undefined ? _data["onsiteStatusChange"] : <any>null;
        }
    }

    static fromJS(data: any): ModifyActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["onsiteStatusChange"] = this.onsiteStatusChange !== undefined ? this.onsiteStatusChange : <any>null;
        return data;
    }

    clone(): ModifyActivityDto {
        const json = this.toJSON();
        let result = new ModifyActivityDto();
        result.init(json);
        return result;
    }
}

export interface IModifyActivityDto {
    name: string;
    description: string;
    externalReference: string;
    onsiteStatusChange?: OnsiteStatusChange;
}

export class ApiResponseOfFileLoadDto extends ApiResponse implements IApiResponseOfFileLoadDto {
    result?: FileLoadDto | null;

    constructor(data?: IApiResponseOfFileLoadDto) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new FileLoadDto(data.result) : <FileLoadDto>this.result;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? FileLoadDto.fromJS(_data["result"]) : <any>null;
        }
    }

    static override fromJS(data: any): ApiResponseOfFileLoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfFileLoadDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiResponseOfFileLoadDto {
        const json = this.toJSON();
        let result = new ApiResponseOfFileLoadDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseOfFileLoadDto extends IApiResponse {
    result?: IFileLoadDto | null;
}

export class FileLoadDto implements IFileLoadDto {
    fileName?: string;
    total?: number;
    importedStatus?: boolean;
    fileErrors?: FileError[] | null;

    constructor(data?: IFileLoadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.fileErrors) {
                this.fileErrors = [];
                for (let i = 0; i < data.fileErrors.length; i++) {
                    let item = data.fileErrors[i];
                    this.fileErrors[i] = item && !(<any>item).toJSON ? new FileError(item) : <FileError>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.importedStatus = _data["importedStatus"] !== undefined ? _data["importedStatus"] : <any>null;
            if (Array.isArray(_data["fileErrors"])) {
                this.fileErrors = [] as any;
                for (let item of _data["fileErrors"])
                    this.fileErrors!.push(FileError.fromJS(item));
            }
            else {
                this.fileErrors = <any>null;
            }
        }
    }

    static fromJS(data: any): FileLoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileLoadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["importedStatus"] = this.importedStatus !== undefined ? this.importedStatus : <any>null;
        if (Array.isArray(this.fileErrors)) {
            data["fileErrors"] = [];
            for (let item of this.fileErrors)
                data["fileErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): FileLoadDto {
        const json = this.toJSON();
        let result = new FileLoadDto();
        result.init(json);
        return result;
    }
}

export interface IFileLoadDto {
    fileName?: string;
    total?: number;
    importedStatus?: boolean;
    fileErrors?: IFileError[] | null;
}

export class FileError implements IFileError {
    errorMessage?: string | null;

    constructor(data?: IFileError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): FileError {
        data = typeof data === 'object' ? data : {};
        let result = new FileError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }

    clone(): FileError {
        const json = this.toJSON();
        let result = new FileError();
        result.init(json);
        return result;
    }
}

export interface IFileError {
    errorMessage?: string | null;
}

export class ApiResponseOfActivityClockingResendDto extends ApiResponse implements IApiResponseOfActivityClockingResendDto {
    result?: ActivityClockingResendDto | null;

    constructor(data?: IApiResponseOfActivityClockingResendDto) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new ActivityClockingResendDto(data.result) : <ActivityClockingResendDto>this.result;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? ActivityClockingResendDto.fromJS(_data["result"]) : <any>null;
        }
    }

    static override fromJS(data: any): ApiResponseOfActivityClockingResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfActivityClockingResendDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiResponseOfActivityClockingResendDto {
        const json = this.toJSON();
        let result = new ApiResponseOfActivityClockingResendDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseOfActivityClockingResendDto extends IApiResponse {
    result?: IActivityClockingResendDto | null;
}

export class ActivityClockingResendDto implements IActivityClockingResendDto {
    remaining?: number;
    continuationSkipOffset?: number;

    constructor(data?: IActivityClockingResendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remaining = _data["remaining"] !== undefined ? _data["remaining"] : <any>null;
            this.continuationSkipOffset = _data["continuationSkipOffset"] !== undefined ? _data["continuationSkipOffset"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityClockingResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityClockingResendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remaining"] = this.remaining !== undefined ? this.remaining : <any>null;
        data["continuationSkipOffset"] = this.continuationSkipOffset !== undefined ? this.continuationSkipOffset : <any>null;
        return data;
    }

    clone(): ActivityClockingResendDto {
        const json = this.toJSON();
        let result = new ActivityClockingResendDto();
        result.init(json);
        return result;
    }
}

export interface IActivityClockingResendDto {
    remaining?: number;
    continuationSkipOffset?: number;
}

export class AddressDto implements IAddressDto {
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class CreateAreaDto implements ICreateAreaDto {
    siteId?: string;
    name!: string;

    constructor(data?: ICreateAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): CreateAreaDto {
        const json = this.toJSON();
        let result = new CreateAreaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAreaDto {
    siteId?: string;
    name: string;
}

export class AreaDto implements IAreaDto {
    id?: string;
    siteId?: string;
    name!: string;
    deviceGroups?: { [key: string]: DeviceGroupDto; } | null;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.deviceGroups) {
                this.deviceGroups = {};
                for (let key in data.deviceGroups) {
                    if (data.deviceGroups.hasOwnProperty(key)) {
                        let item = data.deviceGroups[key];
                        this.deviceGroups[key] = item && !(<any>item).toJSON ? new DeviceGroupDto(item) : <DeviceGroupDto>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (_data["deviceGroups"]) {
                this.deviceGroups = {} as any;
                for (let key in _data["deviceGroups"]) {
                    if (_data["deviceGroups"].hasOwnProperty(key))
                        (<any>this.deviceGroups)![key] = _data["deviceGroups"][key] ? DeviceGroupDto.fromJS(_data["deviceGroups"][key]) : new DeviceGroupDto();
                }
            }
            else {
                this.deviceGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (this.deviceGroups) {
            data["deviceGroups"] = {};
            for (let key in this.deviceGroups) {
                if (this.deviceGroups.hasOwnProperty(key))
                    (<any>data["deviceGroups"])[key] = this.deviceGroups[key] ? this.deviceGroups[key].toJSON() : <any>null;
            }
        }
        return data;
    }

    clone(): AreaDto {
        const json = this.toJSON();
        let result = new AreaDto();
        result.init(json);
        return result;
    }
}

export interface IAreaDto {
    id?: string;
    siteId?: string;
    name: string;
    deviceGroups?: { [key: string]: IDeviceGroupDto; } | null;
}

export class DeviceGroupDto implements IDeviceGroupDto {
    id?: string;
    areaId?: string;
    name!: string;
    deviceGroupType?: DeviceGroupType;
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    devices?: DeviceDto[] | null;
    entityVersion?: string;

    constructor(data?: IDeviceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.devices) {
                this.devices = [];
                for (let i = 0; i < data.devices.length; i++) {
                    let item = data.devices[i];
                    this.devices[i] = item && !(<any>item).toJSON ? new DeviceDto(item) : <DeviceDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.deviceGroupType = _data["deviceGroupType"] !== undefined ? _data["deviceGroupType"] : <any>null;
            this.scheduleRotationType = _data["scheduleRotationType"] !== undefined ? _data["scheduleRotationType"] : <any>null;
            this.scheduleRotationLength = _data["scheduleRotationLength"] !== undefined ? _data["scheduleRotationLength"] : <any>null;
            this.scheduleBaseDate = _data["scheduleBaseDate"] ? new Date(_data["scheduleBaseDate"].toString()) : <any>null;
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDto.fromJS(item));
            }
            else {
                this.devices = <any>null;
            }
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["deviceGroupType"] = this.deviceGroupType !== undefined ? this.deviceGroupType : <any>null;
        data["scheduleRotationType"] = this.scheduleRotationType !== undefined ? this.scheduleRotationType : <any>null;
        data["scheduleRotationLength"] = this.scheduleRotationLength !== undefined ? this.scheduleRotationLength : <any>null;
        data["scheduleBaseDate"] = this.scheduleBaseDate ? this.scheduleBaseDate.toISOString() : <any>null;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): DeviceGroupDto {
        const json = this.toJSON();
        let result = new DeviceGroupDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceGroupDto {
    id?: string;
    areaId?: string;
    name: string;
    deviceGroupType?: DeviceGroupType;
    scheduleRotationType?: ScheduleRotationType;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    devices?: IDeviceDto[] | null;
    entityVersion?: string;
}

export enum DeviceGroupType {
    None = 0,
    ClockingTerminal = 1,
    AccessPoint = 2,
}

export class DeviceDto implements IDeviceDto {
    id?: string;
    businessAccountId?: string;
    deviceGroupId?: string | null;
    siteId?: string | null;
    name!: string;
    deviceType?: DeviceType;
    serialNumber?: string | null;
    firstRegistrationDate?: Date | null;
    lastRegistrationDate?: Date | null;
    engineerPin?: string | null;
    engineerUserId?: string;
    engineerPinExpiryDate?: Date | null;
    deviceActive?: boolean;
    external?: boolean;
    currentFirmwareVersion?: string | null;
    deviceUpgradeState?: DeviceUpgradeStateDto | null;
    entityVersion?: string;
    configuration?: DeviceConfigurationDto | null;
    thirdPartyReaders?: ThirdPartyReaderDto[] | null;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.deviceUpgradeState = data.deviceUpgradeState && !(<any>data.deviceUpgradeState).toJSON ? new DeviceUpgradeStateDto(data.deviceUpgradeState) : <DeviceUpgradeStateDto>this.deviceUpgradeState;
            this.configuration = data.configuration && !(<any>data.configuration).toJSON ? new DeviceConfigurationDto(data.configuration) : <DeviceConfigurationDto>this.configuration;
            if (data.thirdPartyReaders) {
                this.thirdPartyReaders = [];
                for (let i = 0; i < data.thirdPartyReaders.length; i++) {
                    let item = data.thirdPartyReaders[i];
                    this.thirdPartyReaders[i] = item && !(<any>item).toJSON ? new ThirdPartyReaderDto(item) : <ThirdPartyReaderDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.deviceGroupId = _data["deviceGroupId"] !== undefined ? _data["deviceGroupId"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.deviceType = _data["deviceType"] !== undefined ? _data["deviceType"] : <any>null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
            this.firstRegistrationDate = _data["firstRegistrationDate"] ? new Date(_data["firstRegistrationDate"].toString()) : <any>null;
            this.lastRegistrationDate = _data["lastRegistrationDate"] ? new Date(_data["lastRegistrationDate"].toString()) : <any>null;
            this.engineerPin = _data["engineerPin"] !== undefined ? _data["engineerPin"] : <any>null;
            this.engineerUserId = _data["engineerUserId"] !== undefined ? _data["engineerUserId"] : <any>null;
            this.engineerPinExpiryDate = _data["engineerPinExpiryDate"] ? new Date(_data["engineerPinExpiryDate"].toString()) : <any>null;
            this.deviceActive = _data["deviceActive"] !== undefined ? _data["deviceActive"] : <any>null;
            this.external = _data["external"] !== undefined ? _data["external"] : <any>null;
            this.currentFirmwareVersion = _data["currentFirmwareVersion"] !== undefined ? _data["currentFirmwareVersion"] : <any>null;
            this.deviceUpgradeState = _data["deviceUpgradeState"] ? DeviceUpgradeStateDto.fromJS(_data["deviceUpgradeState"]) : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
            this.configuration = _data["configuration"] ? DeviceConfigurationDto.fromJS(_data["configuration"]) : <any>null;
            if (Array.isArray(_data["thirdPartyReaders"])) {
                this.thirdPartyReaders = [] as any;
                for (let item of _data["thirdPartyReaders"])
                    this.thirdPartyReaders!.push(ThirdPartyReaderDto.fromJS(item));
            }
            else {
                this.thirdPartyReaders = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["deviceGroupId"] = this.deviceGroupId !== undefined ? this.deviceGroupId : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["deviceType"] = this.deviceType !== undefined ? this.deviceType : <any>null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        data["firstRegistrationDate"] = this.firstRegistrationDate ? this.firstRegistrationDate.toISOString() : <any>null;
        data["lastRegistrationDate"] = this.lastRegistrationDate ? this.lastRegistrationDate.toISOString() : <any>null;
        data["engineerPin"] = this.engineerPin !== undefined ? this.engineerPin : <any>null;
        data["engineerUserId"] = this.engineerUserId !== undefined ? this.engineerUserId : <any>null;
        data["engineerPinExpiryDate"] = this.engineerPinExpiryDate ? this.engineerPinExpiryDate.toISOString() : <any>null;
        data["deviceActive"] = this.deviceActive !== undefined ? this.deviceActive : <any>null;
        data["external"] = this.external !== undefined ? this.external : <any>null;
        data["currentFirmwareVersion"] = this.currentFirmwareVersion !== undefined ? this.currentFirmwareVersion : <any>null;
        data["deviceUpgradeState"] = this.deviceUpgradeState ? this.deviceUpgradeState.toJSON() : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        if (Array.isArray(this.thirdPartyReaders)) {
            data["thirdPartyReaders"] = [];
            for (let item of this.thirdPartyReaders)
                data["thirdPartyReaders"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeviceDto {
        const json = this.toJSON();
        let result = new DeviceDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceDto {
    id?: string;
    businessAccountId?: string;
    deviceGroupId?: string | null;
    siteId?: string | null;
    name: string;
    deviceType?: DeviceType;
    serialNumber?: string | null;
    firstRegistrationDate?: Date | null;
    lastRegistrationDate?: Date | null;
    engineerPin?: string | null;
    engineerUserId?: string;
    engineerPinExpiryDate?: Date | null;
    deviceActive?: boolean;
    external?: boolean;
    currentFirmwareVersion?: string | null;
    deviceUpgradeState?: IDeviceUpgradeStateDto | null;
    entityVersion?: string;
    configuration?: IDeviceConfigurationDto | null;
    thirdPartyReaders?: IThirdPartyReaderDto[] | null;
}

export enum DeviceType {
    None = 0,
    T2 = 1,
    T1 = 2,
    T2V2 = 3,
}

export class DeviceUpgradeStateDto implements IDeviceUpgradeStateDto {
    id?: string;
    deviceId?: string;
    firmwareVersion?: string | null;
    upgradeProcessState?: UpgradeProcessState;
    timeOfChange?: Date;
    attempts?: number;
    retry?: boolean;

    constructor(data?: IDeviceUpgradeStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.firmwareVersion = _data["firmwareVersion"] !== undefined ? _data["firmwareVersion"] : <any>null;
            this.upgradeProcessState = _data["upgradeProcessState"] !== undefined ? _data["upgradeProcessState"] : <any>null;
            this.timeOfChange = _data["timeOfChange"] ? new Date(_data["timeOfChange"].toString()) : <any>null;
            this.attempts = _data["attempts"] !== undefined ? _data["attempts"] : <any>null;
            this.retry = _data["retry"] !== undefined ? _data["retry"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceUpgradeStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceUpgradeStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["firmwareVersion"] = this.firmwareVersion !== undefined ? this.firmwareVersion : <any>null;
        data["upgradeProcessState"] = this.upgradeProcessState !== undefined ? this.upgradeProcessState : <any>null;
        data["timeOfChange"] = this.timeOfChange ? this.timeOfChange.toISOString() : <any>null;
        data["attempts"] = this.attempts !== undefined ? this.attempts : <any>null;
        data["retry"] = this.retry !== undefined ? this.retry : <any>null;
        return data;
    }

    clone(): DeviceUpgradeStateDto {
        const json = this.toJSON();
        let result = new DeviceUpgradeStateDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceUpgradeStateDto {
    id?: string;
    deviceId?: string;
    firmwareVersion?: string | null;
    upgradeProcessState?: UpgradeProcessState;
    timeOfChange?: Date;
    attempts?: number;
    retry?: boolean;
}

export enum UpgradeProcessState {
    None = 0,
    Scheduled = 1,
    Started = 2,
    Completed = 3,
    Failed = 4,
}

export class DeviceConfigurationDto implements IDeviceConfigurationDto {
    language?: string | null;
    timezone?: string | null;
    portalLogLevel?: number;
    authenticationConfiguration?: AuthenticationConfigurationDto | null;
    alertsConfiguration?: AlertsConfigurationDto | null;
    userAuthenticationConfiguration?: UserAuthenticationDto | null;
    portalLinksConfiguration?: PortalLinksConfigurationDto | null;
    deviceSettingConfiguration?: DeviceSettingConfigurationDto | null;
    proximityReadersConfiguration?: ProximityReadersConfigurationDto | null;

    constructor(data?: IDeviceConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authenticationConfiguration = data.authenticationConfiguration && !(<any>data.authenticationConfiguration).toJSON ? new AuthenticationConfigurationDto(data.authenticationConfiguration) : <AuthenticationConfigurationDto>this.authenticationConfiguration;
            this.alertsConfiguration = data.alertsConfiguration && !(<any>data.alertsConfiguration).toJSON ? new AlertsConfigurationDto(data.alertsConfiguration) : <AlertsConfigurationDto>this.alertsConfiguration;
            this.userAuthenticationConfiguration = data.userAuthenticationConfiguration && !(<any>data.userAuthenticationConfiguration).toJSON ? new UserAuthenticationDto(data.userAuthenticationConfiguration) : <UserAuthenticationDto>this.userAuthenticationConfiguration;
            this.portalLinksConfiguration = data.portalLinksConfiguration && !(<any>data.portalLinksConfiguration).toJSON ? new PortalLinksConfigurationDto(data.portalLinksConfiguration) : <PortalLinksConfigurationDto>this.portalLinksConfiguration;
            this.deviceSettingConfiguration = data.deviceSettingConfiguration && !(<any>data.deviceSettingConfiguration).toJSON ? new DeviceSettingConfigurationDto(data.deviceSettingConfiguration) : <DeviceSettingConfigurationDto>this.deviceSettingConfiguration;
            this.proximityReadersConfiguration = data.proximityReadersConfiguration && !(<any>data.proximityReadersConfiguration).toJSON ? new ProximityReadersConfigurationDto(data.proximityReadersConfiguration) : <ProximityReadersConfigurationDto>this.proximityReadersConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.timezone = _data["timezone"] !== undefined ? _data["timezone"] : <any>null;
            this.portalLogLevel = _data["portalLogLevel"] !== undefined ? _data["portalLogLevel"] : <any>null;
            this.authenticationConfiguration = _data["authenticationConfiguration"] ? AuthenticationConfigurationDto.fromJS(_data["authenticationConfiguration"]) : <any>null;
            this.alertsConfiguration = _data["alertsConfiguration"] ? AlertsConfigurationDto.fromJS(_data["alertsConfiguration"]) : <any>null;
            this.userAuthenticationConfiguration = _data["userAuthenticationConfiguration"] ? UserAuthenticationDto.fromJS(_data["userAuthenticationConfiguration"]) : <any>null;
            this.portalLinksConfiguration = _data["portalLinksConfiguration"] ? PortalLinksConfigurationDto.fromJS(_data["portalLinksConfiguration"]) : <any>null;
            this.deviceSettingConfiguration = _data["deviceSettingConfiguration"] ? DeviceSettingConfigurationDto.fromJS(_data["deviceSettingConfiguration"]) : <any>null;
            this.proximityReadersConfiguration = _data["proximityReadersConfiguration"] ? ProximityReadersConfigurationDto.fromJS(_data["proximityReadersConfiguration"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviceConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["timezone"] = this.timezone !== undefined ? this.timezone : <any>null;
        data["portalLogLevel"] = this.portalLogLevel !== undefined ? this.portalLogLevel : <any>null;
        data["authenticationConfiguration"] = this.authenticationConfiguration ? this.authenticationConfiguration.toJSON() : <any>null;
        data["alertsConfiguration"] = this.alertsConfiguration ? this.alertsConfiguration.toJSON() : <any>null;
        data["userAuthenticationConfiguration"] = this.userAuthenticationConfiguration ? this.userAuthenticationConfiguration.toJSON() : <any>null;
        data["portalLinksConfiguration"] = this.portalLinksConfiguration ? this.portalLinksConfiguration.toJSON() : <any>null;
        data["deviceSettingConfiguration"] = this.deviceSettingConfiguration ? this.deviceSettingConfiguration.toJSON() : <any>null;
        data["proximityReadersConfiguration"] = this.proximityReadersConfiguration ? this.proximityReadersConfiguration.toJSON() : <any>null;
        return data;
    }

    clone(): DeviceConfigurationDto {
        const json = this.toJSON();
        let result = new DeviceConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceConfigurationDto {
    language?: string | null;
    timezone?: string | null;
    portalLogLevel?: number;
    authenticationConfiguration?: IAuthenticationConfigurationDto | null;
    alertsConfiguration?: IAlertsConfigurationDto | null;
    userAuthenticationConfiguration?: IUserAuthenticationDto | null;
    portalLinksConfiguration?: IPortalLinksConfigurationDto | null;
    deviceSettingConfiguration?: IDeviceSettingConfigurationDto | null;
    proximityReadersConfiguration?: IProximityReadersConfigurationDto | null;
}

export class AuthenticationConfigurationDto implements IAuthenticationConfigurationDto {
    fingerprintConfiguration?: FingerprintConfigurationDto | null;
    faceprintConfiguration?: FaceprintConfigurationDto | null;
    proximityCardConfiguration?: ProximityCardConfigurationDto | null;
    userPinConfiguration?: UserPinConfigurationDto | null;

    constructor(data?: IAuthenticationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.fingerprintConfiguration = data.fingerprintConfiguration && !(<any>data.fingerprintConfiguration).toJSON ? new FingerprintConfigurationDto(data.fingerprintConfiguration) : <FingerprintConfigurationDto>this.fingerprintConfiguration;
            this.faceprintConfiguration = data.faceprintConfiguration && !(<any>data.faceprintConfiguration).toJSON ? new FaceprintConfigurationDto(data.faceprintConfiguration) : <FaceprintConfigurationDto>this.faceprintConfiguration;
            this.proximityCardConfiguration = data.proximityCardConfiguration && !(<any>data.proximityCardConfiguration).toJSON ? new ProximityCardConfigurationDto(data.proximityCardConfiguration) : <ProximityCardConfigurationDto>this.proximityCardConfiguration;
            this.userPinConfiguration = data.userPinConfiguration && !(<any>data.userPinConfiguration).toJSON ? new UserPinConfigurationDto(data.userPinConfiguration) : <UserPinConfigurationDto>this.userPinConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fingerprintConfiguration = _data["fingerprintConfiguration"] ? FingerprintConfigurationDto.fromJS(_data["fingerprintConfiguration"]) : <any>null;
            this.faceprintConfiguration = _data["faceprintConfiguration"] ? FaceprintConfigurationDto.fromJS(_data["faceprintConfiguration"]) : <any>null;
            this.proximityCardConfiguration = _data["proximityCardConfiguration"] ? ProximityCardConfigurationDto.fromJS(_data["proximityCardConfiguration"]) : <any>null;
            this.userPinConfiguration = _data["userPinConfiguration"] ? UserPinConfigurationDto.fromJS(_data["userPinConfiguration"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthenticationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fingerprintConfiguration"] = this.fingerprintConfiguration ? this.fingerprintConfiguration.toJSON() : <any>null;
        data["faceprintConfiguration"] = this.faceprintConfiguration ? this.faceprintConfiguration.toJSON() : <any>null;
        data["proximityCardConfiguration"] = this.proximityCardConfiguration ? this.proximityCardConfiguration.toJSON() : <any>null;
        data["userPinConfiguration"] = this.userPinConfiguration ? this.userPinConfiguration.toJSON() : <any>null;
        return data;
    }

    clone(): AuthenticationConfigurationDto {
        const json = this.toJSON();
        let result = new AuthenticationConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationConfigurationDto {
    fingerprintConfiguration?: IFingerprintConfigurationDto | null;
    faceprintConfiguration?: IFaceprintConfigurationDto | null;
    proximityCardConfiguration?: IProximityCardConfigurationDto | null;
    userPinConfiguration?: IUserPinConfigurationDto | null;
}

export class FingerprintConfigurationDto implements IFingerprintConfigurationDto {
    numberOfFingerprintsToCapture?: number;
    fingerprintAuthenticationMandatory?: boolean;
    usersCanDeleteFingerprintFromAccount?: boolean;
    engineersTestFingerprintExpiry?: number;
    fingerToggleEnabled?: boolean;
    verifyThreshold?: number;
    impressions?: number;
    sleepBetweenImpressions?: number;
    fingerSecurityLevel?: number;

    constructor(data?: IFingerprintConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfFingerprintsToCapture = _data["numberOfFingerprintsToCapture"] !== undefined ? _data["numberOfFingerprintsToCapture"] : <any>null;
            this.fingerprintAuthenticationMandatory = _data["fingerprintAuthenticationMandatory"] !== undefined ? _data["fingerprintAuthenticationMandatory"] : <any>null;
            this.usersCanDeleteFingerprintFromAccount = _data["usersCanDeleteFingerprintFromAccount"] !== undefined ? _data["usersCanDeleteFingerprintFromAccount"] : <any>null;
            this.engineersTestFingerprintExpiry = _data["engineersTestFingerprintExpiry"] !== undefined ? _data["engineersTestFingerprintExpiry"] : <any>null;
            this.fingerToggleEnabled = _data["fingerToggleEnabled"] !== undefined ? _data["fingerToggleEnabled"] : <any>null;
            this.verifyThreshold = _data["verifyThreshold"] !== undefined ? _data["verifyThreshold"] : <any>null;
            this.impressions = _data["impressions"] !== undefined ? _data["impressions"] : <any>null;
            this.sleepBetweenImpressions = _data["sleepBetweenImpressions"] !== undefined ? _data["sleepBetweenImpressions"] : <any>null;
            this.fingerSecurityLevel = _data["fingerSecurityLevel"] !== undefined ? _data["fingerSecurityLevel"] : <any>null;
        }
    }

    static fromJS(data: any): FingerprintConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FingerprintConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfFingerprintsToCapture"] = this.numberOfFingerprintsToCapture !== undefined ? this.numberOfFingerprintsToCapture : <any>null;
        data["fingerprintAuthenticationMandatory"] = this.fingerprintAuthenticationMandatory !== undefined ? this.fingerprintAuthenticationMandatory : <any>null;
        data["usersCanDeleteFingerprintFromAccount"] = this.usersCanDeleteFingerprintFromAccount !== undefined ? this.usersCanDeleteFingerprintFromAccount : <any>null;
        data["engineersTestFingerprintExpiry"] = this.engineersTestFingerprintExpiry !== undefined ? this.engineersTestFingerprintExpiry : <any>null;
        data["fingerToggleEnabled"] = this.fingerToggleEnabled !== undefined ? this.fingerToggleEnabled : <any>null;
        data["verifyThreshold"] = this.verifyThreshold !== undefined ? this.verifyThreshold : <any>null;
        data["impressions"] = this.impressions !== undefined ? this.impressions : <any>null;
        data["sleepBetweenImpressions"] = this.sleepBetweenImpressions !== undefined ? this.sleepBetweenImpressions : <any>null;
        data["fingerSecurityLevel"] = this.fingerSecurityLevel !== undefined ? this.fingerSecurityLevel : <any>null;
        return data;
    }

    clone(): FingerprintConfigurationDto {
        const json = this.toJSON();
        let result = new FingerprintConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IFingerprintConfigurationDto {
    numberOfFingerprintsToCapture?: number;
    fingerprintAuthenticationMandatory?: boolean;
    usersCanDeleteFingerprintFromAccount?: boolean;
    engineersTestFingerprintExpiry?: number;
    fingerToggleEnabled?: boolean;
    verifyThreshold?: number;
    impressions?: number;
    sleepBetweenImpressions?: number;
    fingerSecurityLevel?: number;
}

export class FaceprintConfigurationDto implements IFaceprintConfigurationDto {
    wakeMovementThreshold!: number;
    wakeRequireFace!: boolean;
    minimumFaceSize!: number;
    wakeFaceScale!: number;
    faceIdScale!: number;
    defaultToFaceId!: boolean;
    faceToggleEnabled!: boolean;
    livenessEnabled!: boolean;
    livenessGazeThreshold!: number;
    targetGazeRatio!: number;
    faceSecurityLevel!: number;

    constructor(data?: IFaceprintConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wakeMovementThreshold = _data["wakeMovementThreshold"] !== undefined ? _data["wakeMovementThreshold"] : <any>null;
            this.wakeRequireFace = _data["wakeRequireFace"] !== undefined ? _data["wakeRequireFace"] : <any>null;
            this.minimumFaceSize = _data["minimumFaceSize"] !== undefined ? _data["minimumFaceSize"] : <any>null;
            this.wakeFaceScale = _data["wakeFaceScale"] !== undefined ? _data["wakeFaceScale"] : <any>null;
            this.faceIdScale = _data["faceIdScale"] !== undefined ? _data["faceIdScale"] : <any>null;
            this.defaultToFaceId = _data["defaultToFaceId"] !== undefined ? _data["defaultToFaceId"] : <any>null;
            this.faceToggleEnabled = _data["faceToggleEnabled"] !== undefined ? _data["faceToggleEnabled"] : <any>null;
            this.livenessEnabled = _data["livenessEnabled"] !== undefined ? _data["livenessEnabled"] : <any>null;
            this.livenessGazeThreshold = _data["livenessGazeThreshold"] !== undefined ? _data["livenessGazeThreshold"] : <any>null;
            this.targetGazeRatio = _data["targetGazeRatio"] !== undefined ? _data["targetGazeRatio"] : <any>null;
            this.faceSecurityLevel = _data["faceSecurityLevel"] !== undefined ? _data["faceSecurityLevel"] : <any>null;
        }
    }

    static fromJS(data: any): FaceprintConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceprintConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wakeMovementThreshold"] = this.wakeMovementThreshold !== undefined ? this.wakeMovementThreshold : <any>null;
        data["wakeRequireFace"] = this.wakeRequireFace !== undefined ? this.wakeRequireFace : <any>null;
        data["minimumFaceSize"] = this.minimumFaceSize !== undefined ? this.minimumFaceSize : <any>null;
        data["wakeFaceScale"] = this.wakeFaceScale !== undefined ? this.wakeFaceScale : <any>null;
        data["faceIdScale"] = this.faceIdScale !== undefined ? this.faceIdScale : <any>null;
        data["defaultToFaceId"] = this.defaultToFaceId !== undefined ? this.defaultToFaceId : <any>null;
        data["faceToggleEnabled"] = this.faceToggleEnabled !== undefined ? this.faceToggleEnabled : <any>null;
        data["livenessEnabled"] = this.livenessEnabled !== undefined ? this.livenessEnabled : <any>null;
        data["livenessGazeThreshold"] = this.livenessGazeThreshold !== undefined ? this.livenessGazeThreshold : <any>null;
        data["targetGazeRatio"] = this.targetGazeRatio !== undefined ? this.targetGazeRatio : <any>null;
        data["faceSecurityLevel"] = this.faceSecurityLevel !== undefined ? this.faceSecurityLevel : <any>null;
        return data;
    }

    clone(): FaceprintConfigurationDto {
        const json = this.toJSON();
        let result = new FaceprintConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IFaceprintConfigurationDto {
    wakeMovementThreshold: number;
    wakeRequireFace: boolean;
    minimumFaceSize: number;
    wakeFaceScale: number;
    faceIdScale: number;
    defaultToFaceId: boolean;
    faceToggleEnabled: boolean;
    livenessEnabled: boolean;
    livenessGazeThreshold: number;
    targetGazeRatio: number;
    faceSecurityLevel: number;
}

export class ProximityCardConfigurationDto implements IProximityCardConfigurationDto {
    proxCardType!: ProxCardType;
    badgeFormatMfProx!: string;
    mifareSectorNumber!: number;
    mifareBlockNumber!: number;
    mifareEncryptionKey!: string;
    mifareKeyClass!: MifareKeyClassType;
    mifareEncoding!: CardEncodingType;
    proxCardAuthenticationMandatory!: boolean;
    usersCanDeleteProxCardFromAccount!: boolean;
    proxCardToggleEnabled!: boolean;
    mifareBadgeOffset!: number;
    mifareBadgeLength!: number;

    constructor(data?: IProximityCardConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proxCardType = _data["proxCardType"] !== undefined ? _data["proxCardType"] : <any>null;
            this.badgeFormatMfProx = _data["badgeFormatMfProx"] !== undefined ? _data["badgeFormatMfProx"] : <any>null;
            this.mifareSectorNumber = _data["mifareSectorNumber"] !== undefined ? _data["mifareSectorNumber"] : <any>null;
            this.mifareBlockNumber = _data["mifareBlockNumber"] !== undefined ? _data["mifareBlockNumber"] : <any>null;
            this.mifareEncryptionKey = _data["mifareEncryptionKey"] !== undefined ? _data["mifareEncryptionKey"] : <any>null;
            this.mifareKeyClass = _data["mifareKeyClass"] !== undefined ? _data["mifareKeyClass"] : <any>null;
            this.mifareEncoding = _data["mifareEncoding"] !== undefined ? _data["mifareEncoding"] : <any>null;
            this.proxCardAuthenticationMandatory = _data["proxCardAuthenticationMandatory"] !== undefined ? _data["proxCardAuthenticationMandatory"] : <any>null;
            this.usersCanDeleteProxCardFromAccount = _data["usersCanDeleteProxCardFromAccount"] !== undefined ? _data["usersCanDeleteProxCardFromAccount"] : <any>null;
            this.proxCardToggleEnabled = _data["proxCardToggleEnabled"] !== undefined ? _data["proxCardToggleEnabled"] : <any>null;
            this.mifareBadgeOffset = _data["mifareBadgeOffset"] !== undefined ? _data["mifareBadgeOffset"] : <any>null;
            this.mifareBadgeLength = _data["mifareBadgeLength"] !== undefined ? _data["mifareBadgeLength"] : <any>null;
        }
    }

    static fromJS(data: any): ProximityCardConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProximityCardConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proxCardType"] = this.proxCardType !== undefined ? this.proxCardType : <any>null;
        data["badgeFormatMfProx"] = this.badgeFormatMfProx !== undefined ? this.badgeFormatMfProx : <any>null;
        data["mifareSectorNumber"] = this.mifareSectorNumber !== undefined ? this.mifareSectorNumber : <any>null;
        data["mifareBlockNumber"] = this.mifareBlockNumber !== undefined ? this.mifareBlockNumber : <any>null;
        data["mifareEncryptionKey"] = this.mifareEncryptionKey !== undefined ? this.mifareEncryptionKey : <any>null;
        data["mifareKeyClass"] = this.mifareKeyClass !== undefined ? this.mifareKeyClass : <any>null;
        data["mifareEncoding"] = this.mifareEncoding !== undefined ? this.mifareEncoding : <any>null;
        data["proxCardAuthenticationMandatory"] = this.proxCardAuthenticationMandatory !== undefined ? this.proxCardAuthenticationMandatory : <any>null;
        data["usersCanDeleteProxCardFromAccount"] = this.usersCanDeleteProxCardFromAccount !== undefined ? this.usersCanDeleteProxCardFromAccount : <any>null;
        data["proxCardToggleEnabled"] = this.proxCardToggleEnabled !== undefined ? this.proxCardToggleEnabled : <any>null;
        data["mifareBadgeOffset"] = this.mifareBadgeOffset !== undefined ? this.mifareBadgeOffset : <any>null;
        data["mifareBadgeLength"] = this.mifareBadgeLength !== undefined ? this.mifareBadgeLength : <any>null;
        return data;
    }

    clone(): ProximityCardConfigurationDto {
        const json = this.toJSON();
        let result = new ProximityCardConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IProximityCardConfigurationDto {
    proxCardType: ProxCardType;
    badgeFormatMfProx: string;
    mifareSectorNumber: number;
    mifareBlockNumber: number;
    mifareEncryptionKey: string;
    mifareKeyClass: MifareKeyClassType;
    mifareEncoding: CardEncodingType;
    proxCardAuthenticationMandatory: boolean;
    usersCanDeleteProxCardFromAccount: boolean;
    proxCardToggleEnabled: boolean;
    mifareBadgeOffset: number;
    mifareBadgeLength: number;
}

export enum ProxCardType {
    MfProx = 0,
    HiTag = 1,
}

export enum MifareKeyClassType {
    KeyA = 0,
    KeyB = 1,
}

export enum CardEncodingType {
    Integer = 0,
    ASCII = 1,
}

export class UserPinConfigurationDto implements IUserPinConfigurationDto {
    userPinLength?: number;
    userPinAuthenticationMandatory?: boolean;
    usersCanChangePinFromAccount?: boolean;

    constructor(data?: IUserPinConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPinLength = _data["userPinLength"] !== undefined ? _data["userPinLength"] : <any>null;
            this.userPinAuthenticationMandatory = _data["userPinAuthenticationMandatory"] !== undefined ? _data["userPinAuthenticationMandatory"] : <any>null;
            this.usersCanChangePinFromAccount = _data["usersCanChangePinFromAccount"] !== undefined ? _data["usersCanChangePinFromAccount"] : <any>null;
        }
    }

    static fromJS(data: any): UserPinConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPinConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPinLength"] = this.userPinLength !== undefined ? this.userPinLength : <any>null;
        data["userPinAuthenticationMandatory"] = this.userPinAuthenticationMandatory !== undefined ? this.userPinAuthenticationMandatory : <any>null;
        data["usersCanChangePinFromAccount"] = this.usersCanChangePinFromAccount !== undefined ? this.usersCanChangePinFromAccount : <any>null;
        return data;
    }

    clone(): UserPinConfigurationDto {
        const json = this.toJSON();
        let result = new UserPinConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IUserPinConfigurationDto {
    userPinLength?: number;
    userPinAuthenticationMandatory?: boolean;
    usersCanChangePinFromAccount?: boolean;
}

export class AlertsConfigurationDto implements IAlertsConfigurationDto {
    alertOnBatteryConfiguration?: AlertOnBatteryConfigurationDto | null;
    alertConnectionDownConfiguration?: AlertConnectionDownConfigurationDto | null;

    constructor(data?: IAlertsConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.alertOnBatteryConfiguration = data.alertOnBatteryConfiguration && !(<any>data.alertOnBatteryConfiguration).toJSON ? new AlertOnBatteryConfigurationDto(data.alertOnBatteryConfiguration) : <AlertOnBatteryConfigurationDto>this.alertOnBatteryConfiguration;
            this.alertConnectionDownConfiguration = data.alertConnectionDownConfiguration && !(<any>data.alertConnectionDownConfiguration).toJSON ? new AlertConnectionDownConfigurationDto(data.alertConnectionDownConfiguration) : <AlertConnectionDownConfigurationDto>this.alertConnectionDownConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertOnBatteryConfiguration = _data["alertOnBatteryConfiguration"] ? AlertOnBatteryConfigurationDto.fromJS(_data["alertOnBatteryConfiguration"]) : <any>null;
            this.alertConnectionDownConfiguration = _data["alertConnectionDownConfiguration"] ? AlertConnectionDownConfigurationDto.fromJS(_data["alertConnectionDownConfiguration"]) : <any>null;
        }
    }

    static fromJS(data: any): AlertsConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertOnBatteryConfiguration"] = this.alertOnBatteryConfiguration ? this.alertOnBatteryConfiguration.toJSON() : <any>null;
        data["alertConnectionDownConfiguration"] = this.alertConnectionDownConfiguration ? this.alertConnectionDownConfiguration.toJSON() : <any>null;
        return data;
    }

    clone(): AlertsConfigurationDto {
        const json = this.toJSON();
        let result = new AlertsConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAlertsConfigurationDto {
    alertOnBatteryConfiguration?: IAlertOnBatteryConfigurationDto | null;
    alertConnectionDownConfiguration?: IAlertConnectionDownConfigurationDto | null;
}

export class AlertOnBatteryConfigurationDto implements IAlertOnBatteryConfigurationDto {
    active?: boolean;
    sms?: boolean;
    email?: boolean;

    constructor(data?: IAlertOnBatteryConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.sms = _data["sms"] !== undefined ? _data["sms"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): AlertOnBatteryConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertOnBatteryConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["sms"] = this.sms !== undefined ? this.sms : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): AlertOnBatteryConfigurationDto {
        const json = this.toJSON();
        let result = new AlertOnBatteryConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAlertOnBatteryConfigurationDto {
    active?: boolean;
    sms?: boolean;
    email?: boolean;
}

export class AlertConnectionDownConfigurationDto implements IAlertConnectionDownConfigurationDto {
    active?: boolean;
    sms?: boolean;
    email?: boolean;

    constructor(data?: IAlertConnectionDownConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.sms = _data["sms"] !== undefined ? _data["sms"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): AlertConnectionDownConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertConnectionDownConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["sms"] = this.sms !== undefined ? this.sms : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): AlertConnectionDownConfigurationDto {
        const json = this.toJSON();
        let result = new AlertConnectionDownConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAlertConnectionDownConfigurationDto {
    active?: boolean;
    sms?: boolean;
    email?: boolean;
}

export class UserAuthenticationDto implements IUserAuthenticationDto {
    fingerprint?: boolean;
    proxCard?: boolean;
    faceprint?: boolean;
    userPin?: boolean;
    fingerprintCard?: boolean;
    faceCard?: boolean;

    constructor(data?: IUserAuthenticationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fingerprint = _data["fingerprint"] !== undefined ? _data["fingerprint"] : <any>null;
            this.proxCard = _data["proxCard"] !== undefined ? _data["proxCard"] : <any>null;
            this.faceprint = _data["faceprint"] !== undefined ? _data["faceprint"] : <any>null;
            this.userPin = _data["userPin"] !== undefined ? _data["userPin"] : <any>null;
            this.fingerprintCard = _data["fingerprintCard"] !== undefined ? _data["fingerprintCard"] : <any>null;
            this.faceCard = _data["faceCard"] !== undefined ? _data["faceCard"] : <any>null;
        }
    }

    static fromJS(data: any): UserAuthenticationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthenticationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fingerprint"] = this.fingerprint !== undefined ? this.fingerprint : <any>null;
        data["proxCard"] = this.proxCard !== undefined ? this.proxCard : <any>null;
        data["faceprint"] = this.faceprint !== undefined ? this.faceprint : <any>null;
        data["userPin"] = this.userPin !== undefined ? this.userPin : <any>null;
        data["fingerprintCard"] = this.fingerprintCard !== undefined ? this.fingerprintCard : <any>null;
        data["faceCard"] = this.faceCard !== undefined ? this.faceCard : <any>null;
        return data;
    }

    clone(): UserAuthenticationDto {
        const json = this.toJSON();
        let result = new UserAuthenticationDto();
        result.init(json);
        return result;
    }
}

export interface IUserAuthenticationDto {
    fingerprint?: boolean;
    proxCard?: boolean;
    faceprint?: boolean;
    userPin?: boolean;
    fingerprintCard?: boolean;
    faceCard?: boolean;
}

export class PortalLinksConfigurationDto implements IPortalLinksConfigurationDto {
    mfSecureLink?: boolean;

    constructor(data?: IPortalLinksConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mfSecureLink = _data["mfSecureLink"] !== undefined ? _data["mfSecureLink"] : <any>null;
        }
    }

    static fromJS(data: any): PortalLinksConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalLinksConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mfSecureLink"] = this.mfSecureLink !== undefined ? this.mfSecureLink : <any>null;
        return data;
    }

    clone(): PortalLinksConfigurationDto {
        const json = this.toJSON();
        let result = new PortalLinksConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IPortalLinksConfigurationDto {
    mfSecureLink?: boolean;
}

export class DeviceSettingConfigurationDto implements IDeviceSettingConfigurationDto {
    deviceLedOn?: boolean;
    deviceVolume?: number;
    homeScreenLayout?: HomeScreenLayoutType;
    showClockingResultScreen?: boolean;
    directionlessClockOnsiteStatusChange?: OnsiteStatusChange;
    clockInOnsiteStatusChange?: OnsiteStatusChange;
    clockOutOnsiteStatusChange?: OnsiteStatusChange;

    constructor(data?: IDeviceSettingConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceLedOn = _data["deviceLedOn"] !== undefined ? _data["deviceLedOn"] : <any>null;
            this.deviceVolume = _data["deviceVolume"] !== undefined ? _data["deviceVolume"] : <any>null;
            this.homeScreenLayout = _data["homeScreenLayout"] !== undefined ? _data["homeScreenLayout"] : <any>null;
            this.showClockingResultScreen = _data["showClockingResultScreen"] !== undefined ? _data["showClockingResultScreen"] : <any>null;
            this.directionlessClockOnsiteStatusChange = _data["directionlessClockOnsiteStatusChange"] !== undefined ? _data["directionlessClockOnsiteStatusChange"] : <any>null;
            this.clockInOnsiteStatusChange = _data["clockInOnsiteStatusChange"] !== undefined ? _data["clockInOnsiteStatusChange"] : <any>null;
            this.clockOutOnsiteStatusChange = _data["clockOutOnsiteStatusChange"] !== undefined ? _data["clockOutOnsiteStatusChange"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceSettingConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceLedOn"] = this.deviceLedOn !== undefined ? this.deviceLedOn : <any>null;
        data["deviceVolume"] = this.deviceVolume !== undefined ? this.deviceVolume : <any>null;
        data["homeScreenLayout"] = this.homeScreenLayout !== undefined ? this.homeScreenLayout : <any>null;
        data["showClockingResultScreen"] = this.showClockingResultScreen !== undefined ? this.showClockingResultScreen : <any>null;
        data["directionlessClockOnsiteStatusChange"] = this.directionlessClockOnsiteStatusChange !== undefined ? this.directionlessClockOnsiteStatusChange : <any>null;
        data["clockInOnsiteStatusChange"] = this.clockInOnsiteStatusChange !== undefined ? this.clockInOnsiteStatusChange : <any>null;
        data["clockOutOnsiteStatusChange"] = this.clockOutOnsiteStatusChange !== undefined ? this.clockOutOnsiteStatusChange : <any>null;
        return data;
    }

    clone(): DeviceSettingConfigurationDto {
        const json = this.toJSON();
        let result = new DeviceSettingConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceSettingConfigurationDto {
    deviceLedOn?: boolean;
    deviceVolume?: number;
    homeScreenLayout?: HomeScreenLayoutType;
    showClockingResultScreen?: boolean;
    directionlessClockOnsiteStatusChange?: OnsiteStatusChange;
    clockInOnsiteStatusChange?: OnsiteStatusChange;
    clockOutOnsiteStatusChange?: OnsiteStatusChange;
}

export enum HomeScreenLayoutType {
    Clocking = 0,
    Activity = 1,
    ClockingAndActivity = 2,
    ReaderOnly = 3,
}

export class ProximityReadersConfigurationDto implements IProximityReadersConfigurationDto {
    isMfProxReaderLocal?: boolean;

    constructor(data?: IProximityReadersConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMfProxReaderLocal = _data["isMfProxReaderLocal"] !== undefined ? _data["isMfProxReaderLocal"] : <any>null;
        }
    }

    static fromJS(data: any): ProximityReadersConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProximityReadersConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMfProxReaderLocal"] = this.isMfProxReaderLocal !== undefined ? this.isMfProxReaderLocal : <any>null;
        return data;
    }

    clone(): ProximityReadersConfigurationDto {
        const json = this.toJSON();
        let result = new ProximityReadersConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IProximityReadersConfigurationDto {
    isMfProxReaderLocal?: boolean;
}

export class ThirdPartyReaderDto implements IThirdPartyReaderDto {
    id?: string;
    deviceId?: string;
    name!: string;
    readerNumber?: number;
    readerType?: ThirdPartyReaderType;
    badgeFormat?: string | null;

    constructor(data?: IThirdPartyReaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.readerNumber = _data["readerNumber"] !== undefined ? _data["readerNumber"] : <any>null;
            this.readerType = _data["readerType"] !== undefined ? _data["readerType"] : <any>null;
            this.badgeFormat = _data["badgeFormat"] !== undefined ? _data["badgeFormat"] : <any>null;
        }
    }

    static fromJS(data: any): ThirdPartyReaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyReaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["readerNumber"] = this.readerNumber !== undefined ? this.readerNumber : <any>null;
        data["readerType"] = this.readerType !== undefined ? this.readerType : <any>null;
        data["badgeFormat"] = this.badgeFormat !== undefined ? this.badgeFormat : <any>null;
        return data;
    }

    clone(): ThirdPartyReaderDto {
        const json = this.toJSON();
        let result = new ThirdPartyReaderDto();
        result.init(json);
        return result;
    }
}

export interface IThirdPartyReaderDto {
    id?: string;
    deviceId?: string;
    name: string;
    readerNumber?: number;
    readerType?: ThirdPartyReaderType;
    badgeFormat?: string | null;
}

export enum ThirdPartyReaderType {
    Universal = 0,
    ThirdMillennium = 1,
}

export class ModifyAreaDto implements IModifyAreaDto {
    name!: string;

    constructor(data?: IModifyAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ModifyAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): ModifyAreaDto {
        const json = this.toJSON();
        let result = new ModifyAreaDto();
        result.init(json);
        return result;
    }
}

export interface IModifyAreaDto {
    name: string;
}

export class CreateBadgeDto implements ICreateBadgeDto {
    userId?: string;
    badgeNumber!: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;

    constructor(data?: ICreateBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreateBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }

    clone(): CreateBadgeDto {
        const json = this.toJSON();
        let result = new CreateBadgeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBadgeDto {
    userId?: string;
    badgeNumber: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;
}

export class BadgeDto implements IBadgeDto {
    id?: string;
    userId?: string;
    badgeNumber!: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;
    entityVersion?: string;

    constructor(data?: IBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): BadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): BadgeDto {
        const json = this.toJSON();
        let result = new BadgeDto();
        result.init(json);
        return result;
    }
}

export interface IBadgeDto {
    id?: string;
    userId?: string;
    badgeNumber: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;
    entityVersion?: string;
}

export class ModifyBadgeDto implements IModifyBadgeDto {
    badgeNumber!: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;

    constructor(data?: IModifyBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ModifyBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }

    clone(): ModifyBadgeDto {
        const json = this.toJSON();
        let result = new ModifyBadgeDto();
        result.init(json);
        return result;
    }
}

export interface IModifyBadgeDto {
    badgeNumber: string;
    badgeActive?: boolean;
    startDate?: Date;
    endDate?: Date | null;
}

export class ApiResponseOfClockingResendDto extends ApiResponse implements IApiResponseOfClockingResendDto {
    result?: ClockingResendDto | null;

    constructor(data?: IApiResponseOfClockingResendDto) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new ClockingResendDto(data.result) : <ClockingResendDto>this.result;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? ClockingResendDto.fromJS(_data["result"]) : <any>null;
        }
    }

    static override fromJS(data: any): ApiResponseOfClockingResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfClockingResendDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiResponseOfClockingResendDto {
        const json = this.toJSON();
        let result = new ApiResponseOfClockingResendDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseOfClockingResendDto extends IApiResponse {
    result?: IClockingResendDto | null;
}

export class ClockingResendDto implements IClockingResendDto {
    remaining?: number;
    continuationSkipOffset?: number;

    constructor(data?: IClockingResendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remaining = _data["remaining"] !== undefined ? _data["remaining"] : <any>null;
            this.continuationSkipOffset = _data["continuationSkipOffset"] !== undefined ? _data["continuationSkipOffset"] : <any>null;
        }
    }

    static fromJS(data: any): ClockingResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingResendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remaining"] = this.remaining !== undefined ? this.remaining : <any>null;
        data["continuationSkipOffset"] = this.continuationSkipOffset !== undefined ? this.continuationSkipOffset : <any>null;
        return data;
    }

    clone(): ClockingResendDto {
        const json = this.toJSON();
        let result = new ClockingResendDto();
        result.init(json);
        return result;
    }
}

export interface IClockingResendDto {
    remaining?: number;
    continuationSkipOffset?: number;
}

export class ApiResponseOfClockingPageDto extends ApiResponse implements IApiResponseOfClockingPageDto {
    result?: ClockingPageDto | null;

    constructor(data?: IApiResponseOfClockingPageDto) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new ClockingPageDto(data.result) : <ClockingPageDto>this.result;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? ClockingPageDto.fromJS(_data["result"]) : <any>null;
        }
    }

    static override fromJS(data: any): ApiResponseOfClockingPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfClockingPageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiResponseOfClockingPageDto {
        const json = this.toJSON();
        let result = new ApiResponseOfClockingPageDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseOfClockingPageDto extends IApiResponse {
    result?: IClockingPageDto | null;
}

export class ClockingPageDto implements IClockingPageDto {
    metadata?: ClockingPageMetaDataDto | null;
    clockings?: ClockingPageItemDto[] | null;

    constructor(data?: IClockingPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metadata = data.metadata && !(<any>data.metadata).toJSON ? new ClockingPageMetaDataDto(data.metadata) : <ClockingPageMetaDataDto>this.metadata;
            if (data.clockings) {
                this.clockings = [];
                for (let i = 0; i < data.clockings.length; i++) {
                    let item = data.clockings[i];
                    this.clockings[i] = item && !(<any>item).toJSON ? new ClockingPageItemDto(item) : <ClockingPageItemDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ClockingPageMetaDataDto.fromJS(_data["metadata"]) : <any>null;
            if (Array.isArray(_data["clockings"])) {
                this.clockings = [] as any;
                for (let item of _data["clockings"])
                    this.clockings!.push(ClockingPageItemDto.fromJS(item));
            }
            else {
                this.clockings = <any>null;
            }
        }
    }

    static fromJS(data: any): ClockingPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        if (Array.isArray(this.clockings)) {
            data["clockings"] = [];
            for (let item of this.clockings)
                data["clockings"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClockingPageDto {
        const json = this.toJSON();
        let result = new ClockingPageDto();
        result.init(json);
        return result;
    }
}

export interface IClockingPageDto {
    metadata?: IClockingPageMetaDataDto | null;
    clockings?: IClockingPageItemDto[] | null;
}

export class ClockingPageMetaDataDto implements IClockingPageMetaDataDto {
    filteredTotal?: number;
    hasAuthenticationType?: boolean;
    hasAnalysis?: boolean;

    constructor(data?: IClockingPageMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
            this.hasAuthenticationType = _data["hasAuthenticationType"] !== undefined ? _data["hasAuthenticationType"] : <any>null;
            this.hasAnalysis = _data["hasAnalysis"] !== undefined ? _data["hasAnalysis"] : <any>null;
        }
    }

    static fromJS(data: any): ClockingPageMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingPageMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        data["hasAuthenticationType"] = this.hasAuthenticationType !== undefined ? this.hasAuthenticationType : <any>null;
        data["hasAnalysis"] = this.hasAnalysis !== undefined ? this.hasAnalysis : <any>null;
        return data;
    }

    clone(): ClockingPageMetaDataDto {
        const json = this.toJSON();
        let result = new ClockingPageMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IClockingPageMetaDataDto {
    filteredTotal?: number;
    hasAuthenticationType?: boolean;
    hasAnalysis?: boolean;
}

export class ClockingPageItemDto implements IClockingPageItemDto {
    id?: string;
    transactionId?: string;
    userId?: string;
    firstname?: string | null;
    surname?: string | null;
    deviceName?: string | null;
    clockingDateTime?: Date;
    direction?: ClockingDirection;
    directionMethod?: ClockingDirectionMethod;
    toggleSourceDateTime?: Date | null;
    toggleSourceDirection?: ClockingDirection;
    clockingPicture?: string | null;
    usedFingerprint?: boolean;
    usedFace?: boolean;
    usedProximity?: boolean;
    usedKeyboard?: boolean;
    matchingScore?: number;
    analysisResult?: string | null;
    analysisResultValue?: ClockingAnalysisResult;
    analysisConfidenceScore?: number;
    analysisTestItemResults?: AnalysisTestItemResultPageItemDto[] | null;
    analysisAction?: AnalysisActionDto | null;

    constructor(data?: IClockingPageItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.analysisAction = data.analysisAction && !(<any>data.analysisAction).toJSON ? new AnalysisActionDto(data.analysisAction) : <AnalysisActionDto>this.analysisAction;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.deviceName = _data["deviceName"] !== undefined ? _data["deviceName"] : <any>null;
            this.clockingDateTime = _data["clockingDateTime"] ? new Date(_data["clockingDateTime"].toString()) : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.directionMethod = _data["directionMethod"] !== undefined ? _data["directionMethod"] : <any>null;
            this.toggleSourceDateTime = _data["toggleSourceDateTime"] ? new Date(_data["toggleSourceDateTime"].toString()) : <any>null;
            this.toggleSourceDirection = _data["toggleSourceDirection"] !== undefined ? _data["toggleSourceDirection"] : <any>null;
            this.clockingPicture = _data["clockingPicture"] !== undefined ? _data["clockingPicture"] : <any>null;
            this.usedFingerprint = _data["usedFingerprint"] !== undefined ? _data["usedFingerprint"] : <any>null;
            this.usedFace = _data["usedFace"] !== undefined ? _data["usedFace"] : <any>null;
            this.usedProximity = _data["usedProximity"] !== undefined ? _data["usedProximity"] : <any>null;
            this.usedKeyboard = _data["usedKeyboard"] !== undefined ? _data["usedKeyboard"] : <any>null;
            this.matchingScore = _data["matchingScore"] !== undefined ? _data["matchingScore"] : <any>null;
            this.analysisResult = _data["analysisResult"] !== undefined ? _data["analysisResult"] : <any>null;
            this.analysisResultValue = _data["analysisResultValue"] !== undefined ? _data["analysisResultValue"] : <any>null;
            this.analysisConfidenceScore = _data["analysisConfidenceScore"] !== undefined ? _data["analysisConfidenceScore"] : <any>null;
            if (Array.isArray(_data["analysisTestItemResults"])) {
                this.analysisTestItemResults = [] as any;
                for (let item of _data["analysisTestItemResults"])
                    this.analysisTestItemResults!.push(AnalysisTestItemResultPageItemDto.fromJS(item));
            }
            else {
                this.analysisTestItemResults = <any>null;
            }
            this.analysisAction = _data["analysisAction"] ? AnalysisActionDto.fromJS(_data["analysisAction"]) : <any>null;
        }
    }

    static fromJS(data: any): ClockingPageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingPageItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["deviceName"] = this.deviceName !== undefined ? this.deviceName : <any>null;
        data["clockingDateTime"] = this.clockingDateTime ? this.clockingDateTime.toISOString() : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["directionMethod"] = this.directionMethod !== undefined ? this.directionMethod : <any>null;
        data["toggleSourceDateTime"] = this.toggleSourceDateTime ? this.toggleSourceDateTime.toISOString() : <any>null;
        data["toggleSourceDirection"] = this.toggleSourceDirection !== undefined ? this.toggleSourceDirection : <any>null;
        data["clockingPicture"] = this.clockingPicture !== undefined ? this.clockingPicture : <any>null;
        data["usedFingerprint"] = this.usedFingerprint !== undefined ? this.usedFingerprint : <any>null;
        data["usedFace"] = this.usedFace !== undefined ? this.usedFace : <any>null;
        data["usedProximity"] = this.usedProximity !== undefined ? this.usedProximity : <any>null;
        data["usedKeyboard"] = this.usedKeyboard !== undefined ? this.usedKeyboard : <any>null;
        data["matchingScore"] = this.matchingScore !== undefined ? this.matchingScore : <any>null;
        data["analysisResult"] = this.analysisResult !== undefined ? this.analysisResult : <any>null;
        data["analysisResultValue"] = this.analysisResultValue !== undefined ? this.analysisResultValue : <any>null;
        data["analysisConfidenceScore"] = this.analysisConfidenceScore !== undefined ? this.analysisConfidenceScore : <any>null;
        if (Array.isArray(this.analysisTestItemResults)) {
            data["analysisTestItemResults"] = [];
            for (let item of this.analysisTestItemResults)
                data["analysisTestItemResults"].push(item.toJSON());
        }
        data["analysisAction"] = this.analysisAction ? this.analysisAction.toJSON() : <any>null;
        return data;
    }

    clone(): ClockingPageItemDto {
        const json = this.toJSON();
        let result = new ClockingPageItemDto();
        result.init(json);
        return result;
    }
}

export interface IClockingPageItemDto {
    id?: string;
    transactionId?: string;
    userId?: string;
    firstname?: string | null;
    surname?: string | null;
    deviceName?: string | null;
    clockingDateTime?: Date;
    direction?: ClockingDirection;
    directionMethod?: ClockingDirectionMethod;
    toggleSourceDateTime?: Date | null;
    toggleSourceDirection?: ClockingDirection;
    clockingPicture?: string | null;
    usedFingerprint?: boolean;
    usedFace?: boolean;
    usedProximity?: boolean;
    usedKeyboard?: boolean;
    matchingScore?: number;
    analysisResult?: string | null;
    analysisResultValue?: ClockingAnalysisResult;
    analysisConfidenceScore?: number;
    analysisTestItemResults?: AnalysisTestItemResultPageItemDto[] | null;
    analysisAction?: IAnalysisActionDto | null;
}

export enum ClockingDirection {
    None = 0,
    In = 1,
    Out = 2,
}

export enum ClockingDirectionMethod {
    NotRecorded = "NotRecorded",
    NoDirection = "NoDirection",
    Toggle = "Toggle",
    SelectedIn = "SelectedIn",
    SelectedOut = "SelectedOut",
    SwitchedAfterClocking = "SwitchedAfterClocking",
}

export enum ClockingAnalysisResult {
    NotAnalysed = "NotAnalysed",
    Ok = "Ok",
    UnexpectedTimeOfDay = "UnexpectedTimeOfDay",
    UnexpectedDirection = "UnexpectedDirection",
    UnexpectedDayOfWeek = "UnexpectedDayOfWeek",
    UnexpectedDevice = "UnexpectedDevice",
    UnexpectedTimeForBusiness = "UnexpectedTimeForBusiness",
    UnexpectedAuthenticationType = "UnexpectedAuthenticationType",
}

export class AnalysisTestItemResultDto implements IAnalysisTestItemResultDto {
    test?: ClockingAnalysisResult;
    testResult?: boolean;
    confidenceScore?: number;

    constructor(data?: IAnalysisTestItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.test = _data["test"] !== undefined ? _data["test"] : <any>null;
            this.testResult = _data["testResult"] !== undefined ? _data["testResult"] : <any>null;
            this.confidenceScore = _data["confidenceScore"] !== undefined ? _data["confidenceScore"] : <any>null;
        }
    }

    static fromJS(data: any): AnalysisTestItemResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTestItemResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["test"] = this.test !== undefined ? this.test : <any>null;
        data["testResult"] = this.testResult !== undefined ? this.testResult : <any>null;
        data["confidenceScore"] = this.confidenceScore !== undefined ? this.confidenceScore : <any>null;
        return data;
    }

    clone(): AnalysisTestItemResultDto {
        const json = this.toJSON();
        let result = new AnalysisTestItemResultDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisTestItemResultDto {
    test?: ClockingAnalysisResult;
    testResult?: boolean;
    confidenceScore?: number;
}

export class AnalysisTestItemResultPageItemDto extends AnalysisTestItemResultDto implements IAnalysisTestItemResultPageItemDto {
    testName?: string | null;
    additionalDetail?: string | null;

    constructor(data?: IAnalysisTestItemResultPageItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testName = _data["testName"] !== undefined ? _data["testName"] : <any>null;
            this.additionalDetail = _data["additionalDetail"] !== undefined ? _data["additionalDetail"] : <any>null;
        }
    }

    static override fromJS(data: any): AnalysisTestItemResultPageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTestItemResultPageItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testName"] = this.testName !== undefined ? this.testName : <any>null;
        data["additionalDetail"] = this.additionalDetail !== undefined ? this.additionalDetail : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AnalysisTestItemResultPageItemDto {
        const json = this.toJSON();
        let result = new AnalysisTestItemResultPageItemDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisTestItemResultPageItemDto extends IAnalysisTestItemResultDto {
    testName?: string | null;
    additionalDetail?: string | null;
}

export class AnalysisActionDto implements IAnalysisActionDto {
    status?: ClockingAnalysisActionStatus;

    constructor(data?: IAnalysisActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): AnalysisActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): AnalysisActionDto {
        const json = this.toJSON();
        let result = new AnalysisActionDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisActionDto {
    status?: ClockingAnalysisActionStatus;
}

export enum ClockingAnalysisActionStatus {
    Unreviewed = 0,
    Accepted = 1,
    Flagged = 2,
}

export class ModifyClockingAnalysisActionDto implements IModifyClockingAnalysisActionDto {
    status?: ClockingAnalysisActionStatus;

    constructor(data?: IModifyClockingAnalysisActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): ModifyClockingAnalysisActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyClockingAnalysisActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): ModifyClockingAnalysisActionDto {
        const json = this.toJSON();
        let result = new ModifyClockingAnalysisActionDto();
        result.init(json);
        return result;
    }
}

export interface IModifyClockingAnalysisActionDto {
    status?: ClockingAnalysisActionStatus;
}

export class ActivitiesListDto implements IActivitiesListDto {
    metaData?: ActivityListMetaDataDto | null;
    activities?: ActivitySelectionDto[] | null;

    constructor(data?: IActivitiesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new ActivityListMetaDataDto(data.metaData) : <ActivityListMetaDataDto>this.metaData;
            if (data.activities) {
                this.activities = [];
                for (let i = 0; i < data.activities.length; i++) {
                    let item = data.activities[i];
                    this.activities[i] = item && !(<any>item).toJSON ? new ActivitySelectionDto(item) : <ActivitySelectionDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? ActivityListMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ActivitySelectionDto.fromJS(item));
            }
            else {
                this.activities = <any>null;
            }
        }
    }

    static fromJS(data: any): ActivitiesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitiesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data;
    }

    clone(): ActivitiesListDto {
        const json = this.toJSON();
        let result = new ActivitiesListDto();
        result.init(json);
        return result;
    }
}

export interface IActivitiesListDto {
    metaData?: IActivityListMetaDataDto | null;
    activities?: IActivitySelectionDto[] | null;
}

export class ActivityListMetaDataDto implements IActivityListMetaDataDto {
    filtered?: number;
    selected?: number;

    constructor(data?: IActivityListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filtered = _data["filtered"] !== undefined ? _data["filtered"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filtered"] = this.filtered !== undefined ? this.filtered : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): ActivityListMetaDataDto {
        const json = this.toJSON();
        let result = new ActivityListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IActivityListMetaDataDto {
    filtered?: number;
    selected?: number;
}

export class ActivitySelectionDto implements IActivitySelectionDto {
    id?: string;
    name!: string;
    description!: string;
    selected!: boolean;

    constructor(data?: IActivitySelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): ActivitySelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): ActivitySelectionDto {
        const json = this.toJSON();
        let result = new ActivitySelectionDto();
        result.init(json);
        return result;
    }
}

export interface IActivitySelectionDto {
    id?: string;
    name: string;
    description: string;
    selected: boolean;
}

export class DeviceActivitiesDto implements IDeviceActivitiesDto {
    activitiesToAdd?: string[] | null;
    activitiesToRemove?: string[] | null;

    constructor(data?: IDeviceActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activitiesToAdd"])) {
                this.activitiesToAdd = [] as any;
                for (let item of _data["activitiesToAdd"])
                    this.activitiesToAdd!.push(item);
            }
            else {
                this.activitiesToAdd = <any>null;
            }
            if (Array.isArray(_data["activitiesToRemove"])) {
                this.activitiesToRemove = [] as any;
                for (let item of _data["activitiesToRemove"])
                    this.activitiesToRemove!.push(item);
            }
            else {
                this.activitiesToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviceActivitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activitiesToAdd)) {
            data["activitiesToAdd"] = [];
            for (let item of this.activitiesToAdd)
                data["activitiesToAdd"].push(item);
        }
        if (Array.isArray(this.activitiesToRemove)) {
            data["activitiesToRemove"] = [];
            for (let item of this.activitiesToRemove)
                data["activitiesToRemove"].push(item);
        }
        return data;
    }

    clone(): DeviceActivitiesDto {
        const json = this.toJSON();
        let result = new DeviceActivitiesDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceActivitiesDto {
    activitiesToAdd?: string[] | null;
    activitiesToRemove?: string[] | null;
}

export class DeviceFirmwareDto implements IDeviceFirmwareDto {
    releaseType?: DeviceFirmwareReleaseType;
    version?: string | null;

    constructor(data?: IDeviceFirmwareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseType = _data["releaseType"] !== undefined ? _data["releaseType"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceFirmwareDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFirmwareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseType"] = this.releaseType !== undefined ? this.releaseType : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }

    clone(): DeviceFirmwareDto {
        const json = this.toJSON();
        let result = new DeviceFirmwareDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceFirmwareDto {
    releaseType?: DeviceFirmwareReleaseType;
    version?: string | null;
}

export enum DeviceFirmwareReleaseType {
    None = 0,
    Beta = 1,
    Controlled = 2,
    General = 3,
}

export class CreateDeviceGroupDto implements ICreateDeviceGroupDto {
    areaId?: string;
    name!: string;
    deviceGroupType?: DeviceGroupType;

    constructor(data?: ICreateDeviceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.deviceGroupType = _data["deviceGroupType"] !== undefined ? _data["deviceGroupType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateDeviceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeviceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["deviceGroupType"] = this.deviceGroupType !== undefined ? this.deviceGroupType : <any>null;
        return data;
    }

    clone(): CreateDeviceGroupDto {
        const json = this.toJSON();
        let result = new CreateDeviceGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDeviceGroupDto {
    areaId?: string;
    name: string;
    deviceGroupType?: DeviceGroupType;
}

export class ModifyDeviceGroupDto implements IModifyDeviceGroupDto {
    name!: string;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    devices?: DeviceDto[] | null;

    constructor(data?: IModifyDeviceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.devices) {
                this.devices = [];
                for (let i = 0; i < data.devices.length; i++) {
                    let item = data.devices[i];
                    this.devices[i] = item && !(<any>item).toJSON ? new DeviceDto(item) : <DeviceDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.scheduleRotationLength = _data["scheduleRotationLength"] !== undefined ? _data["scheduleRotationLength"] : <any>null;
            this.scheduleBaseDate = _data["scheduleBaseDate"] ? new Date(_data["scheduleBaseDate"].toString()) : <any>null;
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDto.fromJS(item));
            }
            else {
                this.devices = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyDeviceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyDeviceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["scheduleRotationLength"] = this.scheduleRotationLength !== undefined ? this.scheduleRotationLength : <any>null;
        data["scheduleBaseDate"] = this.scheduleBaseDate ? this.scheduleBaseDate.toISOString() : <any>null;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModifyDeviceGroupDto {
        const json = this.toJSON();
        let result = new ModifyDeviceGroupDto();
        result.init(json);
        return result;
    }
}

export interface IModifyDeviceGroupDto {
    name: string;
    scheduleRotationLength?: number;
    scheduleBaseDate?: Date;
    devices?: IDeviceDto[] | null;
}

export class DeviceHardware implements IDeviceHardware {
    id?: string;
    deviceId?: string;
    businessAccountId?: string;
    name!: string;
    configuration?: string | null;

    constructor(data?: IDeviceHardware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.configuration = _data["configuration"] !== undefined ? _data["configuration"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceHardware {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceHardware();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["configuration"] = this.configuration !== undefined ? this.configuration : <any>null;
        return data;
    }

    clone(): DeviceHardware {
        const json = this.toJSON();
        let result = new DeviceHardware();
        result.init(json);
        return result;
    }
}

export interface IDeviceHardware {
    id?: string;
    deviceId?: string;
    businessAccountId?: string;
    name: string;
    configuration?: string | null;
}

export class DeviceHeartbeatDto implements IDeviceHeartbeatDto {
    broadcastDateTime?: Date;
    ethernetConnection?: boolean;
    wiFiConnection?: boolean;
    hardwareAPIConnection?: boolean;
    pushMessageConnection?: boolean;
    transactionQueueSize?: number;
    lastTransactionSent?: Date;
    caseTemperature?: number;
    cpuTemperature?: number;
    ethernetMacAddress?: string | null;
    ethernetIpAddress?: string | null;
    wiFiMacAddress?: string | null;
    wiFiIpAddress?: string | null;
    publicIpAddress?: string | null;

    constructor(data?: IDeviceHeartbeatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broadcastDateTime = _data["broadcastDateTime"] ? new Date(_data["broadcastDateTime"].toString()) : <any>null;
            this.ethernetConnection = _data["ethernetConnection"] !== undefined ? _data["ethernetConnection"] : <any>null;
            this.wiFiConnection = _data["wiFiConnection"] !== undefined ? _data["wiFiConnection"] : <any>null;
            this.hardwareAPIConnection = _data["hardwareAPIConnection"] !== undefined ? _data["hardwareAPIConnection"] : <any>null;
            this.pushMessageConnection = _data["pushMessageConnection"] !== undefined ? _data["pushMessageConnection"] : <any>null;
            this.transactionQueueSize = _data["transactionQueueSize"] !== undefined ? _data["transactionQueueSize"] : <any>null;
            this.lastTransactionSent = _data["lastTransactionSent"] ? new Date(_data["lastTransactionSent"].toString()) : <any>null;
            this.caseTemperature = _data["caseTemperature"] !== undefined ? _data["caseTemperature"] : <any>null;
            this.cpuTemperature = _data["cpuTemperature"] !== undefined ? _data["cpuTemperature"] : <any>null;
            this.ethernetMacAddress = _data["ethernetMacAddress"] !== undefined ? _data["ethernetMacAddress"] : <any>null;
            this.ethernetIpAddress = _data["ethernetIpAddress"] !== undefined ? _data["ethernetIpAddress"] : <any>null;
            this.wiFiMacAddress = _data["wiFiMacAddress"] !== undefined ? _data["wiFiMacAddress"] : <any>null;
            this.wiFiIpAddress = _data["wiFiIpAddress"] !== undefined ? _data["wiFiIpAddress"] : <any>null;
            this.publicIpAddress = _data["publicIpAddress"] !== undefined ? _data["publicIpAddress"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceHeartbeatDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceHeartbeatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broadcastDateTime"] = this.broadcastDateTime ? this.broadcastDateTime.toISOString() : <any>null;
        data["ethernetConnection"] = this.ethernetConnection !== undefined ? this.ethernetConnection : <any>null;
        data["wiFiConnection"] = this.wiFiConnection !== undefined ? this.wiFiConnection : <any>null;
        data["hardwareAPIConnection"] = this.hardwareAPIConnection !== undefined ? this.hardwareAPIConnection : <any>null;
        data["pushMessageConnection"] = this.pushMessageConnection !== undefined ? this.pushMessageConnection : <any>null;
        data["transactionQueueSize"] = this.transactionQueueSize !== undefined ? this.transactionQueueSize : <any>null;
        data["lastTransactionSent"] = this.lastTransactionSent ? this.lastTransactionSent.toISOString() : <any>null;
        data["caseTemperature"] = this.caseTemperature !== undefined ? this.caseTemperature : <any>null;
        data["cpuTemperature"] = this.cpuTemperature !== undefined ? this.cpuTemperature : <any>null;
        data["ethernetMacAddress"] = this.ethernetMacAddress !== undefined ? this.ethernetMacAddress : <any>null;
        data["ethernetIpAddress"] = this.ethernetIpAddress !== undefined ? this.ethernetIpAddress : <any>null;
        data["wiFiMacAddress"] = this.wiFiMacAddress !== undefined ? this.wiFiMacAddress : <any>null;
        data["wiFiIpAddress"] = this.wiFiIpAddress !== undefined ? this.wiFiIpAddress : <any>null;
        data["publicIpAddress"] = this.publicIpAddress !== undefined ? this.publicIpAddress : <any>null;
        return data;
    }

    clone(): DeviceHeartbeatDto {
        const json = this.toJSON();
        let result = new DeviceHeartbeatDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceHeartbeatDto {
    broadcastDateTime?: Date;
    ethernetConnection?: boolean;
    wiFiConnection?: boolean;
    hardwareAPIConnection?: boolean;
    pushMessageConnection?: boolean;
    transactionQueueSize?: number;
    lastTransactionSent?: Date;
    caseTemperature?: number;
    cpuTemperature?: number;
    ethernetMacAddress?: string | null;
    ethernetIpAddress?: string | null;
    wiFiMacAddress?: string | null;
    wiFiIpAddress?: string | null;
    publicIpAddress?: string | null;
}

export class DeviceLogListDto implements IDeviceLogListDto {
    metaData?: DeviceLogListMetaDataDto | null;
    deviceLogs?: DeviceLogDto[] | null;

    constructor(data?: IDeviceLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new DeviceLogListMetaDataDto(data.metaData) : <DeviceLogListMetaDataDto>this.metaData;
            if (data.deviceLogs) {
                this.deviceLogs = [];
                for (let i = 0; i < data.deviceLogs.length; i++) {
                    let item = data.deviceLogs[i];
                    this.deviceLogs[i] = item && !(<any>item).toJSON ? new DeviceLogDto(item) : <DeviceLogDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? DeviceLogListMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["deviceLogs"])) {
                this.deviceLogs = [] as any;
                for (let item of _data["deviceLogs"])
                    this.deviceLogs!.push(DeviceLogDto.fromJS(item));
            }
            else {
                this.deviceLogs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviceLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.deviceLogs)) {
            data["deviceLogs"] = [];
            for (let item of this.deviceLogs)
                data["deviceLogs"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeviceLogListDto {
        const json = this.toJSON();
        let result = new DeviceLogListDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceLogListDto {
    metaData?: IDeviceLogListMetaDataDto | null;
    deviceLogs?: IDeviceLogDto[] | null;
}

export class DeviceLogListMetaDataDto implements IDeviceLogListMetaDataDto {
    total?: number;
    filtered?: number;
    lastLogsCheckDate?: Date | null;
    lastLogsUpdateDate?: Date | null;

    constructor(data?: IDeviceLogListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.filtered = _data["filtered"] !== undefined ? _data["filtered"] : <any>null;
            this.lastLogsCheckDate = _data["lastLogsCheckDate"] ? new Date(_data["lastLogsCheckDate"].toString()) : <any>null;
            this.lastLogsUpdateDate = _data["lastLogsUpdateDate"] ? new Date(_data["lastLogsUpdateDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DeviceLogListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceLogListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["filtered"] = this.filtered !== undefined ? this.filtered : <any>null;
        data["lastLogsCheckDate"] = this.lastLogsCheckDate ? this.lastLogsCheckDate.toISOString() : <any>null;
        data["lastLogsUpdateDate"] = this.lastLogsUpdateDate ? this.lastLogsUpdateDate.toISOString() : <any>null;
        return data;
    }

    clone(): DeviceLogListMetaDataDto {
        const json = this.toJSON();
        let result = new DeviceLogListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceLogListMetaDataDto {
    total?: number;
    filtered?: number;
    lastLogsCheckDate?: Date | null;
    lastLogsUpdateDate?: Date | null;
}

export class DeviceLogDto implements IDeviceLogDto {
    fileName?: string | null;
    uri?: string | null;

    constructor(data?: IDeviceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.uri = _data["uri"] !== undefined ? _data["uri"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["uri"] = this.uri !== undefined ? this.uri : <any>null;
        return data;
    }

    clone(): DeviceLogDto {
        const json = this.toJSON();
        let result = new DeviceLogDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceLogDto {
    fileName?: string | null;
    uri?: string | null;
}

export class CreateDeviceDto implements ICreateDeviceDto {
    deviceType?: DeviceType;
    siteId?: string;
    name!: string;

    constructor(data?: ICreateDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["deviceType"] !== undefined ? _data["deviceType"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType !== undefined ? this.deviceType : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): CreateDeviceDto {
        const json = this.toJSON();
        let result = new CreateDeviceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDeviceDto {
    deviceType?: DeviceType;
    siteId?: string;
    name: string;
}

export class DeviceSummaryDto implements IDeviceSummaryDto {
    id?: string;
    siteName?: string | null;
    areaName?: string | null;
    deviceName?: string | null;

    constructor(data?: IDeviceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : <any>null;
            this.areaName = _data["areaName"] !== undefined ? _data["areaName"] : <any>null;
            this.deviceName = _data["deviceName"] !== undefined ? _data["deviceName"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["siteName"] = this.siteName !== undefined ? this.siteName : <any>null;
        data["areaName"] = this.areaName !== undefined ? this.areaName : <any>null;
        data["deviceName"] = this.deviceName !== undefined ? this.deviceName : <any>null;
        return data;
    }

    clone(): DeviceSummaryDto {
        const json = this.toJSON();
        let result = new DeviceSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceSummaryDto {
    id?: string;
    siteName?: string | null;
    areaName?: string | null;
    deviceName?: string | null;
}

export class ModifyDeviceDto implements IModifyDeviceDto {
    deviceGroupId?: string | null;
    name!: string;
    deviceActive?: boolean;
    external?: boolean;
    configuration?: DeviceConfigurationDto | null;
    thirdPartyReaders?: ThirdPartyReaderDto[] | null;

    constructor(data?: IModifyDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.configuration = data.configuration && !(<any>data.configuration).toJSON ? new DeviceConfigurationDto(data.configuration) : <DeviceConfigurationDto>this.configuration;
            if (data.thirdPartyReaders) {
                this.thirdPartyReaders = [];
                for (let i = 0; i < data.thirdPartyReaders.length; i++) {
                    let item = data.thirdPartyReaders[i];
                    this.thirdPartyReaders[i] = item && !(<any>item).toJSON ? new ThirdPartyReaderDto(item) : <ThirdPartyReaderDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceGroupId = _data["deviceGroupId"] !== undefined ? _data["deviceGroupId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.deviceActive = _data["deviceActive"] !== undefined ? _data["deviceActive"] : <any>null;
            this.external = _data["external"] !== undefined ? _data["external"] : <any>null;
            this.configuration = _data["configuration"] ? DeviceConfigurationDto.fromJS(_data["configuration"]) : <any>null;
            if (Array.isArray(_data["thirdPartyReaders"])) {
                this.thirdPartyReaders = [] as any;
                for (let item of _data["thirdPartyReaders"])
                    this.thirdPartyReaders!.push(ThirdPartyReaderDto.fromJS(item));
            }
            else {
                this.thirdPartyReaders = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceGroupId"] = this.deviceGroupId !== undefined ? this.deviceGroupId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["deviceActive"] = this.deviceActive !== undefined ? this.deviceActive : <any>null;
        data["external"] = this.external !== undefined ? this.external : <any>null;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        if (Array.isArray(this.thirdPartyReaders)) {
            data["thirdPartyReaders"] = [];
            for (let item of this.thirdPartyReaders)
                data["thirdPartyReaders"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModifyDeviceDto {
        const json = this.toJSON();
        let result = new ModifyDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IModifyDeviceDto {
    deviceGroupId?: string | null;
    name: string;
    deviceActive?: boolean;
    external?: boolean;
    configuration?: IDeviceConfigurationDto | null;
    thirdPartyReaders?: IThirdPartyReaderDto[] | null;
}

export class DeviceStatusAlertConfigurationDto implements IDeviceStatusAlertConfigurationDto {
    id?: string;
    useGlobal?: boolean;
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;

    constructor(data?: IDeviceStatusAlertConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.useGlobal = _data["useGlobal"] !== undefined ? _data["useGlobal"] : <any>null;
            this.deviceOfflineEmail = _data["deviceOfflineEmail"] !== undefined ? _data["deviceOfflineEmail"] : <any>null;
            this.deviceOnlineEmail = _data["deviceOnlineEmail"] !== undefined ? _data["deviceOnlineEmail"] : <any>null;
            this.emailAddresses = _data["emailAddresses"] !== undefined ? _data["emailAddresses"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceStatusAlertConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusAlertConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["useGlobal"] = this.useGlobal !== undefined ? this.useGlobal : <any>null;
        data["deviceOfflineEmail"] = this.deviceOfflineEmail !== undefined ? this.deviceOfflineEmail : <any>null;
        data["deviceOnlineEmail"] = this.deviceOnlineEmail !== undefined ? this.deviceOnlineEmail : <any>null;
        data["emailAddresses"] = this.emailAddresses !== undefined ? this.emailAddresses : <any>null;
        return data;
    }

    clone(): DeviceStatusAlertConfigurationDto {
        const json = this.toJSON();
        let result = new DeviceStatusAlertConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceStatusAlertConfigurationDto {
    id?: string;
    useGlobal?: boolean;
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;
}

export class UpsertDeviceStatusAlertConfigurationDto implements IUpsertDeviceStatusAlertConfigurationDto {
    useGlobal?: boolean;
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;

    constructor(data?: IUpsertDeviceStatusAlertConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useGlobal = _data["useGlobal"] !== undefined ? _data["useGlobal"] : <any>null;
            this.deviceOfflineEmail = _data["deviceOfflineEmail"] !== undefined ? _data["deviceOfflineEmail"] : <any>null;
            this.deviceOnlineEmail = _data["deviceOnlineEmail"] !== undefined ? _data["deviceOnlineEmail"] : <any>null;
            this.emailAddresses = _data["emailAddresses"] !== undefined ? _data["emailAddresses"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertDeviceStatusAlertConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDeviceStatusAlertConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useGlobal"] = this.useGlobal !== undefined ? this.useGlobal : <any>null;
        data["deviceOfflineEmail"] = this.deviceOfflineEmail !== undefined ? this.deviceOfflineEmail : <any>null;
        data["deviceOnlineEmail"] = this.deviceOnlineEmail !== undefined ? this.deviceOnlineEmail : <any>null;
        data["emailAddresses"] = this.emailAddresses !== undefined ? this.emailAddresses : <any>null;
        return data;
    }

    clone(): UpsertDeviceStatusAlertConfigurationDto {
        const json = this.toJSON();
        let result = new UpsertDeviceStatusAlertConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertDeviceStatusAlertConfigurationDto {
    useGlobal?: boolean;
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;
}

export class EmailAddressesDto implements IEmailAddressesDto {
    emailAddresses!: string[];

    constructor(data?: IEmailAddressesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.emailAddresses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
            else {
                this.emailAddresses = <any>null;
            }
        }
    }

    static fromJS(data: any): EmailAddressesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAddressesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        return data;
    }

    clone(): EmailAddressesDto {
        const json = this.toJSON();
        let result = new EmailAddressesDto();
        result.init(json);
        return result;
    }
}

export interface IEmailAddressesDto {
    emailAddresses: string[];
}

export class UpsertGlobalConfigurationDto implements IUpsertGlobalConfigurationDto {
    businessAccountId?: string;
    configuration?: ConfigurationDto | null;

    constructor(data?: IUpsertGlobalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.configuration = data.configuration && !(<any>data.configuration).toJSON ? new ConfigurationDto(data.configuration) : <ConfigurationDto>this.configuration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.configuration = _data["configuration"] ? ConfigurationDto.fromJS(_data["configuration"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertGlobalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGlobalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        return data;
    }

    clone(): UpsertGlobalConfigurationDto {
        const json = this.toJSON();
        let result = new UpsertGlobalConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertGlobalConfigurationDto {
    businessAccountId?: string;
    configuration?: IConfigurationDto | null;
}

export class ConfigurationDto implements IConfigurationDto {
    businessName?: string | null;
    timezone?: string | null;
    directionlessToggleClocking?: boolean;
    deviceStatusAlertConfiguration?: GlobalDeviceStatusAlertConfiguration | null;
    deviceWeatherConfiguration?: GlobalDeviceWeatherConfiguration | null;

    constructor(data?: IConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.deviceStatusAlertConfiguration = data.deviceStatusAlertConfiguration && !(<any>data.deviceStatusAlertConfiguration).toJSON ? new GlobalDeviceStatusAlertConfiguration(data.deviceStatusAlertConfiguration) : <GlobalDeviceStatusAlertConfiguration>this.deviceStatusAlertConfiguration;
            this.deviceWeatherConfiguration = data.deviceWeatherConfiguration && !(<any>data.deviceWeatherConfiguration).toJSON ? new GlobalDeviceWeatherConfiguration(data.deviceWeatherConfiguration) : <GlobalDeviceWeatherConfiguration>this.deviceWeatherConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"] !== undefined ? _data["businessName"] : <any>null;
            this.timezone = _data["timezone"] !== undefined ? _data["timezone"] : <any>null;
            this.directionlessToggleClocking = _data["directionlessToggleClocking"] !== undefined ? _data["directionlessToggleClocking"] : <any>null;
            this.deviceStatusAlertConfiguration = _data["deviceStatusAlertConfiguration"] ? GlobalDeviceStatusAlertConfiguration.fromJS(_data["deviceStatusAlertConfiguration"]) : <any>null;
            this.deviceWeatherConfiguration = _data["deviceWeatherConfiguration"] ? GlobalDeviceWeatherConfiguration.fromJS(_data["deviceWeatherConfiguration"]) : <any>null;
        }
    }

    static fromJS(data: any): ConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName !== undefined ? this.businessName : <any>null;
        data["timezone"] = this.timezone !== undefined ? this.timezone : <any>null;
        data["directionlessToggleClocking"] = this.directionlessToggleClocking !== undefined ? this.directionlessToggleClocking : <any>null;
        data["deviceStatusAlertConfiguration"] = this.deviceStatusAlertConfiguration ? this.deviceStatusAlertConfiguration.toJSON() : <any>null;
        data["deviceWeatherConfiguration"] = this.deviceWeatherConfiguration ? this.deviceWeatherConfiguration.toJSON() : <any>null;
        return data;
    }

    clone(): ConfigurationDto {
        const json = this.toJSON();
        let result = new ConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IConfigurationDto {
    businessName?: string | null;
    timezone?: string | null;
    directionlessToggleClocking?: boolean;
    deviceStatusAlertConfiguration?: IGlobalDeviceStatusAlertConfiguration | null;
    deviceWeatherConfiguration?: IGlobalDeviceWeatherConfiguration | null;
}

export class GlobalDeviceStatusAlertConfiguration implements IGlobalDeviceStatusAlertConfiguration {
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;

    constructor(data?: IGlobalDeviceStatusAlertConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deviceOfflineEmail = false;
            this.deviceOnlineEmail = false;
            this.emailAddresses = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceOfflineEmail = _data["deviceOfflineEmail"] !== undefined ? _data["deviceOfflineEmail"] : false;
            this.deviceOnlineEmail = _data["deviceOnlineEmail"] !== undefined ? _data["deviceOnlineEmail"] : false;
            this.emailAddresses = _data["emailAddresses"] !== undefined ? _data["emailAddresses"] : "";
        }
    }

    static fromJS(data: any): GlobalDeviceStatusAlertConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDeviceStatusAlertConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceOfflineEmail"] = this.deviceOfflineEmail !== undefined ? this.deviceOfflineEmail : <any>null;
        data["deviceOnlineEmail"] = this.deviceOnlineEmail !== undefined ? this.deviceOnlineEmail : <any>null;
        data["emailAddresses"] = this.emailAddresses !== undefined ? this.emailAddresses : <any>null;
        return data;
    }

    clone(): GlobalDeviceStatusAlertConfiguration {
        const json = this.toJSON();
        let result = new GlobalDeviceStatusAlertConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGlobalDeviceStatusAlertConfiguration {
    deviceOfflineEmail?: boolean;
    deviceOnlineEmail?: boolean;
    emailAddresses?: string | null;
}

export class GlobalDeviceWeatherConfiguration implements IGlobalDeviceWeatherConfiguration {
    showOnScreensaver?: boolean;
    showOnHomepage?: boolean;

    constructor(data?: IGlobalDeviceWeatherConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.showOnScreensaver = false;
            this.showOnHomepage = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showOnScreensaver = _data["showOnScreensaver"] !== undefined ? _data["showOnScreensaver"] : false;
            this.showOnHomepage = _data["showOnHomepage"] !== undefined ? _data["showOnHomepage"] : false;
        }
    }

    static fromJS(data: any): GlobalDeviceWeatherConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDeviceWeatherConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showOnScreensaver"] = this.showOnScreensaver !== undefined ? this.showOnScreensaver : <any>null;
        data["showOnHomepage"] = this.showOnHomepage !== undefined ? this.showOnHomepage : <any>null;
        return data;
    }

    clone(): GlobalDeviceWeatherConfiguration {
        const json = this.toJSON();
        let result = new GlobalDeviceWeatherConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGlobalDeviceWeatherConfiguration {
    showOnScreensaver?: boolean;
    showOnHomepage?: boolean;
}

export class GlobalConfigurationDto implements IGlobalConfigurationDto {
    id?: string;
    businessAccountId?: string;
    configuration?: ConfigurationDto | null;
    entityVersion?: string;

    constructor(data?: IGlobalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.configuration = data.configuration && !(<any>data.configuration).toJSON ? new ConfigurationDto(data.configuration) : <ConfigurationDto>this.configuration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.configuration = _data["configuration"] ? ConfigurationDto.fromJS(_data["configuration"]) : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): GlobalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): GlobalConfigurationDto {
        const json = this.toJSON();
        let result = new GlobalConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IGlobalConfigurationDto {
    id?: string;
    businessAccountId?: string;
    configuration?: IConfigurationDto | null;
    entityVersion?: string;
}

export class LicenceDto implements ILicenceDto {
    allowClocking?: boolean;
    allowAccess?: boolean;
    editLinkedUsers?: boolean;
    allowActivities?: boolean;
    allowImageOnClocking?: boolean;

    constructor(data?: ILicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowClocking = _data["allowClocking"] !== undefined ? _data["allowClocking"] : <any>null;
            this.allowAccess = _data["allowAccess"] !== undefined ? _data["allowAccess"] : <any>null;
            this.editLinkedUsers = _data["editLinkedUsers"] !== undefined ? _data["editLinkedUsers"] : <any>null;
            this.allowActivities = _data["allowActivities"] !== undefined ? _data["allowActivities"] : <any>null;
            this.allowImageOnClocking = _data["allowImageOnClocking"] !== undefined ? _data["allowImageOnClocking"] : <any>null;
        }
    }

    static fromJS(data: any): LicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowClocking"] = this.allowClocking !== undefined ? this.allowClocking : <any>null;
        data["allowAccess"] = this.allowAccess !== undefined ? this.allowAccess : <any>null;
        data["editLinkedUsers"] = this.editLinkedUsers !== undefined ? this.editLinkedUsers : <any>null;
        data["allowActivities"] = this.allowActivities !== undefined ? this.allowActivities : <any>null;
        data["allowImageOnClocking"] = this.allowImageOnClocking !== undefined ? this.allowImageOnClocking : <any>null;
        return data;
    }

    clone(): LicenceDto {
        const json = this.toJSON();
        let result = new LicenceDto();
        result.init(json);
        return result;
    }
}

export interface ILicenceDto {
    allowClocking?: boolean;
    allowAccess?: boolean;
    editLinkedUsers?: boolean;
    allowActivities?: boolean;
    allowImageOnClocking?: boolean;
}

export class BusinessNoticeDto implements IBusinessNoticeDto {
    id?: string;
    title?: string | null;
    description?: string | null;
    publishDate?: Date;
    expiryDate?: Date;
    priority?: Priority;
    entityVersion?: string;

    constructor(data?: IBusinessNoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>null;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): BusinessNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>null;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): BusinessNoticeDto {
        const json = this.toJSON();
        let result = new BusinessNoticeDto();
        result.init(json);
        return result;
    }
}

export interface IBusinessNoticeDto {
    id?: string;
    title?: string | null;
    description?: string | null;
    publishDate?: Date;
    expiryDate?: Date;
    priority?: Priority;
    entityVersion?: string;
}

export enum Priority {
    High = 1,
    Medium = 2,
    Low = 3,
}

export class PermissionsDto implements IPermissionsDto {
    login?: boolean;

    constructor(data?: IPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
        }
    }

    static fromJS(data: any): PermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login !== undefined ? this.login : <any>null;
        return data;
    }

    clone(): PermissionsDto {
        const json = this.toJSON();
        let result = new PermissionsDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionsDto {
    login?: boolean;
}

export class CreateSiteDto implements ICreateSiteDto {
    name!: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ICreateSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }

    clone(): CreateSiteDto {
        const json = this.toJSON();
        let result = new CreateSiteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSiteDto {
    name: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class SiteSummaryDto implements ISiteSummaryDto {
    id?: string;
    businessAccountId?: string;
    name!: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ISiteSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): SiteSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }

    clone(): SiteSummaryDto {
        const json = this.toJSON();
        let result = new SiteSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ISiteSummaryDto {
    id?: string;
    businessAccountId?: string;
    name: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class SiteDto implements ISiteDto {
    id?: string;
    businessAccountId?: string;
    name!: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    entityVersion?: string;
    areas?: { [key: string]: AreaDto; } | null;

    constructor(data?: ISiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.areas) {
                this.areas = {};
                for (let key in data.areas) {
                    if (data.areas.hasOwnProperty(key)) {
                        let item = data.areas[key];
                        this.areas[key] = item && !(<any>item).toJSON ? new AreaDto(item) : <AreaDto>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
            if (_data["areas"]) {
                this.areas = {} as any;
                for (let key in _data["areas"]) {
                    if (_data["areas"].hasOwnProperty(key))
                        (<any>this.areas)![key] = _data["areas"][key] ? AreaDto.fromJS(_data["areas"][key]) : new AreaDto();
                }
            }
            else {
                this.areas = <any>null;
            }
        }
    }

    static fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        if (this.areas) {
            data["areas"] = {};
            for (let key in this.areas) {
                if (this.areas.hasOwnProperty(key))
                    (<any>data["areas"])[key] = this.areas[key] ? this.areas[key].toJSON() : <any>null;
            }
        }
        return data;
    }

    clone(): SiteDto {
        const json = this.toJSON();
        let result = new SiteDto();
        result.init(json);
        return result;
    }
}

export interface ISiteDto {
    id?: string;
    businessAccountId?: string;
    name: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    entityVersion?: string;
    areas?: { [key: string]: IAreaDto; } | null;
}

export class ModifySiteDto implements IModifySiteDto {
    name!: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: IModifySiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): ModifySiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifySiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }

    clone(): ModifySiteDto {
        const json = this.toJSON();
        let result = new ModifySiteDto();
        result.init(json);
        return result;
    }
}

export interface IModifySiteDto {
    name: string;
    houseOrNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    townCity?: string | null;
    county?: string | null;
    postCode?: string | null;
    country?: string | null;
    telephoneNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class CreateTagDto implements ICreateTagDto {
    tagGroup?: string | null;
    tagDescription?: string | null;

    constructor(data?: ICreateTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): CreateTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): CreateTagDto {
        const json = this.toJSON();
        let result = new CreateTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTagDto {
    tagGroup?: string | null;
    tagDescription?: string | null;
}

export class TagDto implements ITagDto {
    id?: string;
    tagGroup?: string | null;
    tagDescription?: string | null;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    id?: string;
    tagGroup?: string | null;
    tagDescription?: string | null;
}

export class ModifyTagDto implements IModifyTagDto {
    tagGroup!: string;
    tagDescription?: string | null;

    constructor(data?: IModifyTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): ModifyTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): ModifyTagDto {
        const json = this.toJSON();
        let result = new ModifyTagDto();
        result.init(json);
        return result;
    }
}

export interface IModifyTagDto {
    tagGroup: string;
    tagDescription?: string | null;
}

export class TagListDto implements ITagListDto {
    metaData?: TagListMetaDataDto | null;
    tags?: TagDto[] | null;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new TagListMetaDataDto(data.metaData) : <TagListMetaDataDto>this.metaData;
            if (data.tags) {
                this.tags = [];
                for (let i = 0; i < data.tags.length; i++) {
                    let item = data.tags[i];
                    this.tags[i] = item && !(<any>item).toJSON ? new TagDto(item) : <TagDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? TagListMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): TagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }

    clone(): TagListDto {
        const json = this.toJSON();
        let result = new TagListDto();
        result.init(json);
        return result;
    }
}

export interface ITagListDto {
    metaData?: ITagListMetaDataDto | null;
    tags?: ITagDto[] | null;
}

export class TagListMetaDataDto implements ITagListMetaDataDto {
    filteredTotal?: number;

    constructor(data?: ITagListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
        }
    }

    static fromJS(data: any): TagListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        return data;
    }

    clone(): TagListMetaDataDto {
        const json = this.toJSON();
        let result = new TagListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface ITagListMetaDataDto {
    filteredTotal?: number;
}

export class TimeZoneDto implements ITimeZoneDto {
    sequence?: number;
    databaseName?: string | null;
    displayName?: string | null;

    constructor(data?: ITimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : <any>null;
            this.databaseName = _data["databaseName"] !== undefined ? _data["databaseName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): TimeZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence !== undefined ? this.sequence : <any>null;
        data["databaseName"] = this.databaseName !== undefined ? this.databaseName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data;
    }

    clone(): TimeZoneDto {
        const json = this.toJSON();
        let result = new TimeZoneDto();
        result.init(json);
        return result;
    }
}

export interface ITimeZoneDto {
    sequence?: number;
    databaseName?: string | null;
    displayName?: string | null;
}

export class CreateUserGroupDto implements ICreateUserGroupDto {
    name!: string;
    userGroupType!: UserGroupType;
    members!: string[];
    tags!: string[];

    constructor(data?: ICreateUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.members = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userGroupType = _data["userGroupType"] !== undefined ? _data["userGroupType"] : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
            else {
                this.members = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userGroupType"] = this.userGroupType !== undefined ? this.userGroupType : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): CreateUserGroupDto {
        const json = this.toJSON();
        let result = new CreateUserGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserGroupDto {
    name: string;
    userGroupType: UserGroupType;
    members: string[];
    tags: string[];
}

export enum UserGroupType {
    UserList = 0,
    Tags = 1,
}

export class UserGroupSummaryListDto implements IUserGroupSummaryListDto {
    metaData?: UserGroupSummaryListMetaDataDto | null;
    userGroupSummaries?: UserGroupSummaryDto[] | null;

    constructor(data?: IUserGroupSummaryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new UserGroupSummaryListMetaDataDto(data.metaData) : <UserGroupSummaryListMetaDataDto>this.metaData;
            if (data.userGroupSummaries) {
                this.userGroupSummaries = [];
                for (let i = 0; i < data.userGroupSummaries.length; i++) {
                    let item = data.userGroupSummaries[i];
                    this.userGroupSummaries[i] = item && !(<any>item).toJSON ? new UserGroupSummaryDto(item) : <UserGroupSummaryDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? UserGroupSummaryListMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["userGroupSummaries"])) {
                this.userGroupSummaries = [] as any;
                for (let item of _data["userGroupSummaries"])
                    this.userGroupSummaries!.push(UserGroupSummaryDto.fromJS(item));
            }
            else {
                this.userGroupSummaries = <any>null;
            }
        }
    }

    static fromJS(data: any): UserGroupSummaryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSummaryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.userGroupSummaries)) {
            data["userGroupSummaries"] = [];
            for (let item of this.userGroupSummaries)
                data["userGroupSummaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserGroupSummaryListDto {
        const json = this.toJSON();
        let result = new UserGroupSummaryListDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupSummaryListDto {
    metaData?: IUserGroupSummaryListMetaDataDto | null;
    userGroupSummaries?: IUserGroupSummaryDto[] | null;
}

export class UserGroupSummaryListMetaDataDto implements IUserGroupSummaryListMetaDataDto {
    filteredTotal?: number;

    constructor(data?: IUserGroupSummaryListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupSummaryListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSummaryListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        return data;
    }

    clone(): UserGroupSummaryListMetaDataDto {
        const json = this.toJSON();
        let result = new UserGroupSummaryListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupSummaryListMetaDataDto {
    filteredTotal?: number;
}

export class UserGroupSummaryDto implements IUserGroupSummaryDto {
    id?: string;
    name!: string;
    userGroupType?: UserGroupType;
    activeUsersCount?: number;

    constructor(data?: IUserGroupSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userGroupType = _data["userGroupType"] !== undefined ? _data["userGroupType"] : <any>null;
            this.activeUsersCount = _data["activeUsersCount"] !== undefined ? _data["activeUsersCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userGroupType"] = this.userGroupType !== undefined ? this.userGroupType : <any>null;
        data["activeUsersCount"] = this.activeUsersCount !== undefined ? this.activeUsersCount : <any>null;
        return data;
    }

    clone(): UserGroupSummaryDto {
        const json = this.toJSON();
        let result = new UserGroupSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupSummaryDto {
    id?: string;
    name: string;
    userGroupType?: UserGroupType;
    activeUsersCount?: number;
}

export class UserGroupDto implements IUserGroupDto {
    id?: string;
    businessAccountId?: string;
    name!: string;
    activeUsersCount?: number;
    usersCount?: number;
    userGroupType?: UserGroupType;
    members?: UserGroupMemberDto[] | null;
    tags?: UserGroupTagDto[] | null;

    constructor(data?: IUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new UserGroupMemberDto(item) : <UserGroupMemberDto>item;
                }
            }
            if (data.tags) {
                this.tags = [];
                for (let i = 0; i < data.tags.length; i++) {
                    let item = data.tags[i];
                    this.tags[i] = item && !(<any>item).toJSON ? new UserGroupTagDto(item) : <UserGroupTagDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.activeUsersCount = _data["activeUsersCount"] !== undefined ? _data["activeUsersCount"] : <any>null;
            this.usersCount = _data["usersCount"] !== undefined ? _data["usersCount"] : <any>null;
            this.userGroupType = _data["userGroupType"] !== undefined ? _data["userGroupType"] : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(UserGroupMemberDto.fromJS(item));
            }
            else {
                this.members = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UserGroupTagDto.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): UserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["activeUsersCount"] = this.activeUsersCount !== undefined ? this.activeUsersCount : <any>null;
        data["usersCount"] = this.usersCount !== undefined ? this.usersCount : <any>null;
        data["userGroupType"] = this.userGroupType !== undefined ? this.userGroupType : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserGroupDto {
        const json = this.toJSON();
        let result = new UserGroupDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupDto {
    id?: string;
    businessAccountId?: string;
    name: string;
    activeUsersCount?: number;
    usersCount?: number;
    userGroupType?: UserGroupType;
    members?: IUserGroupMemberDto[] | null;
    tags?: IUserGroupTagDto[] | null;
}

export class UserGroupMemberDto implements IUserGroupMemberDto {
    userGroupId?: string;
    userId?: string;
    firstName!: string | null;
    surname!: string | null;
    externalReference!: string;
    startDate?: Date;
    status?: UserStatus;
    profilePicture?: string | null;

    constructor(data?: IUserGroupMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.profilePicture = _data["profilePicture"] !== undefined ? _data["profilePicture"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["profilePicture"] = this.profilePicture !== undefined ? this.profilePicture : <any>null;
        return data;
    }

    clone(): UserGroupMemberDto {
        const json = this.toJSON();
        let result = new UserGroupMemberDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupMemberDto {
    userGroupId?: string;
    userId?: string;
    firstName: string | null;
    surname: string | null;
    externalReference: string;
    startDate?: Date;
    status?: UserStatus;
    profilePicture?: string | null;
}

export enum UserStatus {
    New = 0,
    Unenrolled = 1,
    Active = 2,
    Engineer = 3,
    Inactive = 4,
}

export class UserGroupTagDto implements IUserGroupTagDto {
    id?: string;
    userGroupId?: string;
    tagId?: string;

    constructor(data?: IUserGroupTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userGroupId = _data["userGroupId"] !== undefined ? _data["userGroupId"] : <any>null;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userGroupId"] = this.userGroupId !== undefined ? this.userGroupId : <any>null;
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        return data;
    }

    clone(): UserGroupTagDto {
        const json = this.toJSON();
        let result = new UserGroupTagDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupTagDto {
    id?: string;
    userGroupId?: string;
    tagId?: string;
}

export class UserGroupMembersPageDto implements IUserGroupMembersPageDto {
    metadata?: UserGroupMembersPageMetaDataDto | null;
    members?: UserGroupMemberDto[] | null;

    constructor(data?: IUserGroupMembersPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metadata = data.metadata && !(<any>data.metadata).toJSON ? new UserGroupMembersPageMetaDataDto(data.metadata) : <UserGroupMembersPageMetaDataDto>this.metadata;
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new UserGroupMemberDto(item) : <UserGroupMemberDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? UserGroupMembersPageMetaDataDto.fromJS(_data["metadata"]) : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(UserGroupMemberDto.fromJS(item));
            }
            else {
                this.members = <any>null;
            }
        }
    }

    static fromJS(data: any): UserGroupMembersPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupMembersPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserGroupMembersPageDto {
        const json = this.toJSON();
        let result = new UserGroupMembersPageDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupMembersPageDto {
    metadata?: IUserGroupMembersPageMetaDataDto | null;
    members?: IUserGroupMemberDto[] | null;
}

export class UserGroupMembersPageMetaDataDto implements IUserGroupMembersPageMetaDataDto {
    filteredTotal?: number;

    constructor(data?: IUserGroupMembersPageMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupMembersPageMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupMembersPageMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        return data;
    }

    clone(): UserGroupMembersPageMetaDataDto {
        const json = this.toJSON();
        let result = new UserGroupMembersPageMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupMembersPageMetaDataDto {
    filteredTotal?: number;
}

export class ModifyUserGroupDto implements IModifyUserGroupDto {
    name!: string;
    userGroupType!: UserGroupType;
    members!: string[] | null;
    tags!: string[] | null;

    constructor(data?: IModifyUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userGroupType = _data["userGroupType"] !== undefined ? _data["userGroupType"] : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
            else {
                this.members = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userGroupType"] = this.userGroupType !== undefined ? this.userGroupType : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): ModifyUserGroupDto {
        const json = this.toJSON();
        let result = new ModifyUserGroupDto();
        result.init(json);
        return result;
    }
}

export interface IModifyUserGroupDto {
    name: string;
    userGroupType: UserGroupType;
    members: string[] | null;
    tags: string[] | null;
}

export class ModifyUserGroupMembersDto implements IModifyUserGroupMembersDto {
    name!: string;
    userGroupType!: UserGroupType;
    membersToAdd!: string[] | null;
    membersToRemove!: string[] | null;
    tagsToAdd!: string[] | null;
    tagsToRemove!: string[] | null;

    constructor(data?: IModifyUserGroupMembersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userGroupType = _data["userGroupType"] !== undefined ? _data["userGroupType"] : <any>null;
            if (Array.isArray(_data["membersToAdd"])) {
                this.membersToAdd = [] as any;
                for (let item of _data["membersToAdd"])
                    this.membersToAdd!.push(item);
            }
            else {
                this.membersToAdd = <any>null;
            }
            if (Array.isArray(_data["membersToRemove"])) {
                this.membersToRemove = [] as any;
                for (let item of _data["membersToRemove"])
                    this.membersToRemove!.push(item);
            }
            else {
                this.membersToRemove = <any>null;
            }
            if (Array.isArray(_data["tagsToAdd"])) {
                this.tagsToAdd = [] as any;
                for (let item of _data["tagsToAdd"])
                    this.tagsToAdd!.push(item);
            }
            else {
                this.tagsToAdd = <any>null;
            }
            if (Array.isArray(_data["tagsToRemove"])) {
                this.tagsToRemove = [] as any;
                for (let item of _data["tagsToRemove"])
                    this.tagsToRemove!.push(item);
            }
            else {
                this.tagsToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): ModifyUserGroupMembersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyUserGroupMembersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userGroupType"] = this.userGroupType !== undefined ? this.userGroupType : <any>null;
        if (Array.isArray(this.membersToAdd)) {
            data["membersToAdd"] = [];
            for (let item of this.membersToAdd)
                data["membersToAdd"].push(item);
        }
        if (Array.isArray(this.membersToRemove)) {
            data["membersToRemove"] = [];
            for (let item of this.membersToRemove)
                data["membersToRemove"].push(item);
        }
        if (Array.isArray(this.tagsToAdd)) {
            data["tagsToAdd"] = [];
            for (let item of this.tagsToAdd)
                data["tagsToAdd"].push(item);
        }
        if (Array.isArray(this.tagsToRemove)) {
            data["tagsToRemove"] = [];
            for (let item of this.tagsToRemove)
                data["tagsToRemove"].push(item);
        }
        return data;
    }

    clone(): ModifyUserGroupMembersDto {
        const json = this.toJSON();
        let result = new ModifyUserGroupMembersDto();
        result.init(json);
        return result;
    }
}

export interface IModifyUserGroupMembersDto {
    name: string;
    userGroupType: UserGroupType;
    membersToAdd: string[] | null;
    membersToRemove: string[] | null;
    tagsToAdd: string[] | null;
    tagsToRemove: string[] | null;
}

export class UserGroupTagListSelectDto implements IUserGroupTagListSelectDto {
    metaData?: UserGroupTagListSelectMetaDataDto | null;
    tags?: UserGroupTagSelectDto[] | null;

    constructor(data?: IUserGroupTagListSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new UserGroupTagListSelectMetaDataDto(data.metaData) : <UserGroupTagListSelectMetaDataDto>this.metaData;
            if (data.tags) {
                this.tags = [];
                for (let i = 0; i < data.tags.length; i++) {
                    let item = data.tags[i];
                    this.tags[i] = item && !(<any>item).toJSON ? new UserGroupTagSelectDto(item) : <UserGroupTagSelectDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? UserGroupTagListSelectMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UserGroupTagSelectDto.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): UserGroupTagListSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupTagListSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserGroupTagListSelectDto {
        const json = this.toJSON();
        let result = new UserGroupTagListSelectDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupTagListSelectDto {
    metaData?: IUserGroupTagListSelectMetaDataDto | null;
    tags?: IUserGroupTagSelectDto[] | null;
}

export class UserGroupTagListSelectMetaDataDto implements IUserGroupTagListSelectMetaDataDto {
    totalFiltered?: number;
    totalSelected?: number;

    constructor(data?: IUserGroupTagListSelectMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalFiltered = _data["totalFiltered"] !== undefined ? _data["totalFiltered"] : <any>null;
            this.totalSelected = _data["totalSelected"] !== undefined ? _data["totalSelected"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupTagListSelectMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupTagListSelectMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFiltered"] = this.totalFiltered !== undefined ? this.totalFiltered : <any>null;
        data["totalSelected"] = this.totalSelected !== undefined ? this.totalSelected : <any>null;
        return data;
    }

    clone(): UserGroupTagListSelectMetaDataDto {
        const json = this.toJSON();
        let result = new UserGroupTagListSelectMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupTagListSelectMetaDataDto {
    totalFiltered?: number;
    totalSelected?: number;
}

export class UserGroupTagSelectDto implements IUserGroupTagSelectDto {
    tagId?: string;
    tagGroup?: string | null;
    tagDescription?: string | null;
    selected?: boolean;

    constructor(data?: IUserGroupTagSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupTagSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupTagSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): UserGroupTagSelectDto {
        const json = this.toJSON();
        let result = new UserGroupTagSelectDto();
        result.init(json);
        return result;
    }
}

export interface IUserGroupTagSelectDto {
    tagId?: string;
    tagGroup?: string | null;
    tagDescription?: string | null;
    selected?: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    firstName!: string | null;
    surname!: string | null;
    startDate!: Date;
    authentication?: UserAuthenticationDto | null;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthenticationDto(data.authentication) : <UserAuthenticationDto>this.authentication;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.authentication = _data["authentication"] ? UserAuthenticationDto.fromJS(_data["authentication"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    firstName: string | null;
    surname: string | null;
    startDate: Date;
    authentication?: IUserAuthenticationDto | null;
}

export class UserListDto implements IUserListDto {
    metaData?: UserListMetaDataDto | null;
    users?: UserDto[] | null;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new UserListMetaDataDto(data.metaData) : <UserListMetaDataDto>this.metaData;
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new UserDto(item) : <UserDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? UserListMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserListDto {
        const json = this.toJSON();
        let result = new UserListDto();
        result.init(json);
        return result;
    }
}

export interface IUserListDto {
    metaData?: IUserListMetaDataDto | null;
    users?: IUserDto[] | null;
}

export class UserListMetaDataDto implements IUserListMetaDataDto {
    new?: number;
    unenrolled?: number;
    active?: number;
    inactive?: number;
    filtered?: number;

    constructor(data?: IUserListMetaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.new = _data["new"] !== undefined ? _data["new"] : <any>null;
            this.unenrolled = _data["unenrolled"] !== undefined ? _data["unenrolled"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.inactive = _data["inactive"] !== undefined ? _data["inactive"] : <any>null;
            this.filtered = _data["filtered"] !== undefined ? _data["filtered"] : <any>null;
        }
    }

    static fromJS(data: any): UserListMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListMetaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new"] = this.new !== undefined ? this.new : <any>null;
        data["unenrolled"] = this.unenrolled !== undefined ? this.unenrolled : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["inactive"] = this.inactive !== undefined ? this.inactive : <any>null;
        data["filtered"] = this.filtered !== undefined ? this.filtered : <any>null;
        return data;
    }

    clone(): UserListMetaDataDto {
        const json = this.toJSON();
        let result = new UserListMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserListMetaDataDto {
    new?: number;
    unenrolled?: number;
    active?: number;
    inactive?: number;
    filtered?: number;
}

export class UserDto implements IUserDto {
    id?: string;
    businessAccountId?: string;
    status?: UserStatus;
    firstName!: string | null;
    surname!: string | null;
    enrolmentCode?: string | null;
    startDate!: Date;
    endDate?: Date | null;
    userGroups?: UserGroupSummaryDto[] | null;
    externalReference?: string | null;
    authentication?: UserAuthenticationDto | null;
    badges?: BadgeDto[] | null;
    profilePicture?: string | null;
    userTags?: UserTagDto[] | null;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.userGroups) {
                this.userGroups = [];
                for (let i = 0; i < data.userGroups.length; i++) {
                    let item = data.userGroups[i];
                    this.userGroups[i] = item && !(<any>item).toJSON ? new UserGroupSummaryDto(item) : <UserGroupSummaryDto>item;
                }
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthenticationDto(data.authentication) : <UserAuthenticationDto>this.authentication;
            if (data.badges) {
                this.badges = [];
                for (let i = 0; i < data.badges.length; i++) {
                    let item = data.badges[i];
                    this.badges[i] = item && !(<any>item).toJSON ? new BadgeDto(item) : <BadgeDto>item;
                }
            }
            if (data.userTags) {
                this.userTags = [];
                for (let i = 0; i < data.userTags.length; i++) {
                    let item = data.userTags[i];
                    this.userTags[i] = item && !(<any>item).toJSON ? new UserTagDto(item) : <UserTagDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.enrolmentCode = _data["enrolmentCode"] !== undefined ? _data["enrolmentCode"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(UserGroupSummaryDto.fromJS(item));
            }
            else {
                this.userGroups = <any>null;
            }
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.authentication = _data["authentication"] ? UserAuthenticationDto.fromJS(_data["authentication"]) : <any>null;
            if (Array.isArray(_data["badges"])) {
                this.badges = [] as any;
                for (let item of _data["badges"])
                    this.badges!.push(BadgeDto.fromJS(item));
            }
            else {
                this.badges = <any>null;
            }
            this.profilePicture = _data["profilePicture"] !== undefined ? _data["profilePicture"] : <any>null;
            if (Array.isArray(_data["userTags"])) {
                this.userTags = [] as any;
                for (let item of _data["userTags"])
                    this.userTags!.push(UserTagDto.fromJS(item));
            }
            else {
                this.userTags = <any>null;
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["enrolmentCode"] = this.enrolmentCode !== undefined ? this.enrolmentCode : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        if (Array.isArray(this.badges)) {
            data["badges"] = [];
            for (let item of this.badges)
                data["badges"].push(item.toJSON());
        }
        data["profilePicture"] = this.profilePicture !== undefined ? this.profilePicture : <any>null;
        if (Array.isArray(this.userTags)) {
            data["userTags"] = [];
            for (let item of this.userTags)
                data["userTags"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id?: string;
    businessAccountId?: string;
    status?: UserStatus;
    firstName: string | null;
    surname: string | null;
    enrolmentCode?: string | null;
    startDate: Date;
    endDate?: Date | null;
    userGroups?: IUserGroupSummaryDto[] | null;
    externalReference?: string | null;
    authentication?: IUserAuthenticationDto | null;
    badges?: IBadgeDto[] | null;
    profilePicture?: string | null;
    userTags?: IUserTagDto[] | null;
}

export class UserTagDto implements IUserTagDto {
    id?: string;
    userId?: string;
    tagId?: string;

    constructor(data?: IUserTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
        }
    }

    static fromJS(data: any): UserTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        return data;
    }

    clone(): UserTagDto {
        const json = this.toJSON();
        let result = new UserTagDto();
        result.init(json);
        return result;
    }
}

export interface IUserTagDto {
    id?: string;
    userId?: string;
    tagId?: string;
}

export class UserListSelectDto implements IUserListSelectDto {
    metaData?: UserListSelectMetaDataDto | null;
    users?: UserSelectDto[] | null;

    constructor(data?: IUserListSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new UserListSelectMetaDataDto(data.metaData) : <UserListSelectMetaDataDto>this.metaData;
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new UserSelectDto(item) : <UserSelectDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? UserListSelectMetaDataDto.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSelectDto.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): UserListSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserListSelectDto {
        const json = this.toJSON();
        let result = new UserListSelectDto();
        result.init(json);
        return result;
    }
}

export interface IUserListSelectDto {
    metaData?: IUserListSelectMetaDataDto | null;
    users?: IUserSelectDto[] | null;
}

export class UserListSelectMetaDataDto extends UserListMetaDataDto implements IUserListSelectMetaDataDto {
    totalSelected?: number;

    constructor(data?: IUserListSelectMetaDataDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalSelected = _data["totalSelected"] !== undefined ? _data["totalSelected"] : <any>null;
        }
    }

    static override fromJS(data: any): UserListSelectMetaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListSelectMetaDataDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSelected"] = this.totalSelected !== undefined ? this.totalSelected : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserListSelectMetaDataDto {
        const json = this.toJSON();
        let result = new UserListSelectMetaDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserListSelectMetaDataDto extends IUserListMetaDataDto {
    totalSelected?: number;
}

export class UserSelectDto implements IUserSelectDto {
    id?: string;
    status?: UserStatus;
    firstName!: string | null;
    surname!: string | null;
    startDate?: Date;
    externalReference?: string | null;
    profilePicture?: string | null;
    enrolmentCode?: string | null;
    selected?: boolean;

    constructor(data?: IUserSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.profilePicture = _data["profilePicture"] !== undefined ? _data["profilePicture"] : <any>null;
            this.enrolmentCode = _data["enrolmentCode"] !== undefined ? _data["enrolmentCode"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): UserSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["profilePicture"] = this.profilePicture !== undefined ? this.profilePicture : <any>null;
        data["enrolmentCode"] = this.enrolmentCode !== undefined ? this.enrolmentCode : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): UserSelectDto {
        const json = this.toJSON();
        let result = new UserSelectDto();
        result.init(json);
        return result;
    }
}

export interface IUserSelectDto {
    id?: string;
    status?: UserStatus;
    firstName: string | null;
    surname: string | null;
    startDate?: Date;
    externalReference?: string | null;
    profilePicture?: string | null;
    enrolmentCode?: string | null;
    selected?: boolean;
}

export class ModifyUserDto implements IModifyUserDto {
    firstName!: string | null;
    surname!: string | null;
    enrolmentCode?: string | null;
    startDate?: Date;
    endDate?: Date | null;
    externalReference?: string | null;
    authentication?: UserAuthenticationDto | null;

    constructor(data?: IModifyUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthenticationDto(data.authentication) : <UserAuthenticationDto>this.authentication;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.enrolmentCode = _data["enrolmentCode"] !== undefined ? _data["enrolmentCode"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.authentication = _data["authentication"] ? UserAuthenticationDto.fromJS(_data["authentication"]) : <any>null;
        }
    }

    static fromJS(data: any): ModifyUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["enrolmentCode"] = this.enrolmentCode !== undefined ? this.enrolmentCode : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        return data;
    }

    clone(): ModifyUserDto {
        const json = this.toJSON();
        let result = new ModifyUserDto();
        result.init(json);
        return result;
    }
}

export interface IModifyUserDto {
    firstName: string | null;
    surname: string | null;
    enrolmentCode?: string | null;
    startDate?: Date;
    endDate?: Date | null;
    externalReference?: string | null;
    authentication?: IUserAuthenticationDto | null;
}

export class CreateUserTagDto implements ICreateUserTagDto {
    userId?: string;
    tagId?: string;

    constructor(data?: ICreateUserTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        return data;
    }

    clone(): CreateUserTagDto {
        const json = this.toJSON();
        let result = new CreateUserTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserTagDto {
    userId?: string;
    tagId?: string;
}

export class GuidApiResponse implements IGuidApiResponse {
    /** Gets or Sets Result */
    result!: string;
    /** Gets or Sets Messages */
    messages?: ApiResponseMessage2[] | null;

    constructor(data?: IGuidApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(<any>item).toJSON ? new ApiResponseMessage2(item) : <ApiResponseMessage2>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ApiResponseMessage2.fromJS(item));
            }
            else {
                this.messages = <any>null;
            }
        }
    }

    static fromJS(data: any): GuidApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuidApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }

    clone(): GuidApiResponse {
        const json = this.toJSON();
        let result = new GuidApiResponse();
        result.init(json);
        return result;
    }
}

export interface IGuidApiResponse {
    /** Gets or Sets Result */
    result: string;
    /** Gets or Sets Messages */
    messages?: IApiResponseMessage2[] | null;
}

export class ApiResponseMessage2 implements IApiResponseMessage2 {
    /** Gets or Sets Level */
    level?: ApiResponseMessageLevel2;
    /** Gets or Sets Message */
    message?: string | null;
    /** Gets or Sets Field */
    field?: string | null;
    /** Gets or Sets ErrorId */
    errorId?: string;

    constructor(data?: IApiResponseMessage2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            this.errorId = _data["errorId"] !== undefined ? _data["errorId"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResponseMessage2 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseMessage2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["errorId"] = this.errorId !== undefined ? this.errorId : <any>null;
        return data;
    }

    clone(): ApiResponseMessage2 {
        const json = this.toJSON();
        let result = new ApiResponseMessage2();
        result.init(json);
        return result;
    }
}

export interface IApiResponseMessage2 {
    /** Gets or Sets Level */
    level?: ApiResponseMessageLevel2;
    /** Gets or Sets Message */
    message?: string | null;
    /** Gets or Sets Field */
    field?: string | null;
    /** Gets or Sets ErrorId */
    errorId?: string;
}

/** Gets or Sets ApiResponseMessageLevel */
export enum ApiResponseMessageLevel2 {
    _0Enum = 0,
    _1Enum = 1,
    _2Enum = 2,
    _3Enum = 3,
}

/** Implementation of [RFC7807](https://tools.ietf.org/html/rfc7807) Problem Details object.  Content type should always be ```application/problem+json```.  Problem type definitions MAY extend the problem details object with additional members */
export class ProblemDetailsModel implements IProblemDetailsModel {
    /** A type URI */
    type!: string;
    /** A short, human-readable summary of the problem type */
    title!: string;
    /** The HTTP status code for this occurrence of the problem */
    status!: number;
    /** A human-readable explanation specific to this occurrence of the problem */
    detail?: string | null;
    /** A list of issues that exist with the request. Note this is an extension that is supported by the RFC but specific to Advanced. */
    issues?: ProblemDetailsModelIssuesInner[] | null;
    /** A URI reference that identifies the specific occurrence of the problem.  It may or may not yield further information if dereferenced */
    instance?: string | null;

    constructor(data?: IProblemDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.issues) {
                this.issues = [];
                for (let i = 0; i < data.issues.length; i++) {
                    let item = data.issues[i];
                    this.issues[i] = item && !(<any>item).toJSON ? new ProblemDetailsModelIssuesInner(item) : <ProblemDetailsModelIssuesInner>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(ProblemDetailsModelIssuesInner.fromJS(item));
            }
            else {
                this.issues = <any>null;
            }
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }

    clone(): ProblemDetailsModel {
        const json = this.toJSON();
        let result = new ProblemDetailsModel();
        result.init(json);
        return result;
    }
}

/** Implementation of [RFC7807](https://tools.ietf.org/html/rfc7807) Problem Details object.  Content type should always be ```application/problem+json```.  Problem type definitions MAY extend the problem details object with additional members */
export interface IProblemDetailsModel {
    /** A type URI */
    type: string;
    /** A short, human-readable summary of the problem type */
    title: string;
    /** The HTTP status code for this occurrence of the problem */
    status: number;
    /** A human-readable explanation specific to this occurrence of the problem */
    detail?: string | null;
    /** A list of issues that exist with the request. Note this is an extension that is supported by the RFC but specific to Advanced. */
    issues?: IProblemDetailsModelIssuesInner[] | null;
    /** A URI reference that identifies the specific occurrence of the problem.  It may or may not yield further information if dereferenced */
    instance?: string | null;
}

export class ProblemDetailsModelIssuesInner implements IProblemDetailsModelIssuesInner {
    /** Gets or Sets FieldName */
    fieldName?: string | null;
    /** Gets or Sets Error */
    error?: string | null;

    constructor(data?: IProblemDetailsModelIssuesInner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetailsModelIssuesInner {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetailsModelIssuesInner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data;
    }

    clone(): ProblemDetailsModelIssuesInner {
        const json = this.toJSON();
        let result = new ProblemDetailsModelIssuesInner();
        result.init(json);
        return result;
    }
}

export interface IProblemDetailsModelIssuesInner {
    /** Gets or Sets FieldName */
    fieldName?: string | null;
    /** Gets or Sets Error */
    error?: string | null;
}

export class ActivityCreate implements IActivityCreate {
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets Description */
    description!: string;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets ExternalId */
    externalId?: string | null;
    /** Gets or Sets ImportId */
    importId?: string;

    constructor(data?: IActivityCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.importId = _data["importId"] !== undefined ? _data["importId"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityCreate {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["importId"] = this.importId !== undefined ? this.importId : <any>null;
        return data;
    }

    clone(): ActivityCreate {
        const json = this.toJSON();
        let result = new ActivityCreate();
        result.init(json);
        return result;
    }
}

export interface IActivityCreate {
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets Description */
    description: string;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets ExternalId */
    externalId?: string | null;
    /** Gets or Sets ImportId */
    importId?: string;
}

export class ActivityResponse implements IActivityResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets Description */
    description!: string;
    /** Gets or Sets ExternalReference */
    externalReference!: string;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;

    constructor(data?: IActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): ActivityResponse {
        const json = this.toJSON();
        let result = new ActivityResponse();
        result.init(json);
        return result;
    }
}

export interface IActivityResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets Description */
    description: string;
    /** Gets or Sets ExternalReference */
    externalReference: string;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;
}

export class ActivityModify implements IActivityModify {
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets Description */
    description!: string;
    /** Gets or Sets ExternalReference */
    externalReference!: string;

    constructor(data?: IActivityModify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityModify {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityModify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        return data;
    }

    clone(): ActivityModify {
        const json = this.toJSON();
        let result = new ActivityModify();
        result.init(json);
        return result;
    }
}

export interface IActivityModify {
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets Description */
    description: string;
    /** Gets or Sets ExternalReference */
    externalReference: string;
}

export class BadgeCreate implements IBadgeCreate {
    /** Gets or Sets UserId */
    userId!: string;
    /** Gets or Sets BadgeNumber */
    badgeNumber!: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;

    constructor(data?: IBadgeCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BadgeCreate {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }

    clone(): BadgeCreate {
        const json = this.toJSON();
        let result = new BadgeCreate();
        result.init(json);
        return result;
    }
}

export interface IBadgeCreate {
    /** Gets or Sets UserId */
    userId: string;
    /** Gets or Sets BadgeNumber */
    badgeNumber: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
}

export class BadgeResponse implements IBadgeResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets UserId */
    userId?: string;
    /** Gets or Sets BadgeNumber */
    badgeNumber!: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;

    constructor(data?: IBadgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): BadgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): BadgeResponse {
        const json = this.toJSON();
        let result = new BadgeResponse();
        result.init(json);
        return result;
    }
}

export interface IBadgeResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets UserId */
    userId?: string;
    /** Gets or Sets BadgeNumber */
    badgeNumber: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;
}

export class BadgeModify implements IBadgeModify {
    /** Gets or Sets BadgeNumber */
    badgeNumber!: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;

    constructor(data?: IBadgeModify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : <any>null;
            this.badgeActive = _data["badgeActive"] !== undefined ? _data["badgeActive"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BadgeModify {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeModify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : <any>null;
        data["badgeActive"] = this.badgeActive !== undefined ? this.badgeActive : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }

    clone(): BadgeModify {
        const json = this.toJSON();
        let result = new BadgeModify();
        result.init(json);
        return result;
    }
}

export interface IBadgeModify {
    /** Gets or Sets BadgeNumber */
    badgeNumber: string;
    /** Gets or Sets BadgeActive */
    badgeActive?: boolean;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
}

export class ClockingListResponse implements IClockingListResponse {
    /** Gets or Sets MetaData */
    metaData?: ClockingListMetaDataResponse | null;
    /** Gets or Sets Clockings */
    clockings!: ClockingResponse[];

    constructor(data?: IClockingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new ClockingListMetaDataResponse(data.metaData) : <ClockingListMetaDataResponse>this.metaData;
            if (data.clockings) {
                this.clockings = [];
                for (let i = 0; i < data.clockings.length; i++) {
                    let item = data.clockings[i];
                    this.clockings[i] = item && !(<any>item).toJSON ? new ClockingResponse(item) : <ClockingResponse>item;
                }
            }
        }
        if (!data) {
            this.clockings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? ClockingListMetaDataResponse.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["clockings"])) {
                this.clockings = [] as any;
                for (let item of _data["clockings"])
                    this.clockings!.push(ClockingResponse.fromJS(item));
            }
            else {
                this.clockings = <any>null;
            }
        }
    }

    static fromJS(data: any): ClockingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.clockings)) {
            data["clockings"] = [];
            for (let item of this.clockings)
                data["clockings"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClockingListResponse {
        const json = this.toJSON();
        let result = new ClockingListResponse();
        result.init(json);
        return result;
    }
}

export interface IClockingListResponse {
    /** Gets or Sets MetaData */
    metaData?: IClockingListMetaDataResponse | null;
    /** Gets or Sets Clockings */
    clockings: IClockingResponse[];
}

export class ClockingListMetaDataResponse implements IClockingListMetaDataResponse {
    /** Gets or Sets FilteredTotal */
    filteredTotal?: number;
    /** Gets or Sets HasAuthenticationType */
    hasAuthenticationType?: boolean;
    /** Gets or Sets HasAnalysis */
    hasAnalysis?: boolean;

    constructor(data?: IClockingListMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
            this.hasAuthenticationType = _data["hasAuthenticationType"] !== undefined ? _data["hasAuthenticationType"] : <any>null;
            this.hasAnalysis = _data["hasAnalysis"] !== undefined ? _data["hasAnalysis"] : <any>null;
        }
    }

    static fromJS(data: any): ClockingListMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingListMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        data["hasAuthenticationType"] = this.hasAuthenticationType !== undefined ? this.hasAuthenticationType : <any>null;
        data["hasAnalysis"] = this.hasAnalysis !== undefined ? this.hasAnalysis : <any>null;
        return data;
    }

    clone(): ClockingListMetaDataResponse {
        const json = this.toJSON();
        let result = new ClockingListMetaDataResponse();
        result.init(json);
        return result;
    }
}

export interface IClockingListMetaDataResponse {
    /** Gets or Sets FilteredTotal */
    filteredTotal?: number;
    /** Gets or Sets HasAuthenticationType */
    hasAuthenticationType?: boolean;
    /** Gets or Sets HasAnalysis */
    hasAnalysis?: boolean;
}

export class ClockingResponse implements IClockingResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets TransactionId */
    transactionId?: string;
    /** Gets or Sets UserId */
    userId?: string;
    /** Gets or Sets Firstname */
    firstname?: string | null;
    /** Gets or Sets Surname */
    surname?: string | null;
    /** Gets or Sets DeviceName */
    deviceName?: string | null;
    /** Gets or Sets ClockingDateTime */
    clockingDateTime?: Date;
    /** Gets or Sets Direction */
    direction?: ClockingDirection2;
    /** Gets or Sets DirectionMethod */
    directionMethod?: ClockingDirectionMethod2;
    /** Gets or Sets ToggleSourceDateTime */
    toggleSourceDateTime?: Date | null;
    /** Gets or Sets ToggleSourceDirection */
    toggleSourceDirection?: ClockingDirection2;
    /** Gets or Sets ClockingPicture */
    clockingPicture?: string | null;
    /** Gets or Sets UsedFingerprint */
    usedFingerprint?: boolean;
    /** Gets or Sets UsedFace */
    usedFace?: boolean;
    /** Gets or Sets UsedProximity */
    usedProximity?: boolean;
    /** Gets or Sets UsedKeyboard */
    usedKeyboard?: boolean;
    /** Gets or Sets MatchingScore */
    matchingScore?: number;
    /** Gets or Sets AnalysisResult */
    analysisResult?: string | null;
    /** Gets or Sets AnalysisResultValue */
    analysisResultValue?: AnalysisTestItemResultPageItemResponse[] | null;
    /** Gets or Sets AnalysisConfidenceScore */
    analysisConfidenceScore?: number;

    constructor(data?: IClockingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.analysisResultValue) {
                this.analysisResultValue = [];
                for (let i = 0; i < data.analysisResultValue.length; i++) {
                    let item = data.analysisResultValue[i];
                    this.analysisResultValue[i] = item && !(<any>item).toJSON ? new AnalysisTestItemResultPageItemResponse(item) : <AnalysisTestItemResultPageItemResponse>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.deviceName = _data["deviceName"] !== undefined ? _data["deviceName"] : <any>null;
            this.clockingDateTime = _data["clockingDateTime"] ? new Date(_data["clockingDateTime"].toString()) : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.directionMethod = _data["directionMethod"] !== undefined ? _data["directionMethod"] : <any>null;
            this.toggleSourceDateTime = _data["toggleSourceDateTime"] ? new Date(_data["toggleSourceDateTime"].toString()) : <any>null;
            this.toggleSourceDirection = _data["toggleSourceDirection"] !== undefined ? _data["toggleSourceDirection"] : <any>null;
            this.clockingPicture = _data["clockingPicture"] !== undefined ? _data["clockingPicture"] : <any>null;
            this.usedFingerprint = _data["usedFingerprint"] !== undefined ? _data["usedFingerprint"] : <any>null;
            this.usedFace = _data["usedFace"] !== undefined ? _data["usedFace"] : <any>null;
            this.usedProximity = _data["usedProximity"] !== undefined ? _data["usedProximity"] : <any>null;
            this.usedKeyboard = _data["usedKeyboard"] !== undefined ? _data["usedKeyboard"] : <any>null;
            this.matchingScore = _data["matchingScore"] !== undefined ? _data["matchingScore"] : <any>null;
            this.analysisResult = _data["analysisResult"] !== undefined ? _data["analysisResult"] : <any>null;
            if (Array.isArray(_data["analysisResultValue"])) {
                this.analysisResultValue = [] as any;
                for (let item of _data["analysisResultValue"])
                    this.analysisResultValue!.push(AnalysisTestItemResultPageItemResponse.fromJS(item));
            }
            else {
                this.analysisResultValue = <any>null;
            }
            this.analysisConfidenceScore = _data["analysisConfidenceScore"] !== undefined ? _data["analysisConfidenceScore"] : <any>null;
        }
    }

    static fromJS(data: any): ClockingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["deviceName"] = this.deviceName !== undefined ? this.deviceName : <any>null;
        data["clockingDateTime"] = this.clockingDateTime ? this.clockingDateTime.toISOString() : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["directionMethod"] = this.directionMethod !== undefined ? this.directionMethod : <any>null;
        data["toggleSourceDateTime"] = this.toggleSourceDateTime ? this.toggleSourceDateTime.toISOString() : <any>null;
        data["toggleSourceDirection"] = this.toggleSourceDirection !== undefined ? this.toggleSourceDirection : <any>null;
        data["clockingPicture"] = this.clockingPicture !== undefined ? this.clockingPicture : <any>null;
        data["usedFingerprint"] = this.usedFingerprint !== undefined ? this.usedFingerprint : <any>null;
        data["usedFace"] = this.usedFace !== undefined ? this.usedFace : <any>null;
        data["usedProximity"] = this.usedProximity !== undefined ? this.usedProximity : <any>null;
        data["usedKeyboard"] = this.usedKeyboard !== undefined ? this.usedKeyboard : <any>null;
        data["matchingScore"] = this.matchingScore !== undefined ? this.matchingScore : <any>null;
        data["analysisResult"] = this.analysisResult !== undefined ? this.analysisResult : <any>null;
        if (Array.isArray(this.analysisResultValue)) {
            data["analysisResultValue"] = [];
            for (let item of this.analysisResultValue)
                data["analysisResultValue"].push(item.toJSON());
        }
        data["analysisConfidenceScore"] = this.analysisConfidenceScore !== undefined ? this.analysisConfidenceScore : <any>null;
        return data;
    }

    clone(): ClockingResponse {
        const json = this.toJSON();
        let result = new ClockingResponse();
        result.init(json);
        return result;
    }
}

export interface IClockingResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets TransactionId */
    transactionId?: string;
    /** Gets or Sets UserId */
    userId?: string;
    /** Gets or Sets Firstname */
    firstname?: string | null;
    /** Gets or Sets Surname */
    surname?: string | null;
    /** Gets or Sets DeviceName */
    deviceName?: string | null;
    /** Gets or Sets ClockingDateTime */
    clockingDateTime?: Date;
    /** Gets or Sets Direction */
    direction?: ClockingDirection2;
    /** Gets or Sets DirectionMethod */
    directionMethod?: ClockingDirectionMethod2;
    /** Gets or Sets ToggleSourceDateTime */
    toggleSourceDateTime?: Date | null;
    /** Gets or Sets ToggleSourceDirection */
    toggleSourceDirection?: ClockingDirection2;
    /** Gets or Sets ClockingPicture */
    clockingPicture?: string | null;
    /** Gets or Sets UsedFingerprint */
    usedFingerprint?: boolean;
    /** Gets or Sets UsedFace */
    usedFace?: boolean;
    /** Gets or Sets UsedProximity */
    usedProximity?: boolean;
    /** Gets or Sets UsedKeyboard */
    usedKeyboard?: boolean;
    /** Gets or Sets MatchingScore */
    matchingScore?: number;
    /** Gets or Sets AnalysisResult */
    analysisResult?: string | null;
    /** Gets or Sets AnalysisResultValue */
    analysisResultValue?: IAnalysisTestItemResultPageItemResponse[] | null;
    /** Gets or Sets AnalysisConfidenceScore */
    analysisConfidenceScore?: number;
}

/** Gets or Sets ClockingDirection */
export enum ClockingDirection2 {
    _0Enum = 0,
    _1Enum = 1,
    _2Enum = 2,
}

/** Gets or Sets ClockingDirectionMethod */
export enum ClockingDirectionMethod2 {
    NotRecordedEnum = "NotRecorded",
    NoDirectionEnum = "NoDirection",
    ToggleEnum = "Toggle",
    SelectedInEnum = "SelectedIn",
    SelectedOutEnum = "SelectedOut",
    SwitchedAfterClockingEnum = "SwitchedAfterClocking",
}

export class AnalysisTestItemResultPageItemResponse implements IAnalysisTestItemResultPageItemResponse {
    /** Gets or Sets TestName */
    testName!: string;
    /** Gets or Sets AdditionalDetail */
    additionalDetail?: string | null;
    /** Gets or Sets Test */
    test?: ClockingAnalysisResultResponse;
    /** Gets or Sets TestResult */
    testResult!: boolean;
    /** Gets or Sets ConfidenceScore */
    confidenceScore?: number;

    constructor(data?: IAnalysisTestItemResultPageItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testName = _data["testName"] !== undefined ? _data["testName"] : <any>null;
            this.additionalDetail = _data["additionalDetail"] !== undefined ? _data["additionalDetail"] : <any>null;
            this.test = _data["test"] !== undefined ? _data["test"] : <any>null;
            this.testResult = _data["testResult"] !== undefined ? _data["testResult"] : <any>null;
            this.confidenceScore = _data["confidenceScore"] !== undefined ? _data["confidenceScore"] : <any>null;
        }
    }

    static fromJS(data: any): AnalysisTestItemResultPageItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTestItemResultPageItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testName"] = this.testName !== undefined ? this.testName : <any>null;
        data["additionalDetail"] = this.additionalDetail !== undefined ? this.additionalDetail : <any>null;
        data["test"] = this.test !== undefined ? this.test : <any>null;
        data["testResult"] = this.testResult !== undefined ? this.testResult : <any>null;
        data["confidenceScore"] = this.confidenceScore !== undefined ? this.confidenceScore : <any>null;
        return data;
    }

    clone(): AnalysisTestItemResultPageItemResponse {
        const json = this.toJSON();
        let result = new AnalysisTestItemResultPageItemResponse();
        result.init(json);
        return result;
    }
}

export interface IAnalysisTestItemResultPageItemResponse {
    /** Gets or Sets TestName */
    testName: string;
    /** Gets or Sets AdditionalDetail */
    additionalDetail?: string | null;
    /** Gets or Sets Test */
    test?: ClockingAnalysisResultResponse;
    /** Gets or Sets TestResult */
    testResult: boolean;
    /** Gets or Sets ConfidenceScore */
    confidenceScore?: number;
}

/** Gets or Sets ClockingAnalysisResultResponse */
export enum ClockingAnalysisResultResponse {
    NotAnalysedEnum = "NotAnalysed",
    OkEnum = "Ok",
    UnexpectedTimeOfDayEnum = "UnexpectedTimeOfDay",
    UnexpectedDirectionEnum = "UnexpectedDirection",
    UnexpectedDayOfWeekEnum = "UnexpectedDayOfWeek",
    UnexpectedDeviceEnum = "UnexpectedDevice",
    UnexpectedTimeForBusinessEnum = "UnexpectedTimeForBusiness",
    UnexpectedAuthenticationTypeEnum = "UnexpectedAuthenticationType",
}

export class DeviceActivitiesListResponse implements IDeviceActivitiesListResponse {
    /** Gets or Sets MetaData */
    metaData?: ActivityListMetaDataResponse | null;
    /** Gets or Sets Activities */
    activities!: ActivitySelectionResponse[];

    constructor(data?: IDeviceActivitiesListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new ActivityListMetaDataResponse(data.metaData) : <ActivityListMetaDataResponse>this.metaData;
            if (data.activities) {
                this.activities = [];
                for (let i = 0; i < data.activities.length; i++) {
                    let item = data.activities[i];
                    this.activities[i] = item && !(<any>item).toJSON ? new ActivitySelectionResponse(item) : <ActivitySelectionResponse>item;
                }
            }
        }
        if (!data) {
            this.activities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? ActivityListMetaDataResponse.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ActivitySelectionResponse.fromJS(item));
            }
            else {
                this.activities = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviceActivitiesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceActivitiesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeviceActivitiesListResponse {
        const json = this.toJSON();
        let result = new DeviceActivitiesListResponse();
        result.init(json);
        return result;
    }
}

export interface IDeviceActivitiesListResponse {
    /** Gets or Sets MetaData */
    metaData?: IActivityListMetaDataResponse | null;
    /** Gets or Sets Activities */
    activities: IActivitySelectionResponse[];
}

export class ActivityListMetaDataResponse implements IActivityListMetaDataResponse {
    /** Gets or Sets Filtered */
    filtered?: number;
    /** Gets or Sets Selected */
    selected?: number;

    constructor(data?: IActivityListMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filtered = _data["filtered"] !== undefined ? _data["filtered"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityListMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityListMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filtered"] = this.filtered !== undefined ? this.filtered : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): ActivityListMetaDataResponse {
        const json = this.toJSON();
        let result = new ActivityListMetaDataResponse();
        result.init(json);
        return result;
    }
}

export interface IActivityListMetaDataResponse {
    /** Gets or Sets Filtered */
    filtered?: number;
    /** Gets or Sets Selected */
    selected?: number;
}

export class ActivitySelectionResponse implements IActivitySelectionResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets Description */
    description!: string;
    /** Gets or Sets Selected */
    selected!: boolean;

    constructor(data?: IActivitySelectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): ActivitySelectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySelectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }

    clone(): ActivitySelectionResponse {
        const json = this.toJSON();
        let result = new ActivitySelectionResponse();
        result.init(json);
        return result;
    }
}

export interface IActivitySelectionResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets Description */
    description: string;
    /** Gets or Sets Selected */
    selected: boolean;
}

export class DeviceActivitiesModify implements IDeviceActivitiesModify {
    /** Gets or Sets ActivitiesToAdd */
    activitiesToAdd!: string[];
    /** Gets or Sets ActivitiesToRemove */
    activitiesToRemove!: string[];

    constructor(data?: IDeviceActivitiesModify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activitiesToAdd = [];
            this.activitiesToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activitiesToAdd"])) {
                this.activitiesToAdd = [] as any;
                for (let item of _data["activitiesToAdd"])
                    this.activitiesToAdd!.push(item);
            }
            else {
                this.activitiesToAdd = <any>null;
            }
            if (Array.isArray(_data["activitiesToRemove"])) {
                this.activitiesToRemove = [] as any;
                for (let item of _data["activitiesToRemove"])
                    this.activitiesToRemove!.push(item);
            }
            else {
                this.activitiesToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviceActivitiesModify {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceActivitiesModify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activitiesToAdd)) {
            data["activitiesToAdd"] = [];
            for (let item of this.activitiesToAdd)
                data["activitiesToAdd"].push(item);
        }
        if (Array.isArray(this.activitiesToRemove)) {
            data["activitiesToRemove"] = [];
            for (let item of this.activitiesToRemove)
                data["activitiesToRemove"].push(item);
        }
        return data;
    }

    clone(): DeviceActivitiesModify {
        const json = this.toJSON();
        let result = new DeviceActivitiesModify();
        result.init(json);
        return result;
    }
}

export interface IDeviceActivitiesModify {
    /** Gets or Sets ActivitiesToAdd */
    activitiesToAdd: string[];
    /** Gets or Sets ActivitiesToRemove */
    activitiesToRemove: string[];
}

export class DeviceResponse implements IDeviceResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets DeviceType */
    deviceType?: DeviceType2;
    /** Gets or Sets SerialNumber */
    serialNumber?: string | null;
    /** Gets or Sets FirstRegistrationDate */
    firstRegistrationDate?: Date;
    /** Gets or Sets LastRegistrationDate */
    lastRegistrationDate?: Date;
    /** Gets or Sets EngineerPin */
    engineerPin?: string | null;
    /** Gets or Sets EngineerUserId */
    engineerUserId?: string;
    /** Gets or Sets EngineerPinExpiryDate */
    engineerPinExpiryDate?: Date;
    /** Gets or Sets DeviceActive */
    deviceActive?: boolean;
    /** Gets or Sets External */
    external?: boolean;
    /** Gets or Sets CurrentFirmwareVersion */
    currentFirmwareVersion?: string | null;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;

    constructor(data?: IDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.deviceType = _data["deviceType"] !== undefined ? _data["deviceType"] : <any>null;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : <any>null;
            this.firstRegistrationDate = _data["firstRegistrationDate"] ? new Date(_data["firstRegistrationDate"].toString()) : <any>null;
            this.lastRegistrationDate = _data["lastRegistrationDate"] ? new Date(_data["lastRegistrationDate"].toString()) : <any>null;
            this.engineerPin = _data["engineerPin"] !== undefined ? _data["engineerPin"] : <any>null;
            this.engineerUserId = _data["engineerUserId"] !== undefined ? _data["engineerUserId"] : <any>null;
            this.engineerPinExpiryDate = _data["engineerPinExpiryDate"] ? new Date(_data["engineerPinExpiryDate"].toString()) : <any>null;
            this.deviceActive = _data["deviceActive"] !== undefined ? _data["deviceActive"] : <any>null;
            this.external = _data["external"] !== undefined ? _data["external"] : <any>null;
            this.currentFirmwareVersion = _data["currentFirmwareVersion"] !== undefined ? _data["currentFirmwareVersion"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["deviceType"] = this.deviceType !== undefined ? this.deviceType : <any>null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
        data["firstRegistrationDate"] = this.firstRegistrationDate ? this.firstRegistrationDate.toISOString() : <any>null;
        data["lastRegistrationDate"] = this.lastRegistrationDate ? this.lastRegistrationDate.toISOString() : <any>null;
        data["engineerPin"] = this.engineerPin !== undefined ? this.engineerPin : <any>null;
        data["engineerUserId"] = this.engineerUserId !== undefined ? this.engineerUserId : <any>null;
        data["engineerPinExpiryDate"] = this.engineerPinExpiryDate ? this.engineerPinExpiryDate.toISOString() : <any>null;
        data["deviceActive"] = this.deviceActive !== undefined ? this.deviceActive : <any>null;
        data["external"] = this.external !== undefined ? this.external : <any>null;
        data["currentFirmwareVersion"] = this.currentFirmwareVersion !== undefined ? this.currentFirmwareVersion : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): DeviceResponse {
        const json = this.toJSON();
        let result = new DeviceResponse();
        result.init(json);
        return result;
    }
}

export interface IDeviceResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets DeviceType */
    deviceType?: DeviceType2;
    /** Gets or Sets SerialNumber */
    serialNumber?: string | null;
    /** Gets or Sets FirstRegistrationDate */
    firstRegistrationDate?: Date;
    /** Gets or Sets LastRegistrationDate */
    lastRegistrationDate?: Date;
    /** Gets or Sets EngineerPin */
    engineerPin?: string | null;
    /** Gets or Sets EngineerUserId */
    engineerUserId?: string;
    /** Gets or Sets EngineerPinExpiryDate */
    engineerPinExpiryDate?: Date;
    /** Gets or Sets DeviceActive */
    deviceActive?: boolean;
    /** Gets or Sets External */
    external?: boolean;
    /** Gets or Sets CurrentFirmwareVersion */
    currentFirmwareVersion?: string | null;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;
}

/** Gets or Sets DeviceType */
export enum DeviceType2 {
    _0Enum = 0,
    _1Enum = 1,
    _2Enum = 2,
    _3Enum = 3,
}

export class SiteSummaryResponse implements ISiteSummaryResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets HouseOrNumber */
    houseOrNumber?: string | null;
    /** Gets or Sets AddressLine1 */
    addressLine1?: string | null;
    /** Gets or Sets AddressLine2 */
    addressLine2?: string | null;
    /** Gets or Sets TownCity */
    townCity?: string | null;
    /** Gets or Sets County */
    county?: string | null;
    /** Gets or Sets PostCode */
    postCode?: string | null;
    /** Gets or Sets Country */
    country?: string | null;
    /** Gets or Sets TelephoneNumber */
    telephoneNumber?: string | null;
    /** Gets or Sets Latitude */
    latitude?: number;
    /** Gets or Sets Longitude */
    longitude?: number;

    constructor(data?: ISiteSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): SiteSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }

    clone(): SiteSummaryResponse {
        const json = this.toJSON();
        let result = new SiteSummaryResponse();
        result.init(json);
        return result;
    }
}

export interface ISiteSummaryResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets HouseOrNumber */
    houseOrNumber?: string | null;
    /** Gets or Sets AddressLine1 */
    addressLine1?: string | null;
    /** Gets or Sets AddressLine2 */
    addressLine2?: string | null;
    /** Gets or Sets TownCity */
    townCity?: string | null;
    /** Gets or Sets County */
    county?: string | null;
    /** Gets or Sets PostCode */
    postCode?: string | null;
    /** Gets or Sets Country */
    country?: string | null;
    /** Gets or Sets TelephoneNumber */
    telephoneNumber?: string | null;
    /** Gets or Sets Latitude */
    latitude?: number;
    /** Gets or Sets Longitude */
    longitude?: number;
}

export class SiteResponse implements ISiteResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name!: string;
    /** Gets or Sets HouseOrNumber */
    houseOrNumber?: string | null;
    /** Gets or Sets AddressLine1 */
    addressLine1?: string | null;
    /** Gets or Sets AddressLine2 */
    addressLine2?: string | null;
    /** Gets or Sets TownCity */
    townCity?: string | null;
    /** Gets or Sets County */
    county?: string | null;
    /** Gets or Sets PostCode */
    postCode?: string | null;
    /** Gets or Sets Country */
    country?: string | null;
    /** Gets or Sets TelephoneNumber */
    telephoneNumber?: string | null;
    /** Gets or Sets Latitude */
    latitude?: number;
    /** Gets or Sets Longitude */
    longitude?: number;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;

    constructor(data?: ISiteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.houseOrNumber = _data["houseOrNumber"] !== undefined ? _data["houseOrNumber"] : <any>null;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.townCity = _data["townCity"] !== undefined ? _data["townCity"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.telephoneNumber = _data["telephoneNumber"] !== undefined ? _data["telephoneNumber"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.entityVersion = _data["entityVersion"] !== undefined ? _data["entityVersion"] : <any>null;
        }
    }

    static fromJS(data: any): SiteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SiteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["houseOrNumber"] = this.houseOrNumber !== undefined ? this.houseOrNumber : <any>null;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["townCity"] = this.townCity !== undefined ? this.townCity : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["telephoneNumber"] = this.telephoneNumber !== undefined ? this.telephoneNumber : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["entityVersion"] = this.entityVersion !== undefined ? this.entityVersion : <any>null;
        return data;
    }

    clone(): SiteResponse {
        const json = this.toJSON();
        let result = new SiteResponse();
        result.init(json);
        return result;
    }
}

export interface ISiteResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Name */
    name: string;
    /** Gets or Sets HouseOrNumber */
    houseOrNumber?: string | null;
    /** Gets or Sets AddressLine1 */
    addressLine1?: string | null;
    /** Gets or Sets AddressLine2 */
    addressLine2?: string | null;
    /** Gets or Sets TownCity */
    townCity?: string | null;
    /** Gets or Sets County */
    county?: string | null;
    /** Gets or Sets PostCode */
    postCode?: string | null;
    /** Gets or Sets Country */
    country?: string | null;
    /** Gets or Sets TelephoneNumber */
    telephoneNumber?: string | null;
    /** Gets or Sets Latitude */
    latitude?: number;
    /** Gets or Sets Longitude */
    longitude?: number;
    /** Gets or Sets EntityVersion */
    entityVersion?: string;
}

export class TagCreate implements ITagCreate {
    /** Gets or Sets TagGroup */
    tagGroup!: string;
    /** Gets or Sets TagDescription */
    tagDescription!: string;

    constructor(data?: ITagCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TagCreate {
        data = typeof data === 'object' ? data : {};
        let result = new TagCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): TagCreate {
        const json = this.toJSON();
        let result = new TagCreate();
        result.init(json);
        return result;
    }
}

export interface ITagCreate {
    /** Gets or Sets TagGroup */
    tagGroup: string;
    /** Gets or Sets TagDescription */
    tagDescription: string;
}

export class TagResponse implements ITagResponse {
    /** Gets or Sets Id */
    id!: string;
    /** Gets or Sets TagGroup */
    tagGroup!: string;
    /** Gets or Sets TagDescription */
    tagDescription!: string;

    constructor(data?: ITagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): TagResponse {
        const json = this.toJSON();
        let result = new TagResponse();
        result.init(json);
        return result;
    }
}

export interface ITagResponse {
    /** Gets or Sets Id */
    id: string;
    /** Gets or Sets TagGroup */
    tagGroup: string;
    /** Gets or Sets TagDescription */
    tagDescription: string;
}

export class TagPageableListResponse implements ITagPageableListResponse {
    /** Gets or Sets MetaData */
    metaData?: TagListMetaDataResponse | null;
    /** Gets or Sets Tags */
    tags!: TagResponse[];

    constructor(data?: ITagPageableListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new TagListMetaDataResponse(data.metaData) : <TagListMetaDataResponse>this.metaData;
            if (data.tags) {
                this.tags = [];
                for (let i = 0; i < data.tags.length; i++) {
                    let item = data.tags[i];
                    this.tags[i] = item && !(<any>item).toJSON ? new TagResponse(item) : <TagResponse>item;
                }
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? TagListMetaDataResponse.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagResponse.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): TagPageableListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagPageableListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }

    clone(): TagPageableListResponse {
        const json = this.toJSON();
        let result = new TagPageableListResponse();
        result.init(json);
        return result;
    }
}

export interface ITagPageableListResponse {
    /** Gets or Sets MetaData */
    metaData?: ITagListMetaDataResponse | null;
    /** Gets or Sets Tags */
    tags: ITagResponse[];
}

export class TagListMetaDataResponse implements ITagListMetaDataResponse {
    /** Gets or Sets FilteredTotal */
    filteredTotal?: number;

    constructor(data?: ITagListMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredTotal = _data["filteredTotal"] !== undefined ? _data["filteredTotal"] : <any>null;
        }
    }

    static fromJS(data: any): TagListMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagListMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredTotal"] = this.filteredTotal !== undefined ? this.filteredTotal : <any>null;
        return data;
    }

    clone(): TagListMetaDataResponse {
        const json = this.toJSON();
        let result = new TagListMetaDataResponse();
        result.init(json);
        return result;
    }
}

export interface ITagListMetaDataResponse {
    /** Gets or Sets FilteredTotal */
    filteredTotal?: number;
}

export class TagModify implements ITagModify {
    /** Gets or Sets TagGroup */
    tagGroup!: string;
    /** Gets or Sets TagDescription */
    tagDescription?: string | null;

    constructor(data?: ITagModify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagGroup = _data["tagGroup"] !== undefined ? _data["tagGroup"] : <any>null;
            this.tagDescription = _data["tagDescription"] !== undefined ? _data["tagDescription"] : <any>null;
        }
    }

    static fromJS(data: any): TagModify {
        data = typeof data === 'object' ? data : {};
        let result = new TagModify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagGroup"] = this.tagGroup !== undefined ? this.tagGroup : <any>null;
        data["tagDescription"] = this.tagDescription !== undefined ? this.tagDescription : <any>null;
        return data;
    }

    clone(): TagModify {
        const json = this.toJSON();
        let result = new TagModify();
        result.init(json);
        return result;
    }
}

export interface ITagModify {
    /** Gets or Sets TagGroup */
    tagGroup: string;
    /** Gets or Sets TagDescription */
    tagDescription?: string | null;
}

export class UserCreate implements IUserCreate {
    /** Gets or Sets FirstName */
    firstName!: string;
    /** Gets or Sets Surname */
    surname!: string;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets Authentication */
    authentication?: UserAuthentication | null;

    constructor(data?: IUserCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthentication(data.authentication) : <UserAuthentication>this.authentication;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.authentication = _data["authentication"] ? UserAuthentication.fromJS(_data["authentication"]) : <any>null;
        }
    }

    static fromJS(data: any): UserCreate {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        return data;
    }

    clone(): UserCreate {
        const json = this.toJSON();
        let result = new UserCreate();
        result.init(json);
        return result;
    }
}

export interface IUserCreate {
    /** Gets or Sets FirstName */
    firstName: string;
    /** Gets or Sets Surname */
    surname: string;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets Authentication */
    authentication?: IUserAuthentication | null;
}

export class UserAuthentication implements IUserAuthentication {
    /** Gets or Sets Fingerprint */
    fingerprint?: boolean;
    /** Gets or Sets ProxCard */
    proxCard?: boolean;
    /** Gets or Sets Faceprint */
    faceprint?: boolean;
    /** Gets or Sets UserPin */
    userPin?: boolean;
    /** Gets or Sets FingerprintCard */
    fingerprintCard?: boolean;
    /** Gets or Sets FaceCard */
    faceCard?: boolean;

    constructor(data?: IUserAuthentication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fingerprint = _data["fingerprint"] !== undefined ? _data["fingerprint"] : <any>null;
            this.proxCard = _data["proxCard"] !== undefined ? _data["proxCard"] : <any>null;
            this.faceprint = _data["faceprint"] !== undefined ? _data["faceprint"] : <any>null;
            this.userPin = _data["userPin"] !== undefined ? _data["userPin"] : <any>null;
            this.fingerprintCard = _data["fingerprintCard"] !== undefined ? _data["fingerprintCard"] : <any>null;
            this.faceCard = _data["faceCard"] !== undefined ? _data["faceCard"] : <any>null;
        }
    }

    static fromJS(data: any): UserAuthentication {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthentication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fingerprint"] = this.fingerprint !== undefined ? this.fingerprint : <any>null;
        data["proxCard"] = this.proxCard !== undefined ? this.proxCard : <any>null;
        data["faceprint"] = this.faceprint !== undefined ? this.faceprint : <any>null;
        data["userPin"] = this.userPin !== undefined ? this.userPin : <any>null;
        data["fingerprintCard"] = this.fingerprintCard !== undefined ? this.fingerprintCard : <any>null;
        data["faceCard"] = this.faceCard !== undefined ? this.faceCard : <any>null;
        return data;
    }

    clone(): UserAuthentication {
        const json = this.toJSON();
        let result = new UserAuthentication();
        result.init(json);
        return result;
    }
}

export interface IUserAuthentication {
    /** Gets or Sets Fingerprint */
    fingerprint?: boolean;
    /** Gets or Sets ProxCard */
    proxCard?: boolean;
    /** Gets or Sets Faceprint */
    faceprint?: boolean;
    /** Gets or Sets UserPin */
    userPin?: boolean;
    /** Gets or Sets FingerprintCard */
    fingerprintCard?: boolean;
    /** Gets or Sets FaceCard */
    faceCard?: boolean;
}

export class UserResponse implements IUserResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Status */
    status?: UserStatus2;
    /** Gets or Sets FirstName */
    firstName!: string;
    /** Gets or Sets Surname */
    surname!: string;
    /** Gets or Sets EmailAddress */
    emailAddress?: string | null;
    /** Gets or Sets ContactNumber */
    contactNumber?: string | null;
    /** Gets or Sets EnrolmentCode */
    enrolmentCode?: string | null;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets Authentication */
    authentication?: UserAuthentication | null;
    /** Gets or Sets Badges */
    badges?: BadgeResponse[] | null;
    /** Gets or Sets ProfilePicture */
    profilePicture?: string | null;
    /** Gets or Sets UserTags */
    userTags?: UserTagResponse[] | null;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthentication(data.authentication) : <UserAuthentication>this.authentication;
            if (data.badges) {
                this.badges = [];
                for (let i = 0; i < data.badges.length; i++) {
                    let item = data.badges[i];
                    this.badges[i] = item && !(<any>item).toJSON ? new BadgeResponse(item) : <BadgeResponse>item;
                }
            }
            if (data.userTags) {
                this.userTags = [];
                for (let i = 0; i < data.userTags.length; i++) {
                    let item = data.userTags[i];
                    this.userTags[i] = item && !(<any>item).toJSON ? new UserTagResponse(item) : <UserTagResponse>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.businessAccountId = _data["businessAccountId"] !== undefined ? _data["businessAccountId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.enrolmentCode = _data["enrolmentCode"] !== undefined ? _data["enrolmentCode"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.authentication = _data["authentication"] ? UserAuthentication.fromJS(_data["authentication"]) : <any>null;
            if (Array.isArray(_data["badges"])) {
                this.badges = [] as any;
                for (let item of _data["badges"])
                    this.badges!.push(BadgeResponse.fromJS(item));
            }
            else {
                this.badges = <any>null;
            }
            this.profilePicture = _data["profilePicture"] !== undefined ? _data["profilePicture"] : <any>null;
            if (Array.isArray(_data["userTags"])) {
                this.userTags = [] as any;
                for (let item of _data["userTags"])
                    this.userTags!.push(UserTagResponse.fromJS(item));
            }
            else {
                this.userTags = <any>null;
            }
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["businessAccountId"] = this.businessAccountId !== undefined ? this.businessAccountId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["enrolmentCode"] = this.enrolmentCode !== undefined ? this.enrolmentCode : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        if (Array.isArray(this.badges)) {
            data["badges"] = [];
            for (let item of this.badges)
                data["badges"].push(item.toJSON());
        }
        data["profilePicture"] = this.profilePicture !== undefined ? this.profilePicture : <any>null;
        if (Array.isArray(this.userTags)) {
            data["userTags"] = [];
            for (let item of this.userTags)
                data["userTags"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserResponse {
        const json = this.toJSON();
        let result = new UserResponse();
        result.init(json);
        return result;
    }
}

export interface IUserResponse {
    /** Gets or Sets Id */
    id?: string;
    /** Gets or Sets BusinessAccountId */
    businessAccountId?: string;
    /** Gets or Sets Status */
    status?: UserStatus2;
    /** Gets or Sets FirstName */
    firstName: string;
    /** Gets or Sets Surname */
    surname: string;
    /** Gets or Sets EmailAddress */
    emailAddress?: string | null;
    /** Gets or Sets ContactNumber */
    contactNumber?: string | null;
    /** Gets or Sets EnrolmentCode */
    enrolmentCode?: string | null;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets Authentication */
    authentication?: IUserAuthentication | null;
    /** Gets or Sets Badges */
    badges?: IBadgeResponse[] | null;
    /** Gets or Sets ProfilePicture */
    profilePicture?: string | null;
    /** Gets or Sets UserTags */
    userTags?: IUserTagResponse[] | null;
}

/** Gets or Sets UserStatus */
export enum UserStatus2 {
    _0Enum = 0,
    _1Enum = 1,
    _2Enum = 2,
    _3Enum = 3,
    _4Enum = 4,
}

export class UserTagResponse implements IUserTagResponse {
    /** Gets or Sets Id */
    id!: string;
    /** Gets or Sets UserId */
    userId!: string;
    /** Gets or Sets TagId */
    tagId!: string;

    constructor(data?: IUserTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
        }
    }

    static fromJS(data: any): UserTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        return data;
    }

    clone(): UserTagResponse {
        const json = this.toJSON();
        let result = new UserTagResponse();
        result.init(json);
        return result;
    }
}

export interface IUserTagResponse {
    /** Gets or Sets Id */
    id: string;
    /** Gets or Sets UserId */
    userId: string;
    /** Gets or Sets TagId */
    tagId: string;
}

export class UserListResponse implements IUserListResponse {
    /** Gets or Sets MetaData */
    metaData?: UserListMetaDataResponse | null;
    /** Gets or Sets Users */
    users!: UserResponse[];

    constructor(data?: IUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.metaData = data.metaData && !(<any>data.metaData).toJSON ? new UserListMetaDataResponse(data.metaData) : <UserListMetaDataResponse>this.metaData;
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new UserResponse(item) : <UserResponse>item;
                }
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? UserListMetaDataResponse.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserResponse.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): UserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserListResponse {
        const json = this.toJSON();
        let result = new UserListResponse();
        result.init(json);
        return result;
    }
}

export interface IUserListResponse {
    /** Gets or Sets MetaData */
    metaData?: IUserListMetaDataResponse | null;
    /** Gets or Sets Users */
    users: IUserResponse[];
}

export class UserListMetaDataResponse implements IUserListMetaDataResponse {
    /** Gets or Sets New */
    new?: number;
    /** Gets or Sets Unenrolled */
    unenrolled?: number;
    /** Gets or Sets Active */
    active?: number;
    /** Gets or Sets Inactive */
    inactive?: number;
    /** Gets or Sets Filtered */
    filtered?: number;

    constructor(data?: IUserListMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.new = _data["new"] !== undefined ? _data["new"] : <any>null;
            this.unenrolled = _data["unenrolled"] !== undefined ? _data["unenrolled"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.inactive = _data["inactive"] !== undefined ? _data["inactive"] : <any>null;
            this.filtered = _data["filtered"] !== undefined ? _data["filtered"] : <any>null;
        }
    }

    static fromJS(data: any): UserListMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserListMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new"] = this.new !== undefined ? this.new : <any>null;
        data["unenrolled"] = this.unenrolled !== undefined ? this.unenrolled : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["inactive"] = this.inactive !== undefined ? this.inactive : <any>null;
        data["filtered"] = this.filtered !== undefined ? this.filtered : <any>null;
        return data;
    }

    clone(): UserListMetaDataResponse {
        const json = this.toJSON();
        let result = new UserListMetaDataResponse();
        result.init(json);
        return result;
    }
}

export interface IUserListMetaDataResponse {
    /** Gets or Sets New */
    new?: number;
    /** Gets or Sets Unenrolled */
    unenrolled?: number;
    /** Gets or Sets Active */
    active?: number;
    /** Gets or Sets Inactive */
    inactive?: number;
    /** Gets or Sets Filtered */
    filtered?: number;
}

export class UserModify implements IUserModify {
    /** Gets or Sets FirstName */
    firstName!: string;
    /** Gets or Sets Surname */
    surname!: string;
    /** Gets or Sets EmailAddress */
    emailAddress?: string | null;
    /** Gets or Sets ContactNumber */
    contactNumber?: string | null;
    /** Gets or Sets EnrolmentCode */
    enrolmentCode?: string | null;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets Authentication */
    authentication?: UserAuthentication | null;

    constructor(data?: IUserModify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authentication = data.authentication && !(<any>data.authentication).toJSON ? new UserAuthentication(data.authentication) : <UserAuthentication>this.authentication;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.enrolmentCode = _data["enrolmentCode"] !== undefined ? _data["enrolmentCode"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.externalReference = _data["externalReference"] !== undefined ? _data["externalReference"] : <any>null;
            this.authentication = _data["authentication"] ? UserAuthentication.fromJS(_data["authentication"]) : <any>null;
        }
    }

    static fromJS(data: any): UserModify {
        data = typeof data === 'object' ? data : {};
        let result = new UserModify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["enrolmentCode"] = this.enrolmentCode !== undefined ? this.enrolmentCode : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["externalReference"] = this.externalReference !== undefined ? this.externalReference : <any>null;
        data["authentication"] = this.authentication ? this.authentication.toJSON() : <any>null;
        return data;
    }

    clone(): UserModify {
        const json = this.toJSON();
        let result = new UserModify();
        result.init(json);
        return result;
    }
}

export interface IUserModify {
    /** Gets or Sets FirstName */
    firstName: string;
    /** Gets or Sets Surname */
    surname: string;
    /** Gets or Sets EmailAddress */
    emailAddress?: string | null;
    /** Gets or Sets ContactNumber */
    contactNumber?: string | null;
    /** Gets or Sets EnrolmentCode */
    enrolmentCode?: string | null;
    /** Gets or Sets StartDate */
    startDate?: Date;
    /** Gets or Sets EndDate */
    endDate?: Date | null;
    /** Gets or Sets ExternalReference */
    externalReference?: string | null;
    /** Gets or Sets Authentication */
    authentication?: IUserAuthentication | null;
}

export class UserTagCreate implements IUserTagCreate {
    /** Gets or Sets UserId */
    userId!: string;
    /** Gets or Sets TagId */
    tagId!: string;

    constructor(data?: IUserTagCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : <any>null;
        }
    }

    static fromJS(data: any): UserTagCreate {
        data = typeof data === 'object' ? data : {};
        let result = new UserTagCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["tagId"] = this.tagId !== undefined ? this.tagId : <any>null;
        return data;
    }

    clone(): UserTagCreate {
        const json = this.toJSON();
        let result = new UserTagCreate();
        result.init(json);
        return result;
    }
}

export interface IUserTagCreate {
    /** Gets or Sets UserId */
    userId: string;
    /** Gets or Sets TagId */
    tagId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}